export default {
    "corporate": "Chương trình của công ty",
    "onboarding": {
        "goal_desc": "Bạn sẽ giành được %{customPoints} khi theo dõi hoạt động của mình và được thưởng %{customPoints} khi hoàn thành mục tiêu. Hãy bắt đầu nào! Bạn có thể kích hoạt 3 mục tiêu cá nhân cùng một lúc.",
        "sample_task": {
            "modalActivityTitle": "3 lần hít thở sâu",
            "rewards_featured_title": "Nổi bật",
            "rewards_partners_title": "Đối tác",
            "header_description": "Bạn sẽ nhận được %{customPoints} khi theo dõi hoạt động và hoàn thành các nhiệm vụ, mục tiêu và thử thách.",
            "icon_text": "Nhấn vào {icon} để theo dõi hoạt động hít thở sâu.",
            "activityName": "hít thở sâu",
            "activityUnit": "thở"
        },
        "lets_get_started": "Hãy bắt đầu nào!",
        "start_description": "Bạn sẽ nhận được %{customPoints} khi theo dõi hoạt động và hoàn thành các nhiệm vụ, mục tiêu và thử thách.",
        "complete_and_earn": "Hoàn thành và nhận điểm",
        "did_it": "Tôi đã hoàn thành!",
        "task_complete": "Đã hoàn thành nhiệm vụ!",
        "breath_sample_task": "Hãy xem hướng dẫn nhanh về cách theo dõi hoạt động",
        "track_a_sample_activity": "Theo dõi hoạt động mẫu",
        "nice": "Tuyệt!",
        "nice_one": "Tuyệt vời!",
        "nice_subtext_1": "Bạn đã nhận được %{points} %{customPoints}.",
        "nice_subtext_2": "Khi nhận được %{customPoints}, bạn sẽ được lên cấp. Mỗi khi lên cấp, bạn sẽ nhận được %{reward_currency} và có thể đổi phần thưởng này lấy các ưu đãi hấp dẫn.",
        "nice_subtext_3": "Bạn sẽ nhận được nhiều điểm hơn khi hoàn thành nhiều nhiệm vụ hơn, theo dõi hoạt động cũng như hoàn thành các mục tiêu và thử thách.",
        "progress_subtitle": "%{customPoints} và tiến độ của bạn được đặt lại mỗi %{frequency}.",
        "skip_for_now": "Bỏ qua lúc này",
        "loadingText": "Vui lòng đợi trong khi chúng tôi tính toán điểm sức khỏe của bạn.",
        "goal_title": "Đặt mục tiêu riêng",
        "swipe_for_more": "Vuốt để xem thêm",
        "skip_goals": "Tôi hiện đã đặt xong mục tiêu.",
        "complete_profile": "",
        "level": "Cấp độ",
        "finish_onboarding_action": "Vui lòng hoàn thành việc làm quen trước",
        "vital_stats": {
            "height_ft": "Chiều cao (feet)",
            "height_in": "Chiều cao (inch)"
        },
        "rewards": "",
        "welcome": {
            "disclaimerTitle": "Quyền riêng tư của bạn là quan trọng"
        },
        "levels": {
            "title": "Thành tích và phần thưởng",
            "tableTitle": "Thành tích"
        },
        "initialScreen": {
            "title": "%{username}, chào mừng bạn đến với %{programName}!",
            "getRewarded": "Nhận phần thưởng %{rewardName}",
            "completeAgainst": "Cạnh tranh với đồng nghiệp của bạn",
            "earnPoints": "Nhận điểm thông qua các hoạt động chăm sóc sức khỏe",
            "levelUp": "Lên cấp và mở khóa huy hiệu"
        },
        "starterGoals": {
            "title": "Chọn mục tiêu",
            "subtitle": "Hãy bắt đầu hành trình sức khỏe của bạn bằng một thói quen lành mạnh mới."
        }
    },
    "healthkit_not_available": "Không thể kết nối với Apple Health. Trong ứng dụng Health, bên dưới mục Sources, hãy đảm bảo bạn đã bật quyền tối thiểu đối với các bước và đã theo dõi ít nhất 1 bước.",
    "changeCover": "Thay đổi ảnh",
    "joiningCommunityToast": {
        "success": {
            "message": "Bạn đã tham gia thành công %{name}",
            "title": "Tham gia cộng đồng"
        }
    },
    "achievement_starts_date": "Ngày bắt đầu: %{date}",
    "editChallenge": "Chỉnh sửa %{challengeName}",
    "createChallenge": {
        "activitiesOrCategory": {
            "subtitle": "Chọn tối đa 5 hoạt động",
            "title": "Bạn muốn làm gì?",
            "noActivityTitle": "Thêm hoạt động",
            "noActivityMessage": "Chọn ít nhất một hoạt động hoặc danh mục.",
            "categoryItemDescription": "Tất cả các hoạt động trong danh mục %{category}",
            "addActivityTitle": "Bạn muốn %{activity} bao nhiêu %{unit} mỗi %{period}?",
            "addCategoryQuantityTitle": "Bạn muốn giành được bao nhiêu %{customPoints} trong danh mục %{category}?",
            "subtitleCategories": "Chọn một danh mục. Tất cả các hoạt động từ danh mục đó sẽ đóng góp vào mục tiêu.",
            "subtitleWithActivities": "Đã chọn %{num}\/%{max} hoạt động",
            "selectCategoryMessage": "Tất cả các hoạt động trong danh mục sẽ được chọn và các hoạt động đã chọn trước đó sẽ bị loại bỏ.",
            "addActivityTitleTotal": "Bạn muốn %{activity} ở mức nào mỗi %{period}?"
        },
        "inviteDepartments": {
            "title": "Mời các phòng ban"
        },
        "inviteRegions": {
            "title": "Mời các khu vực"
        },
        "createInvitation": {
            "selectMore": "Vui lòng chọn ít nhất 2 %{entity}!"
        },
        "visibility": {
            "title": "Chế độ hiển thị",
            "description": "Tất cả người dùng %{programName} đều có thể tìm thấy và tham gia các thử thách nhóm."
        },
        "highest": {
            "name": "%{customPoints} cao nhất sẽ giành chiến thắng",
            "description": "Không có giới hạn, ai có %{customPoints} cao nhất sẽ giành vị trí số 1"
        },
        "compete": {
            "individual": "Hoàn thành với tư cách cá nhân",
            "team": "Hoàn thành với tư cách nhóm"
        },
        "unitType": {
            "title": "Chọn cách bạn hoàn thành mục tiêu của mình",
            "subtitle": "Chọn trong số các hoạt động hoặc trong một danh mục"
        },
        "category": {
            "name": "Tất cả các hoạt động trong một danh mục",
            "description": "Ví dụ: Theo dõi bất kỳ hoạt động nào trong mục \"Di chuyển\"",
            "title": "Chọn một danh mục",
            "subtitle": "Bạn sẽ theo dõi các hoạt động trong danh mục nào?"
        },
        "activities": {
            "name": "Các hoạt động đã chọn",
            "description": "Ví dụ: Theo dõi các hoạt động cụ thể như đạp xe",
            "title": "Chọn hoạt động",
            "subtitle": "Bạn nên tập trung vào một hoạt động nhưng có thể thêm tối đa 5 hoạt động",
            "maxModalTitle": "Đã chọn số hoạt động tối đa",
            "maxModalDescription": "Bạn có thể thêm tối đa 5 hoạt động. Nhấn vào Chấp nhận để tiếp tục với 5 hoạt động bạn đã chọn hoặc nhấn vào Chỉnh sửa để thay đổi.",
            "warningModalTitle": "Độ khó cao",
            "warningModalDescription": "Đối với mục tiêu này, bạn đã chỉ định nhiều hoạt động cần hoàn thành trong mỗi khoảng thời gian. Bạn có chắc chắn muốn đặt một mục tiêu đầy thách thức như vậy không?",
            "requiredPoints": "cần vượt qua %{period} %{challengeType}",
            "noActivitiesModalTitle": "Thêm hoạt động",
            "noActivitiesModalDescription": "Chọn ít nhất một hoạt động."
        },
        "categoryQuantity": {
            "title": "Đặt mục tiêu %{customPoints}",
            "subtitle": "Bạn muốn giành được bao nhiêu %{customPoints} từ %{category} mỗi %{period}?",
            "subtitleTotal": "Bạn muốn giành được bao nhiêu %{customPoints} từ %{category} mỗi %{period}?",
            "text": "Theo nguyên tắc, 30 phút hoạt động vừa phải bằng khoảng 105 %{customPoints}",
            "noQuantityModalTitle": "Số lượng",
            "noQuantityModalDescription": "Nhập một giá trị",
            "defaultCategoryTitle": "danh mục hiện tại"
        },
        "cancel": {
            "title": "Hủy quá trình tạo thử thách",
            "message": "Bạn có chắc chắn muốn hủy quá trình tạo thử thách không?"
        },
        "createNew": "Tạo thử thách mới",
        "chooseChallengeTitle": "Chọn một thử thách hoặc tạo thử thách của riêng bạn",
        "createOwn": {
            "title": "Tạo thử thách của riêng bạn"
        },
        "frequency": {
            "title": "Bạn đạt được mục tiêu của mình với tần suất thế nào?",
            "subtitle": "Những người có thói quen tốt sẽ đạt mục tiêu hàng ngày"
        },
        "startAndDuration": {
            "title": "Chọn ngày bắt đầu và khoảng thời gian",
            "subtitle": "",
            "noFieldsTitle": "Ngày bắt đầu và khoảng thời gian",
            "noFieldsMessage": "Vui lòng nhập ngày bắt đầu và khoảng thời gian"
        },
        "finalize": {
            "title": "Xem xét mục tiêu mới",
            "subtitle": "",
            "noFieldsTitle": "Tên và hướng dẫn",
            "noFieldsMessage": "Vui lòng nhập tên và hướng dẫn",
            "name": "Mục tiêu %{names} %{frequency} của tôi",
            "instructionCategory": "Nhận %{points} %{customPoints} %{frequency} từ tất cả các hoạt động %{category}",
            "instructionActivities": "Theo dõi %{items} %{frequency} để nhận được %{points} %{customPoints} %{pointsFrequency}",
            "instructionCompetitionCategory": "Đạt %{customPoints} cao nhất cho mọi hoạt động %{category} để chiến thắng cuộc thi này",
            "instructionCompetitionActivities": "Đạt %{customPoints} cao nhất cho %{items} để chiến thắng cuộc thi này",
            "namePlaceholder": "Đặt tên cho cuộc thi",
            "titleChallenge": "Hoàn thành thử thách của bạn"
        },
        "dailyDescription": "Ví dụ: Uống 8 cốc nước mỗi ngày",
        "weeklyDescription": "Ví dụ: Đi bộ 150 phút mỗi tuần",
        "monthlyDescription": "Ví dụ: Chạy 150 km mỗi tháng",
        "totalDescription": "Ví dụ: Đạp xe tổng cộng 10.000 km",
        "title": "Thử thách bản thân hay người khác?",
        "navigatorTitle": "Tạo thử thách",
        "me": {
            "name": "Chỉ mình tôi",
            "description": "Thử thách bản thân với mục tiêu cá nhân"
        },
        "others": {
            "name": "Cạnh tranh với những người khác",
            "description": "Cạnh tranh với tư cách cá nhân hoặc theo nhóm"
        },
        "one": {
            "name": "Cá nhân",
            "description": "Hoàn thành với tư cách cá nhân cùng những người dùng khác"
        },
        "team": {
            "name": "Với tư cách nhóm",
            "description": "Hoàn thành với tư cách nhóm cùng những nhóm khác"
        },
        "company": {
            "name": "Thử thách của công ty",
            "description": "Tạo cuộc thi đặc biệt"
        },
        "adminItemTitle": "Với tư cách là quản trị viên, bạn có thể tạo",
        "userOrTeamTitle": "Cạnh tranh với tư cách cá nhân hoặc theo nhóm?",
        "target": {
            "name": "Đặt mục tiêu cần hoàn thành",
            "description": "Thử thách có giới hạn trên"
        },
        "typeTitle": "Chọn loại %{challengeType}",
        "teamSizeTitle": "Chọn quy mô cho mỗi nhóm",
        "teamSizeSubtitle": "Quy mô tối thiểu của nhóm là %{min} và tối đa là %{max}. %{customPoints} của nhóm bạn là giá trị trung bình của tất cả thành viên trong nhóm và bạn chỉ giành được %{customPoints} khi nhóm của mình đáp ứng yêu cầu về số thành viên tối thiểu.",
        "teamSize": {
            "noFieldsTitle": "Tối thiểu và tối đa",
            "noFieldsMessage": "Chọn số lượng thành viên tối thiểu và tối đa của một nhóm"
        },
        "companyChallengeTitle": "Thử thách của công ty",
        "companyChallengeSubtitle": "Bạn là quản trị viên. Bạn có thể thiết lập thử thách phòng ban và các loại thử thách khác",
        "chooseDepartmentTitle": "Chọn các phòng ban để cạnh tranh",
        "chooseRegionTitle": "Chọn các khu vực để cạnh tranh",
        "goToChallenge": "Chuyển đến thử thách của tôi",
        "additional": {
            "title": "Đã tạo thử thách",
            "subtitle": "Hãy bắt đầu nào! Mời những người khác tham gia.",
            "makePublicName": "Đặt mục này ở chế độ công khai",
            "makePublicDescription": "Ai cũng có thể tham gia",
            "toDirectoryName": "Gửi đến Thư mục thử thách",
            "toDirectoryDescription": "Mọi người có thể tạo một mục tương tự",
            "inviteTitle": "Mời tham gia thách thức",
            "titleGoal": "Đã tạo mục tiêu!"
        },
        "quantityMinimum": {
            "message": "Số lượng yêu cầu tối thiểu là %{quantity}",
            "title": "Không đủ số lượng"
        },
        "toast": {
            "success": "%{challengeType} của bạn đã được tạo."
        },
        "goToGoal": "Chuyển đến mục tiêu của tôi",
        "navigatorTitleGoal": "Tạo mục tiêu",
        "quantityError": {
            "wholeNumber": "Phải là số nguyên",
            "greaterThanZero": "Phải lớn hơn 0"
        }
    },
    "wellbeing": {
        "description": {
            "overall": "Hệ thống sẽ tính toán điểm sức khỏe của bạn bằng cách so sánh các câu trả lời bạn đưa ra trong cuộc khảo sát sức khoẻ với câu trả lời của hàng triệu người khác ở cùng độ tuổi và có cùng giới tính với bạn. Điểm số cho biết thứ hạng của bạn so với họ. Điểm số sẽ tự động cập nhật mỗi tháng theo những thay đổi của bạn về thói quen vận động, ăn uống và tinh thần của bạn được nhập vào ứng dụng. Việc thiết lập mục tiêu nhất quán và thực hiện hành động tích cực để cải thiện sức khỏe có thể giúp tăng điểm số sức khỏe của bạn.",
            "excellent": "Điểm số sức khỏe của bạn cao hơn 85% so với những người ở cùng độ tuổi và có cùng giới tính với bạn. ",
            "very_good": "Điểm số sức khỏe của bạn cao hơn 70-84% so với những người ở cùng độ tuổi và có cùng giới tính với bạn.",
            "good": "Điểm số sức khỏe của bạn cao hơn 51-69% so với những người ở cùng độ tuổi và có cùng giới tính với bạn.",
            "fair": "Điểm số sức khỏe của bạn cao hơn 31-50% so với những người ở cùng độ tuổi và có cùng giới tính với bạn.",
            "poor": "Điểm số sức khỏe của bạn thấp hơn 70% so với những người ở cùng độ tuổi và có cùng giới tính với bạn. Việc ưu tiên cho vấn đề sức khỏe không bao giờ là quá muộn. Hãy tận dụng nền tảng của chúng tôi để giúp bạn tiến bộ trong hành trình chăm sóc sức khỏe của mình!",
            "overall_result": "Nhìn chung, điểm sức khỏe của bạn là %{status}.",
            "category_result": "Nhìn chung, điểm {category} của bạn là {string}.",
            "goals": "Bạn không thể giành chiến thắng nếu không có mục tiêu. Đặt ra 3 mục tiêu cá nhân và theo dõi các mục tiêu này. Theo thời gian, khi thay đổi lối sống, bạn sẽ thấy điểm số của mình tăng lên."
        },
        "reminder": {
            "title": "Đã đến lúc cập nhật bản khảo sát sức khỏe của bạn!",
            "updateAnswers": "Cập nhật câu trả lời của tôi"
        },
        "lastUpdated": "Lần cập nhật gần đây nhất: %{date}",
        "scoreDescription": {
            "part1": "Điểm",
            "part2": "của bạn",
            "belowAverage": "ở dưới mức trung bình",
            "aboveAverage": "ở trên mức trung bình",
            "part3": "cho những người khác ở cùng độ tuổi và có cùng giới tính với bạn."
        },
        "improveScore": {
            "description": "Hệ thống tính toán điểm của bạn dựa trên câu trả lời bạn đưa ra trong bản khảo sát sức khỏe và hoạt động bạn theo dõi. Bạn có thể cập nhật câu trả lời của mình trong bản khảo sát hoặc đặt mục tiêu mới để cải thiện.",
            "desc1": "Điểm của bạn không thể cao hơn được nữa! Để giúp cho các việc tập luyện hàng ngày trở nên thú vị, hãy thử thách bản thân với những mục tiêu vượt quá khả năng bình thường của bạn và mời những người khác cùng thi đấu để duy trì động lực.",
            "desc2": "Nếu bạn đã sẵn sàng tăng cấp, đã đến lúc tăng mức độ thử thách. Hãy thử thách bản thân với những mục tiêu vượt quá khả năng bình thường của bạn và mời những người khác cùng thi đấu để duy trì động lực.",
            "desc3": "Đặt các mục tiêu cá nhân và tạo ra những thử thách công khai để bạn có trách nhiệm và duy trì động lực. Hãy nhớ chọn các mục tiêu có thể đạt được và khung thời gian nhỏ hơn - chúng tôi khuyên bạn nên thực hiện 1 tuần.",
            "desc4": "Điều quan trọng là phải vận động mỗi ngày. Nếu bạn không có thói quen vận động nhiều hàng ngày, hãy bắt đầu với những mục tiêu nhỏ phù hợp với khả năng và sở thích của bạn. Hãy nhớ chọn các mục tiêu có thể đạt được và khung thời gian nhỏ hơn - chúng tôi khuyên bạn nên thực hiện 1 tuần."
        },
        "recommendedGoals": "Mục tiêu đề xuất",
        "recommendedDescription": {
            "desc1": "Bạn có thể thiết lập ",
            "desc2": "3 mục tiêu ",
            "desc3": "để tập trung cải thiện sức khỏe. Bạn hiện có "
        },
        "categoryScore": "Điểm %{category} của bạn là ",
        "learnMore": "Tìm hiểu thêm",
        "youAreSet": "Đã xong!",
        "goalSetting": "Đặt mục tiêu",
        "attention": "Không có điểm %{category}.",
        "move": {
            "error": "Dựa trên câu trả lời của bạn, hiện không có điểm di chuyển. "
        },
        "eat": {
            "error": "Bạn cho biết một chuyên gia chăm sóc sức khỏe đã kết luận bạn bị Tiểu đường Loại 2 và bệnh chưa được kiểm soát. "
        },
        "feel": {
            "error": "Dựa trên câu trả lời của bạn, hiện không có điểm tinh thần. "
        },
        "survey": {
            "requiredField": "* đây là trường bắt buộc"
        },
        "score_info_title": "Ý nghĩa của điểm số",
        "company_average_info": "Mức trung bình tại công ty của tôi",
        "demographic_average_info": "Mức trung bình trong nhóm nhân khẩu học của tôi",
        "score": "Điểm sức khỏe",
        "table": {
            "what_it_means": "Ý nghĩa",
            "score": "Điểm"
        },
        "updated": "Đã cập nhật",
        "label": {
            "excellent": "Xuất sắc",
            "very_good": "Rất tốt",
            "good": "Tốt",
            "fair": "Khá tốt",
            "poor": "Kém"
        },
        "activity": {
            "eat": "Hoạt động ăn uống 1, Hoạt động ăn uống 2, Hoạt động ăn uống 3",
            "move": "Hoạt động vận động 1, Hoạt động vận động 2, Hoạt động vận động 3",
            "feel": "Hoạt động tinh thần 1, Hoạt động tinh thần 2, Hoạt động tinh thần 3"
        },
        "score_info_screen": "Cách tính điểm của tôi",
        "details": "Chi tiết",
        "activities": "Hoạt động",
        "improveCategoryScore": "Cải thiện điểm %{category} của tôi",
        "meaning": {
            "heading": "Tính điểm"
        },
        "score_button": {
            "meaning": "Ý nghĩa của điểm này?"
        },
        "improve": "Xem các mục tiêu đề xuất",
        "score_text": {
            "demographic": "Điểm trung bình cho nhóm độ tuổi và giới tính của bạn là",
            "company": "và điểm trung bình tại công ty của bạn là"
        },
        "scoreHigher": "cao hơn mức trung bình",
        "scoreLower": "mức hơn mức trung bình",
        "settedGoals": {
            "noGoals": "Chưa đặt mục tiêu",
            "one": "Đã đặt 1 mục tiêu",
            "n": "Đã đặt %{count} mục tiêu"
        },
        "yourScoreIsPoor": "Điểm %{category} của bạn ở mức kém",
        "unlock": {
            "title": "Xem điểm sức khỏe của bạn",
            "description": "Hãy hoàn thành bảng câu hỏi ngắn để tìm hiểu xem sức khỏe tổng thể của bạn như thế nào so với những người khác có cùng thông tin nhân khẩu học với bạn."
        },
        "browseAndSet": "Bạn có thể duyệt tìm và đặt các mục tiêu mới sau khi các mục tiêu hiện tại của bạn đã hoàn thành.",
        "excellent": {
            "desc1": "Lối sống cực kỳ lành mạnh",
            "desc2": "Nguy cơ rất thấp đối với sức khỏe"
        },
        "veryGood": {
            "desc1": "Lối sống rất lành mạnh",
            "desc2": "Nguy cơ thấp đối với sức khỏe"
        },
        "good": {
            "desc1": "Lối sống lành mạnh",
            "desc2": "Nguy cơ trung bình đối với sức khỏe"
        },
        "fair": {
            "desc1": "Lối sống khá lành mạnh",
            "desc2": "Nguy cơ trên trung bình đối với sức khỏe"
        },
        "poor": {
            "desc1": "Nguy cơ cao đối với sức khỏe",
            "desc2": "Nên vận động nhiều hơn mỗi ngày",
            "desc3": "Cần vận động nhiều hơn mỗi ngày"
        },
        "calculateScore": {
            "description": "Khi bạn hoàn thành cuộc khảo sát về tình trạng sức khỏe, các câu trả lời của bạn sẽ được phân tích bằng cách sử dụng hàng tỷ biến dữ liệu từ những người có cùng độ tuổi và giới tính với bạn. Cách tính này cũng bao gồm hoạt động bạn theo dõi trong %{programName}.\n\nĐiểm sức khỏe của bạn được cập nhật thường xuyên để bạn có thể thấy điểm số này thay đổi theo thời gian."
        },
        "improveYourScore": "Cải thiện điểm số của bạn"
    },
    "challengerCount": "%{num} người thách đấu",
    "team_name": "Tên nhóm",
    "syncingDeviceToast": {
        "danger": {
            "message": "Rất tiếc… Chúng tôi đã gặp sự cố khi đồng bộ hóa %{name}. Vui lòng thử lại.",
            "title": "Đồng bộ hóa"
        },
        "success": {
            "title": "Đồng bộ hóa",
            "message": "Đã đồng bộ hóa thành công %{name}. Các hoạt động của bạn hiện đã được cập nhật."
        }
    },
    "allCompanyMembers": "Tất cả các thành viên của công ty",
    "allCompanyMembersTeam": "Tất cả các thành viên của công ty (Nhóm)",
    "successfullyRedeemedItemForConfirmation": "Bạn đã đổi thành công mặt hàng này và một email xác nhận đã được gửi đến %{email}.",
    "no_all_events_placeholder": "Có vẻ như hiện không có sự kiện nào để tham gia. Hãy tạo một sự kiện nào.",
    "confirmDeleteAccount": "Hãy xác nhận thao tác xóa bằng cách nhập địa chỉ email liên kết với tài khoản của bạn",
    "deleteAccount": "Xóa tài khoản",
    "linkAccounts": "Quản lý các tài khoản được liên kết",
    "titleSlug": {
        "icon_reward_text": "Các thành viên đủ điều kiện có thể dễ dàng giành được nhiều điểm hơn bằng cách mua sắm cùng các đối tác của chúng tôi hoặc đến gặp nha sĩ của Members’ Choice Advantage để thăm khám thông qua gói bảo hiểm bổ sung.",
        "icon_move_text": "Việc theo dõi các lựa chọn lành mạnh hàng ngày như ngủ ngon hơn hoặc ăn rau có thể giúp bạn giành được Điểm Live Better (Cải thiện sức khỏe).",
        "icon_redeem_text": "Live Better thưởng cho những thành viên của Medibank có tham gia bảo hiểm bệnh viện hoặc bổ sung để chăm sóc sức khỏe của họ. ",
        "icon_phone_text": "Hãy đăng ký và sẵn sàng đổi các phần thưởng, như thẻ quà tặng sức khỏe và tinh thần hoặc tiết kiệm tiền nhờ bảo hiểm sức khỏe. ",
        "wellness": "Chào mừng bạn đến với thế giới của sự khỏe mạnh",
        "goals": "Đạt được mục tiêu của bạn",
        "devices": "Đi đúng hướng",
        "challenges": "Tạo thử thách",
        "celebrate": "Sức khỏe xã hội",
        "habits": "Xây dựng thói quen lành mạnh",
        "joinChallenge": "Tham gia thử thách",
        "getSocial": "Hòa nhập cộng đồng",
        "reward": "Nhận phần thưởng để sống lành mạnh hơn.",
        "move": "Vận động, ăn uống lành mạnh và sống lạc quan hơn.",
        "phone": "Sống lành mạnh, nghĩ lạc quan."
    },
    "viewProgress": {
        "goal": "Xem tiến độ hoàn thành mục tiêu",
        "challenge": "Xem tiến độ hoàn thành thử thách",
        "progress": "Xem tiến độ"
    },
    "vitalStats": {
        "disclaimer": {
            "message": "Việc nhập thông tin này là không bắt buộc, vì lợi ích của chính bạn và đảm bảo quyền riêng tư cho bạn."
        }
    },
    "eventBonusPoints": {
        "section": {
            "title": "Tham gia sự kiện này để được thưởng %{potentialBonusPoints} %{customPoints}!"
        },
        "modal": {
            "paragraph1": "Khi tham gia sự kiện này, bạn sẽ được thưởng %{pointsName}.",
            "paragraph2": "Bạn sẽ được thưởng toàn bộ %{pointsName} sau khi hoàn tất sự kiện. Bạn sẽ không nhận được tín dụng thưởng đối với những sự kiện mình không tham gia."
        }
    },
    "EAP": {
        "contactInfo": "Thông tin liên hệ",
        "doLater": "Thực hiện sau",
        "tellMore": "Tìm hiểu thêm",
        "contactMe": "Liên hệ với tôi",
        "title": "Chương trình hỗ trợ nhân viên và gia đình",
        "reachGoal": {
            "title": "Chúng tôi luôn sẵn sàng trợ giúp",
            "description": "Chương trình hỗ trợ nhân viên và gia đình (EFAP), do %{providerName} cung cấp, mang đến nhiều dịch vụ đào tạo để giúp bạn đạt được mục tiêu về sức khỏe.\n\nBạn có muốn nhận thêm thông tin từ %{providerName} không?"
        },
        "privacyPolicy": "Chính sách về quyền riêng tư của %{provider}"
    },
    "HRIS": {
        "disclaimer": "Một số trường được cập nhật tự động và không thể thay đổi."
    },
    "settingGoals": {
        "description": "Việc tập trung vào 3 mục tiêu được đề xuất cùng một lúc sẽ tăng khả năng thành công.",
        "title": {
            "one": "Bạn đã đặt 1 mục tiêu"
        }
    },
    "auth": {
        "linkAccount": {
            "alreadyLinkedToUser": "Tài khoản đã được liên kết với một người dùng khác",
            "lastAccountMessage": "Bạn có chắc chắn muốn xóa tài khoản được liên kết gần đây nhất không? Sau khi xóa, bạn phải đăng nhập bằng địa chỉ email %{email} và mật khẩu mới.",
            "unlinkCorpAccountMessage": "Bạn có chắc chắn muốn xóa tài khoản được liên kết của công ty bạn không? Sau khi xóa, bạn phải đăng nhập lại bằng địa chỉ email %{email}.",
            "alreadyLinked": "Đã liên kết tài khoản",
            "unlinkMessage": "Bạn có chắc chắn muốn xóa tài khoản được liên kết không?"
        },
        "sso": {
            "emailNotVerified": "Email của bạn chưa được xác minh."
        },
        "signIn": {
            "dontHaveAccount": "Bạn không có tài khoản?",
            "enterPIN": "Nhập Số nhận dạng chương trình của công ty",
            "dontKnowPIN": "Bạn không biết mã PIN?",
            "pin": "Mã PIN",
            "register": "Đăng ký",
            "pinDescription": "Liên hệ với quản trị viên chương trình nếu bạn không biết chắc Mã số nhận dạng chương trình (PIN) duy nhất của tổ chức. Nếu bạn có mã PIN và gặp khó khăn khi thực hiện bước tiếp theo, hãy liên hệ theo địa chỉ support@sproutatwork.com.",
            "keepMeTooltip": "Để thuận tiện cho bạn, khi hộp này được chọn, phiên của bạn sẽ vẫn có hiệu lực trong 30 ngày. Trên các thiết bị dùng chung, bạn nên bỏ chọn hộp này và đăng xuất khi hoàn tất."
        },
        "signUp": {
            "backToLogin": "Quay lại phần đăng nhập",
            "termsOfService": "Điều khoản dịch vụ",
            "privacyPolicy": "Chính sách quyền riêng tư"
        },
        "createYourAccount": "Tạo tài khoản của bạn",
        "setYourDetails": "Ghi thông tin chi tiết về bạn",
        "ModaHybridLogin": {
            "noAccessDashboard": "Bạn không có quyền truy cập vào Bảng điều khiển thành viên?",
            "signUpSSOButton": "Đăng ký qua Moda Member Dashboard",
            "noAccessDashboardWeb": "Nếu bạn không có quyền truy cập vào Bảng điều khiển thành viên, hãy đăng nhập bằng email và mật khẩu bên dưới.",
            "loginSSOButton": "Đăng nhập qua Moda Member Dashboard"
        }
    },
    "entityHasBeenDeleted": "Đã xóa %{name}",
    "track_challenge": {
        "message": {
            "manually": "Theo dõi thủ công",
            "automatically": "Đã tự động theo dõi bằng %{appOrDeviceName}",
            "manuallyOrConnect": "Theo dõi thủ công hoặc kết nối một ứng dụng hoặc thiết bị",
            "manuallyAndBy": "Theo dõi thủ công và tự động bằng %{appOrDeviceName}",
            "reconnectDevice": "Cần có thiết bị. Vui lòng kết nối lại thiết bị của bạn",
            "manualAndAuto": "Theo dõi thủ công và tự động",
            "trackedAutomatically": "Theo dõi tự động"
        }
    },
    "signUpPartnerSSOToast": {
        "danger": {
            "title": "Không thể đăng ký",
            "message": "Không thể truy xuất thông tin người dùng từ đối tác. Vui lòng thử lại sau"
        }
    },
    "app_device_required": {
        "disclaimer": {
            "title": "Cần có một ứng dụng hoặc thiết bị để thực hiện %{goalName} này.",
            "subTitle": "Vui lòng kết nối một ứng dụng hoặc thiết bị"
        }
    },
    "descriptionSlug": {
        "wellness": "Tham gia cộng đồng sức khỏe để đặt mục tiêu, kết nối và đi đúng hướng.",
        "goals": "Hãy cho chúng tôi biết bạn đang hướng tới mục tiêu gì.  Chúng tôi sẽ giúp bạn đạt được điều đó thông qua các mục tiêu được đề xuất.",
        "devices": "Đồng bộ hóa thiết bị thể dục hoặc ghi nhật ký các hoạt động của bạn và giữ cho các mục tiêu sức khỏe của bạn đi đúng hướng.",
        "challenges": "Tổ chức cuộc thi thân thiện.  Tạo một thử thách và mời những người khác tham gia cuộc vui.",
        "celebrate": "Luôn kết nối với đồng nghiệp và cùng nhau chúc mừng những thành công bạn đạt được.",
        "habits": "Theo dõi các hoạt động chăm sóc sức khỏe để giành điểm. Liên kết với điện thoại hoặc thiết bị đeo của bạn để giành điểm nhanh hơn.",
        "joinChallenge": "Xem cách bạn so tài với đồng nghiệp của mình trong các cuộc thi đấu thân thiện.",
        "getSocial": "Luôn kết nối với đồng nghiệp và cùng nhau chúc mừng những thành công bạn đạt được.",
        "reward_text": "Nhận điểm khi hoàn thành các hoạt động hàng ngày và thử thách cá nhân.",
        "move_text": "Cho dù là dạo quanh khu phố, dành 5 phút tĩnh tâm hay ăn uống lành mạnh trong nhiều ngày, bạn đều sẽ được thưởng.",
        "phone_text": "Sử dụng điểm của bạn để được giảm giá theo chương trình bảo hiểm hoặc ưu đãi hấp dẫn, tùy bạn chọn.",
        "none": ""
    },
    "core": {
        "featureNotEnabled": "Chưa bật tính năng",
        "checkAppVersion": {
            "message": "Có vẻ như ứng dụng của bạn đã lỗi thời. Vui lòng cài đặt bản cập nhật mới nhất.",
            "button": "Cập nhật %{appName}"
        },
        "noConnection": {
            "title": "Không có kết nối mạng",
            "description": "Có vẻ như bạn chưa có kết nối Internet. Bạn sẽ không thể dùng trọn vẹn ứng dụng nếu không có kết nối.",
            "button": "Thử lại"
        },
        "uploadPhotoText": "Thêm ảnh cho %{entityType} của bạn",
        "entities": {
            "community": "cộng đồng",
            "event": "sự kiện",
            "team": "nhóm",
            "goal": "mục tiêu",
            "challenge": "thử thách",
            "competition": "cuộc thi"
        }
    },
    "registration": {
        "login": {
            "errorHeading": "Không thể đăng nhập",
            "resetPasswordHeading": "Cần đặt lại mật khẩu"
        },
        "signup": {
            "corporateOrOther": "Bạn không phải là thành viên Medibank? Hay tham gia chương trình của công ty?",
            "sign_up_here": "Đăng ký tại đây ",
            "errorHeading": "Không thể đăng ký",
            "areYouMedibankMember": "Bạn là thành viên của Medibank?",
            "isMedibankMember": "Tôi là thành viên",
            "isNotMedibankMember": "Tôi không phải là thành viên"
        },
        "bpidExists": "Email được cung cấp đã được liên kết với một người dùng có lối sống tốt hơn. Email phải là duy nhất.",
        "generalError": "Dịch vụ hiện không dùng được"
    },
    "rewardsNoAvailableProducts": "Hiện không có sản phẩm nào.",
    "endedGoal": {
        "timeToTrack": {
            "yes": "Bạn vẫn có thời gian để theo dõi!",
            "no": "%{type} của bạn đã kết thúc"
        },
        "grace": "%{type} của bạn có thể đã kết thúc nhưng bạn có %{n} %{text} để theo dõi bất kỳ hoạt động nào bỏ quên",
        "notGrace": {
            "goal": "Chúc mừng bạn đã hoàn thành mục tiêu! Hãy tiếp tục công việc tuyệt vời bằng cách đặt mục tiêu mới để duy trì tình trạng sức khỏe của bạn.",
            "competition": "Chúc mừng bạn đã hoàn thành thử thách! Duy trì động lực của bạn bằng cách tham gia một thử thách khác hoặc tạo ra thử thách của riêng bạn."
        }
    },
    "appDeviceModal": {
        "defaultMessage": "Kết nối thiết bị hoặc ứng dụng của bạn và sử dụng tính năng theo dõi một cách liền mạch. Khi bạn xác thực, đối tác công nghệ của chúng tôi \"Sprout\" có thể chuyển dữ liệu của bạn một cách an toàn từ tài khoản %{appDeviceTitle}."
    },
    "noTransactionsMessage": "Có vẻ như bạn chưa thực hiện bất kỳ giao dịch nào.",
    "noRedemptionsMessage": "Có vẻ như bạn chưa đổi thưởng.",
    "challengeCarousel": {
        "emptyChallenge": {
            "subtitle": "Bạn có thể cạnh tranh trong các cuộc thi với tư cách cá nhân hoặc theo nhóm",
            "prompt": "Không có thử thách nào để tham gia ngay bây giờ. Hãy tạo một thử thách nhé."
        },
        "createChallengeButton": "Tạo thử thách"
    },
    "eventCarousel": {
        "emptyEvents": {
            "subtitle": "Sự kiện có thể chỉ dành cho người được mời hoặc cho tất cả mọi người.",
            "button": "Tạo sự kiện"
        },
        "emptyEventsMessage": "Không có sự kiện nào để tham gia ngay bây giờ. Hãy tạo một thử thách nhé."
    },
    "appnameLiveBetter": "Live Better",
    "appnameTelus": "Sức khỏe",
    "appnameUPnGo": "UPnGO",
    "personal_goal": {
        "carousel": {
            "headingNoSet": "Bạn chưa đặt mục tiêu!",
            "descriptionNoSet": "Hãy đặt một số mục tiêu để cải thiện điểm sức khỏe. Bắt đầu nhanh chóng với mục tiêu được đề xuất, chọn trong danh mục hoặc tạo mục tiêu của riêng bạn.",
            "descriptionSet": "Bạn có thể chọn một trong những mục tiêu mà chúng tôi đề xuất riêng cho bạn, duyệt qua danh mục hoàn chỉnh hoặc tạo mục tiêu của riêng bạn.",
            "action_text": "Đặt mục tiêu mới",
            "heading_singular": "Bạn có thể đặt thêm 1 mục tiêu",
            "heading_plural": "Bạn có thể đặt thêm %{number} mục tiêu"
        },
        "heading": "Các mục tiêu cá nhân",
        "single": "Mục tiêu cá nhân"
    },
    "settingGoal": {
        "yourGoal": "%{units} của bạn",
        "yourGoalDescription": "Bạn đang trên hành trình của mình! %{units} sau đây sẽ được thiết lập và sẽ bắt đầu ngay.",
        "selectedGoals": "Các mục tiêu đã chọn",
        "recommendedDescription": {
            "maximumSet": "Bạn đã đặt số mục tiêu tối đa. Bạn có thể duyệt và đặt các mục tiêu mới sau khi hoàn thành các mục tiêu hiện tại.",
            "maximumSetTitle": "Bạn đã đặt %{count} mục tiêu"
        }
    },
    "activityLogRemoved": {
        "single": {
            "success": "Hoạt động này đã bị xóa",
            "info": "Đã xảy ra lỗi. Vui lòng thử lại.",
            "danger": "Đã xảy ra lỗi. Vui lòng thử lại."
        },
        "plural": {
            "success": "Các hoạt động đã bị xóa",
            "info": "Đã xảy ra lỗi. Vui lòng thử lại.",
            "danger": "Đã xảy ra lỗi. Vui lòng thử lại."
        },
        "success": "Hoạt động này đã bị xóa",
        "info": "Hoạt động chưa bị xóa. Vui lòng thử lại.",
        "danger": "Hoạt động chưa bị xóa. Vui lòng thử lại."
    },
    "participants": "Người tham gia",
    "members": "Thành viên",
    "timeSittingInformationOld": "Nguyên tắc khuyến nghị:\n- Giảm thiểu lượng thời gian ngồi lâu.\n- Hạn chế ngồi lâu càng thường xuyên càng tốt.",
    "timeSittingInformation": {
        "title": "Nguyên tắc khuyến nghị:",
        "list": "- Giảm thiểu lượng thời gian ngồi lâu.\n- Hạn chế ngồi lâu càng thường xuyên càng tốt."
    },
    "activityLevelInformationOld": "Nguyên tắc khuyến nghị:\n- Vận động vào hầu hết, tốt nhất là tất cả các ngày trong tuần.\n- Tích lũy hơn 150 phút hoạt động thể chất với cường độ vừa phải mỗi tuần.\n- Thực hiện các hoạt động tăng cường cơ bắp ít nhất 2 ngày mỗi tuần.",
    "activityLevelInformation": {
        "title": "Nguyên tắc khuyến nghị:",
        "list": "- Vận động vào hầu hết, tốt nhất là tất cả các ngày trong tuần.\n- Tích lũy hơn 150 phút hoạt động thể chất với cường độ vừa phải mỗi tuần.\n- Thực hiện các hoạt động tăng cường cơ bắp ít nhất 2 ngày mỗi tuần."
    },
    "viewGuidelines": "Xem nguyên tắc",
    "corporateAccountLink": {
        "verification": {
            "title": "Xác minh địa chỉ email cơ quan của bạn",
            "description": "Bạn cần xác minh địa chỉ email cơ quan của mình để hoàn tất thành công quá trình liên kết. Vui lòng làm theo hướng dẫn được gửi tới:"
        }
    },
    "invitation": {
        "findFriendsAndFamily": "Tìm bạn bè và gia đình",
        "findFriends&Family": "Tìm bạn bè và gia đình",
        "tapToAddFriendsAndFamily": "Nhấn để thêm vào danh sách bạn bè và gia đình",
        "addedFriendsAndFamily": "Đã thêm vào danh sách bạn bè và gia đình",
        "whoYouAreLookingFor": "Bạn không tìm được người mình muốn ư?",
        "inviteWithEmail": "Mời qua email",
        "sentInvitations": "Đã gửi lời mời",
        "foundPerson": "Chúng tôi tìm thấy người này có email trùng khớp",
        "youAreBoth": "Cả 2 bạn đều thuộc %{entityName}",
        "youAreBothMore": "Cả 2 bạn đều thuộc %{entityName} và %{n} nhóm khác",
        "noFriendsAndFamilyAdded": "Có vẻ như bạn chưa thêm bạn bè hoặc gia đình.",
        "sendInvitation": "Gửi lời mời",
        "youHaveNoSentInvitations": "Bạn chưa gửi bất kỳ lời mời nào",
        "toast": {
            "success_title": "Đã gửi lời mời",
            "success_description": "%{invite_email} sẽ thấy lời mời trong hộp thư đến của họ",
            "danger_title": "Không gửi được lời mời",
            "danger_description": "Vui lòng thử lại sau"
        },
        "email": {
            "invalid_email": "Vui lòng nhập một địa chỉ email hợp lệ"
        },
        "inviteOthers": "Mời người khác",
        "searchForSomeone": "Tìm kiếm ai đó",
        "searchForOthersToInvite": "Tìm kiếm những người khác để mời",
        "programNameOnly": {
            "title": "Chỉ %{programName}",
            "description": "%{entityType} chỉ dành cho những ai tham gia %{programName}"
        },
        "domainCannotBeUsed": "Không thể dùng miền này với %{programName}",
        "actionSearchByEmail": "Mời qua email nếu bạn không tìm thấy người mình muốn",
        "send": "Gửi",
        "addEmailToList": "Thêm email vào danh sách",
        "toBeSent": "Đã gửi các lời mời",
        "noInvitationsToBeSent": "Không có lời mời nào",
        "removeEmailConfirmation": "Bạn có chắc chắn muốn xóa email này khỏi danh sách không?",
        "yes": "Có",
        "no": "Không",
        "foundByEmail": "Chúng tôi tìm thấy người này có email trùng khớp",
        "addToFriendsAndFamily": "Thêm vào danh sách bạn bè và gia đình",
        "alreadyAddedEmail": "Bạn đã thêm email này vào danh sách"
    },
    "pointsCurrencyAdditionalInfo": "%{points_name} và các cấp độ của bạn bắt đầu làm mới mỗi %{period}. Tất cả các hoạt động bạn theo dõi đều đóng góp vào mức tổng thể của bạn trong khoảng thời gian này.",
    "rankLabel": "Thứ hạng",
    "leaderboards": {
        "loadingLabel": "Đang tải bảng xếp hạng... Quá trình này có thể mất vài phút - có vẻ như mọi người đang hoạt động ngoài trời!"
    },
    "feeds": {
        "emptyListHomePage": "Không có bài viết nào để hiển thị. Hãy thử điều chỉnh luồng để hiển thị nhiều bài viết hơn.",
        "viewingPostsFrom": "Xem các bài viết của",
        "postActivity": "Thêm một bình luận hoặc hình ảnh về các hoạt động của bạn!",
        "indicatorLoader": {
            "defaultTitle": "Đang làm mới...",
            "successfulLoadedTitle": "Đã đồng bộ hóa & làm mới..."
        },
        "inapropriateTextError": {
            "message": "Nội dung trong tin nhắn của bạn có thể không phù hợp. Hãy cố gắng sử dụng ngôn ngữ thân thiện hơn."
        },
        "postImageError": {
            "title": "Rất tiếc, chúng tôi không thể đăng nội dung này",
            "message": "Hình ảnh bạn đã thêm có thể không phù hợp. Vui lòng thử hình ảnh khác."
        }
    },
    "syncModal": {
        "connect": {
            "title": "Đang kết nối %{name}",
            "description": "Để kết nối dữ liệu %{name} với tài khoản của bạn, hãy hoàn thành các bước sau:",
            "firstStep": "Tải xuống và cài đặt ứng dụng %{appName} dành cho di động từ %{storeName}",
            "fourthStep": "Chọn để kết nối với %{name}",
            "fifthStep": "Khi được nhắc, hãy chọn các chỉ số sức khỏe để đồng bộ hóa với %{appName} và nhấn vào \"Hoàn tất\"",
            "additionalInfo": "Xin lưu ý rằng để kích hoạt quá trình đồng bộ hóa từ ứng dụng Health, bạn phải mở %{appName}. Mặc dù bạn không cần mở ứng dụng, nhưng có thể mất một giờ để quá trình đồng bộ hóa hoàn tất và xuất hiện trong nhật ký hoạt động của bạn."
        },
        "title": "Đang đồng bộ hóa %{name}",
        "description": "Để đồng bộ hóa dữ liệu %{name} với tài khoản của bạn, hãy hoàn thành các bước sau:",
        "steps": {
            "one": "Đăng nhập vào ứng dụng %{appName} trên điện thoại",
            "two": "Mở phần Ứng dụng & thiết bị trong hồ sơ của bạn",
            "three": "Nhấn nút đồng bộ hóa bên cạnh %{name}",
            "iPhone": "Đăng nhập vào ứng dụng %{appName} trên iPhone"
        }
    },
    "accountLinkingToast": {
        "success": {
            "title": "Tài khoản công việc",
            "message": "Đã kết nối thành công tài khoản"
        },
        "danger": {
            "message": "Lỗi khi kết nối tài khoản"
        },
        "conflict": {
            "message": "Tài khoản đã được liên kết với một người dùng khác"
        }
    },
    "accountUnlinkingToast": {
        "success": {
            "title": "Tài khoản công việc",
            "message": "Đã ngắt kết nối thành công tài khoản"
        },
        "danger": {
            "title": "Liên kết các tài khoản",
            "message": "Lỗi khi ngắt kết nối tài khoản"
        }
    },
    "earnMoreWithPartners": "Giành nhiều điểm hơn nhờ đối tác",
    "connectPartnersToEarnByShopping": "Kết nối tài khoản và giành thêm %{unit_type} bằng cách mua sắm cùng đối tác %{program_name}.",
    "viewAllPartners": "Xem tất cả các đối tác",
    "myPartnerMemberships": "Tư cách thành viên đối tác của tôi",
    "linkAccount": "Liên kết thành viên",
    "linkToPartner": "Liên kết với đối tác",
    "linkingError": "Đã xảy ra lỗi khi liên kết tài khoản của bạn. Vui lòng thử lại.",
    "linkPending": "Đang chờ liên kết",
    "unlinkAccount": "Hủy liên kết tài khoản",
    "linkedToPartnerName": "Đã liên kết với %{partner_name}",
    "linked": "Đã liên kết",
    "permission": {
        "facebookTitle": "Đăng ký bằng Facebook",
        "googleTitle": "Đăng ký bằng Google",
        "facebookDescription": "Khi đăng ký bằng Facebook, bạn cần cấp quyền để đối tác công nghệ của chúng tôi \"Sprout\" xem được danh tính của bạn và tạo tài khoản %{programName}.",
        "googleDescription": "Khi đăng ký bằng Google, bạn cần cấp quyền để đối tác công nghệ của chúng tôi \"Sprout\" xem được danh tính của bạn và tạo tài khoản %{programName}.",
        "camera": {
            "title": "Quyền dùng máy ảnh",
            "description": "Cần quyền dùng máy ảnh để chụp ảnh. Trong phần cài đặt iPhone, hãy nhấn vào %{appName} và bật Máy ảnh.\n\nXin lưu ý rằng bạn có thể mất mọi thay đổi chưa lưu."
        },
        "notNow": "Lúc khác",
        "openSettings": "Mở phần Cài đặt",
        "photos": {
            "title": "Vui lòng cho phép truy cập ảnh",
            "description": "Khi đó, bạn có thể chia sẻ ảnh từ thư viện và lưu ảnh vào thư viện ảnh. Trong phần cài đặt iPhone, hãy nhấn vào %{appName} và chuyển Ảnh sang chế độ Đọc và ghi.\n\nXin lưu ý rằng bạn có thể mất mọi thay đổi chưa lưu."
        }
    },
    "firstNameContainsSpecialChar": "Tên của bạn chỉ được chứa các chữ cái tiếng Anh, dấu gạch ngang - và dấu nháy đơn",
    "lastNameContainsSpecialChar": "Họ của bạn chỉ được chứa các chữ cái tiếng Anh, dấu gạch ngang - và dấu nháy đơn",
    "goToPartnerSite": "Truy cập vào trang web của đối tác",
    "noPartnersFound": "Không tìm thấy đối tác",
    "noLinkedPartners": "Không có đối tác được liên kết",
    "noPartnersInCategory": "Không có đối tác trong danh mục",
    "partnerAccountPendingVerification": "Đang chờ xác minh tài khoản",
    "shopWithPartner": "Mua sắm cùng đối tác",
    "shopWithPartnerName": "Mua sắm cùng %{partner_name}",
    "linkToPartnerName": "Liên kết với %{partner_name}",
    "earnPartnerMembershipIdentifier": "Thông tin nhận dạng của thành viên",
    "earnPartnerAccountPendingAddLink": "Tư cách thành viên của bạn đang được liên kết và quá trình này có thể mất vài ngày để hoàn thành.",
    "earnPartnerAccountPendingRemoveLink": "Tư cách thành viên của bạn đang bị hủy liên kết và quá trình này có thể mất vài ngày để hoàn thành.",
    "linkStatusUpdating": "Cập nhật trạng thái liên kết",
    "activityTracking": {
        "firstActivityModal": {
            "description1": "Chúc mừng bạn đã thêm các hoạt động đầu tiên của mình! \n\nNếu muốn, bạn có thể thêm nhiều hoạt động hơn cho ngày hôm nay và những ngày khác. Khi hoàn thành các hoạt động hôm nay, hãy nhấn",
            "description2": "trên màn hình tiếp theo khi bạn không cần theo dõi hoạt động nào nữa."
        },
        "listTitle": "Các hoạt động được theo dõi vào",
        "dots": {
            "tracked": "Các hoạt động được theo dõi vào ngày này",
            "added": "Các hoạt động đã được thêm và đang chờ gửi"
        },
        "trackedActivitiesFor": "Đã theo dõi hoạt động cho %{date}",
        "activityTracking": "Theo dõi hoạt động",
        "addedPending": "Đã thêm (đang chờ gửi)",
        "search": {
            "description1": "Nhấn",
            "description2": "để xem các hoạt động có sẵn hoặc tìm kiếm một hoạt động cụ thể"
        },
        "addActivity": "Thêm hoạt động",
        "addAnotherActivity": "Thêm hoạt động khác"
    },
    "rewardsBalance": "Số dư %{currencyName}: %{points}",
    "membershipIdentifierRequiredError": "Cần cung cấp thông tin nhận dạng thành viên của bạn để liên kết",
    "incorrectValueInRange": "Vui lòng nhập một giá trị trong khoảng từ %{min} đến %{max}",
    "joinTeam": {
        "title": "Tham gia nhóm",
        "createInsteadText": "Tham gia hoặc tạo một nhóm để tham gia thử thách này"
    },
    "teamRank": "Thứ hạng của nhóm",
    "teamScore": "Điểm của nhóm",
    "appsDevices": {
        "infoText": "Bạn sẽ được yêu cầu cho phép đối tác công nghệ của chúng tôi Sprout Wellness Solutions, Inc. truy cập vào dữ liệu sức khỏe của bạn khi thêm ứng dụng hoặc thiết bị.",
        "connectModal": {
            "title": "Ủy quyền",
            "paragraph1Part1": "Bạn sẽ được yêu cầu ủy quyền cho đối tác công nghệ của chúng tôi",
            "paragraph1Part2": "Sprout Wellness Solutions, Inc.",
            "paragraph1Part3": "truy cập vào dữ liệu sức khỏe của bạn.",
            "paragraph2Desc1": "Khi đó,",
            "paragraph2Desc2": "Sprout",
            "paragraph2Desc3": "có thể đồng bộ hóa dữ liệu của bạn",
            "paragraph2Desc4": "một cách an toàn",
            "paragraph2Desc5": "và bạn có thể giành được thêm %{pointsName}!"
        },
        "statusAlert": {
            "connectMessage": "Kết nối một ứng dụng hoặc thiết bị theo dõi hoạt động để đồng bộ hóa và theo dõi hoạt động một cách dễ dàng",
            "connectAction": "Kết nối một ứng dụng hoặc thiết bị",
            "errorMessage": "Một số ứng dụng hoặc thiết bị đã kết nối của bạn không thể đồng bộ hóa",
            "warningMessage": "Một số ứng dụng hoặc thiết bị được kết nối của bạn có thể gặp sự cố kết nối",
            "errorAction": "Sửa lỗi này",
            "warningAction": "Khắc phục cảnh báo này",
            "syncingError": "Lỗi đồng bộ hóa",
            "syncingIssue": "Sự cố đồng bộ hóa"
        },
        "deviceDetails": {
            "warningMessage": "Ứng dụng hoặc thiết bị này gặp sự cố khi đồng bộ hóa",
            "errorMessage": "Ứng dụng hoặc thiết bị này không thể đồng bộ hóa",
            "warningAction": "Đóng cảnh báo",
            "noActivities": "Không có hoạt động nào trên %{deviceName} được đồng bộ hóa với %{programName} trong 7 ngày qua. \n\nCó thể mất đến một giờ để các hoạt động hiển thị ở đây sau khi chúng được theo dõi bằng %{deviceName}.\n\nNếu ứng dụng hoặc thiết bị khác mà bạn kết nối đã theo dõi các bước khác, bạn sẽ thấy hoạt động ở đó. Nếu không, hãy thử ngắt kết nối và kết nối lại %{deviceName}. Nếu bạn được yêu cầu xác thực hoặc cấp quyền, hãy nhớ bật dữ liệu hoạt động và xác thực bằng tài khoản dùng để theo dõi hoạt động. Xem các bước khắc phục sự cố để biết thêm thông tin.  "
        },
        "troubleshooting": "Khắc phục sự cố",
        "deviceItem": {
            "error": "Lỗi kết nối",
            "warning": "Cảnh báo kết nối",
            "unableToSync": "Không thể đồng bộ hóa"
        },
        "platformDevice": {
            "defaultApp": "Ứng dụng sức khỏe mặc định trên thiết bị của bạn là",
            "continueMore": "Tiếp tục truy cập vào các ứng dụng và thiết bị khác"
        }
    },
    "friendsAndFamily": {
        "learnMore": "Tìm hiểu thêm về danh sách bạn bè và gia đình",
        "learnModal": {
            "title": "Giới thiệu về danh sách bạn bè và gia đình",
            "description": "Sau khi thêm ai đó vào danh sách Bạn bè và gia đình, bạn có thể chọn chỉ chia sẻ bài viết của mình trên %{programName} với họ.\n\nBạn cũng có thể lọc để chỉ nhìn thấy bài viết của những người trong danh sách bạn bè và gia đình của mình trên %{programName} nếu họ chọn chế độ hiển thị bài viết với tất cả mọi người hoặc với bạn.",
            "description_line1": "Sau khi thêm ai đó vào danh sách Bạn bè và gia đình, bạn có thể chọn chỉ chia sẻ bài viết của mình trên %{programName} với họ.",
            "description_line2": "Bạn cũng có thể lọc để chỉ nhìn thấy bài viết của những người trong danh sách bạn bè và gia đình của mình trên %{programName} nếu họ chọn chế độ hiển thị bài viết với tất cả mọi người hoặc với bạn.",
            "whatIconsMean": "Ý nghĩa của các biểu tượng",
            "canAdd": "Thêm",
            "added": "Đã thêm"
        },
        "searchDescription1": "Tìm kiếm mọi người để thêm vào danh sách bạn bè và gia đình của bạn.",
        "searchDescription2": "Bạn không tìm được người mình muốn ư? Mời họ tham gia qua email.",
        "friends&Family": "Bạn bè và gia đình",
        "managingTour": {
            "title": "Quản lý danh sách bạn bè và gia đình",
            "body": "Nếu bạn muốn xóa ai đó khỏi danh sách bạn bè và gia đình, hãy nhấn vào biểu tượng này"
        },
        "removeOption": "Xóa khỏi danh sách bạn bè và gia đình",
        "inviteDescription1": "Tìm kiếm bạn bè và gia đình của bạn.",
        "inviteDescription2": "Bạn không tìm được người mình muốn ư?"
    },
    "deletePlatformInvitationToast": {
        "success": {
            "message": "Các bài viết bạn chỉ chia sẻ với bạn bè và gia đình sẽ không hiển thị với %{userFirstName} nữa."
        }
    },
    "skipAll": "Bỏ qua tất cả",
    "smallMin": "tối thiểu",
    "eap": {
        "skipModal": {
            "title": "Bạn có chắc không?",
            "description": "Từ mục hồ sơ của mình, bạn luôn có thể liên hệ với Chương trình Hỗ trợ nhân viên & gia đình khi cần."
        },
        "contact": {
            "whatIsBestNumber": "Chúng tôi nên liên hệ với bạn theo số điện thoại nào?",
            "whatIsBestTime": "Chúng tôi nên liên hệ với bạn vào thời gian nào?",
            "morning": "Sáng",
            "afternoon": "Chiều",
            "evening": "Tối",
            "additionalDetails": "Thông tin bổ sung về ngày\/giờ bạn muốn được liên hệ",
            "message": "Liên hệ với tôi vào %{weekDay} theo số %{phoneNumber}. Thông tin bổ sung: %{additional}",
            "description": "Lưu ý: Bạn nên chọn thời gian ngoài giờ làm việc và chọn một nơi mà bạn có thể trò chuyện riêng tư. Vui lòng thêm múi giờ."
        },
        "phoneNumber": {
            "empty": "Không được để trống trường này",
            "missingDigits": "Số điện thoại phải có ít nhất 4 chữ số"
        },
        "myEAP": "Chương trình hỗ trợ nhân viên và gia đình của tôi"
    },
    "healthSurveySkipAllTitle": "Bỏ qua cuộc khảo sát sức khỏe",
    "healthSurveySkipAllAlert": "Bạn có chắc chắn muốn bỏ qua tất cả các câu hỏi còn lại của cuộc khảo sát sức khỏe không?",
    "eapSavingWithoutDataToast": {
        "danger": {
            "title": "Chương trình hỗ trợ nhân viên và gia đình",
            "message": "Vui lòng cung cấp số điện thoại của bạn và thời gian liên hệ thuận tiện nhất"
        }
    },
    "allMyChallenges": "Thử thách của tôi",
    "invitedChallenges": "Lời mời",
    "companyChallenges": "Thử thách của công ty",
    "completedChallengesEmpty": "Có vẻ như bạn vẫn chưa hoàn thành bất kỳ thử thách nào.",
    "myChallengesEmpty": "Có vẻ như bạn vẫn chưa tham gia bất kỳ thử thách nào.",
    "allChallengesEmpty": "Không có thách thức.",
    "startsToday": "Bắt đầu ngay hôm nay",
    "startedDaysAgo": "Đã bắt đầu %{dayCount} ngày trước",
    "startsInDays": "Bắt đầu sau %{dayCount} ngày",
    "privacyOn": "Tắt",
    "privacyOff": "Bật",
    "dashboard": {
        "viewLeaderboard": "Xem bảng xếp hạng",
        "timePeriodProgress": "Tiến độ của bạn trong %{period} này",
        "howToEarn": "Cách nhận điểm"
    },
    "privacyChangeConfirmationMessage": "Thay đổi quyền riêng tư?",
    "privacySettingsTitle": "Quyền riêng tư",
    "privacySettingsDescription": "Bạn có thể kiểm soát chế độ hiển thị của ảnh, tên và hồ sơ của mình với những người dùng khác. ",
    "mainLeaderBoardSettingsTitle": "?Bảng xếp hạng tổng thể",
    "challengeLeaderBoardSettingsTitle": "?Bảng xếp hạng thử thách",
    "managePrivacySettingUrlTitle": "Quản lý chế độ cài đặt quyền riêng tư",
    "onboardingFamilyPrivacySettingsMessageOn": "Bạn hiển thị trong kết quả tìm kiếm bạn bè và gia đình. Bạn có thể chọn ẩn bản thân khỏi kết quả tìm kiếm.",
    "onboardingFamilyPrivacySettingsMessageOff": "Chế độ cài đặt quyền riêng tư của bạn hiện ẩn bạn khỏi kết quả tìm kiếm bạn bè và gia đình.",
    "challengeInvitationPrivacySettingsMessageOn": "Bạn hiển thị trong kết quả tìm kiếm lời mời tham gia thử thách. Bạn có thể chọn ẩn bản thân khỏi kết quả tìm kiếm.",
    "challengeInvitationPrivacySettingsMessageOff": "Chế độ cài đặt quyền riêng tư của bạn hiện ẩn bạn khỏi kết quả tìm kiếm lời mời tham gia thử thách.",
    "challengeParticipationPrivacySettingsMessageOn": "Bạn được liệt kê là người tham gia thử thách này. Bạn có thể chọn ẩn bản thân là người tham gia thử thách này.",
    "challengeParticipationPrivacySettingsMessageOff": "Chế độ cài đặt quyền riêng tư của bạn hiện ẩn bạn khỏi danh sách người tham gia.",
    "communityInvitationPrivacySettingsMessageOn": "Bạn hiển thị trong kết quả tìm kiếm lời mời tham gia cộng đồng. Bạn có thể chọn ẩn bản thân khỏi kết quả tìm kiếm.",
    "communityInvitationPrivacySettingsMessageOff": "Chế độ cài đặt quyền riêng tư của bạn hiện ẩn bạn khỏi kết quả tìm kiếm lời mời tham gia cộng đồng.",
    "communityParticipationPrivacySettingsMessageOn": "Bạn được liệt kê là thành viên của cộng đồng này. Bạn có thể chọn ẩn bản thân là thành viên của các cộng đồng.",
    "communityParticipationPrivacySettingsMessageOff": "Chế độ cài đặt quyền riêng tư của bạn hiện ẩn bạn khỏi danh sách thành viên.",
    "eventInvitationPrivacySettingsMessageOn": "Bạn hiển thị trong kết quả tìm kiếm lời mời tham gia sự kiện. Bạn có thể chọn ẩn bản thân khỏi kết quả tìm kiếm.",
    "eventInvitationPrivacySettingsMessageOff": "Chế độ cài đặt quyền riêng tư của bạn hiện ẩn bạn khỏi kết quả tìm kiếm lời mời tham gia sự kiện.",
    "eventParticipationPrivacySettingsMessageOn": "Bạn được liệt kê là người tham gia sự kiện này. Bạn có thể chọn ẩn bản thân là người tham gia sự kiện.",
    "eventParticipationPrivacySettingsMessageOff": "Chế độ cài đặt quyền riêng tư của bạn hiện ẩn bạn khỏi danh sách người tham dự.",
    "mainLeaderboardPrivacySettingsMessageOn": "Bạn hiển thị trên bảng xếp hạng tổng thể. Bạn có thể chọn ẩn bản thân để những người khác không thấy thứ hạng, ảnh và tên của bạn trên bảng xếp hạng tổng thể.",
    "mainLeaderboardPrivacySettingsMessageOff": "Theo chế độ cài đặt quyền riêng tư hiện tại của bạn, những người khác sẽ không thấy bạn trên bảng xếp hạng tổng thể.",
    "challengeLeaderboardPrivacySettingsMessageOn": "Bạn hiển thị trên bảng xếp hạng thử thách. Bạn có thể chọn ẩn bản thân để những người khác không thấy thứ hạng, ảnh và tên của bạn trên bảng xếp hạng thử thách.",
    "challengeLeaderboardPrivacySettingsMessageOff": "Theo chế độ cài đặt quyền riêng tư hiện tại của bạn, những người khác sẽ không thấy bạn trên bảng xếp hạng thử thách.",
    "thumbsUpConfirmationTitle": "Thích",
    "thumbsUpConfirmationDescriptionline1": "Xin chúc mừng, bạn sắp thích bài viết đầu tiên và truyền cảm hứng người khác!",
    "thumbsUpConfirmationDescriptionline2": "Bạn sẽ nằm trong danh sách những người đã thích bài viết này và những người khác có thể xem ảnh, tên và hồ sơ của bạn.",
    "thumbsUpConfirmationButtonOk": "Thích",
    "commentToActionInfoTitle": "Những người khác nhìn thấy gì?",
    "commentToActionMessage": "Khi bạn bình luận, người khác có thể xem ảnh, tên và hồ sơ của bạn.",
    "postToActionTitle": "Ai nhìn thấy bài viết này?",
    "postToActionMessageLine1": "Khi bạn tạo bài viết, bạn có thể kiểm soát ai có thể xem bài viết đó và thậm chí chỉ hiển thị bài viết với chính mình.",
    "postToActionMessageLine2": "Những bài viết bạn chia sẻ với người khác sẽ hiển thị ảnh, tên và hồ sơ của bạn",
    "privateUsersDescriptionChallenge": "(Những) người tham gia này đã ẩn bản thân khỏi danh sách",
    "privateUsersFirstNamePlaceHolderChallenge": "%{n} riêng tư",
    "privateUsersLastNamePlaceHolderChallenge": "người tham gia",
    "privateUsersDescriptionEvent": "(Những) người tham dự này đã ẩn bản thân khỏi danh sách",
    "privateUsersFirstNamePlaceHolderEvent": "%{n} riêng tư",
    "privateUsersLastNamePlaceHolderEvent": "người tham dự",
    "privateUsersDescriptionCommunity": "(Những) thành viên này đã ẩn bản thân khỏi danh sách",
    "privateUsersFirstNamePlaceHolderCommunity": "%{n} riêng tư",
    "privateUsersLastNamePlaceHolderCommunity": "thành viên",
    "noPrivacySettings": "Không có phần cài đặt quyền riêng tư",
    "linkToPartnerNameWebsite": "Liên kết qua trang web của %{partner_name}",
    "linkToPartnerWebsiteUrl": "URL trang web của đối tác",
    "start_end_time": "Thời gian bắt đầu và Thời gian kết thúc:",
    "joinCreateTeamPrivacyDisclaimer": "Ảnh, tên và hồ sơ của bạn sẽ luôn hiển thị với bất kỳ ai xem nhóm của bạn trong một thử thách, ngay cả khi bạn đã thay đổi Chế độ cài đặt quyền riêng tư thành Riêng tư.",
    "carouselInstructions": {
        "swipe": "Vuốt các thẻ để xem tất cả mục tiêu và thách thức của bạn.",
        "click": "Nhấp vào các thẻ để xem tất cả mục tiêu và thách thức của bạn."
    },
    "achieved": "Đã đạt",
    "hours": "giờ",
    "createCommunityFlow": {
        "navigatorTitle": "Tạo cộng đồng",
        "stepType": {
            "title": "Chế độ hiển thị của cộng đồng",
            "subTitle": "Ai có thể xem và tham gia cộng đồng?",
            "privateName": "Riêng tư",
            "publicName": "Công khai",
            "privateDescription": "Chỉ những người bạn mời mới có thể xem hoặc tham gia cộng đồng",
            "publicDescription": "Bất kỳ ai cũng có thể xem và tham gia cộng đồng này"
        },
        "stepName": {
            "title": "Đặt tên cho cộng đồng của bạn",
            "subTitle": "Đặt tên cho cộng đồng của bạn để cho mọi người biết về cộng đồng này.",
            "namePlaceholder": "Tên cộng đồng",
            "noFieldsTitle": "Tên",
            "noFieldsMessage": "Chưa đặt tên"
        },
        "stepDescription": {
            "title": "Giới thiệu về cộng đồng của bạn",
            "subTitle": "Cho người khác biết về cộng đồng của bạn.",
            "descriptionPlaceholder": "Mô tả (không bắt buộc)",
            "noFieldsTitle": "Mô tả",
            "noFieldsMessage": "Chưa cung cấp nội dung mô tả"
        },
        "stepImage": {
            "uploadPhotoButtonTitle": "Thêm ảnh"
        },
        "stepJoin": {
            "title": "Chúng tôi đã tìm thấy các cộng đồng tương tự",
            "subTitle": "Bạn có muốn tham gia một trong những cộng đồng này không?"
        },
        "createNew": "Tạo cộng đồng mới"
    },
    "challengeCard": {
        "allActivities": "Tất cả các hoạt động trong",
        "category": "danh mục"
    },
    "myLinkedPartners": "Đối tác được liên kết của tôi",
    "leaderboardPosition": "Vị trí trên bảng xếp hạng tổng thể",
    "remainingInChallenge": "còn lại trong thử thách",
    "todays_progress": "Tiến độ của ngày hôm nay",
    "this_weeks_progress": "Tiến độ của tuần này",
    "this_months_progress": "Tiến độ của tháng này",
    "achievement": "thành tích",
    "challengeCardHeader": {
        "challenge": "Thử thách",
        "recommended_personal_goals": "Mục tiêu cá nhân đề xuất",
        "personal_goal": "Mục tiêu cá nhân",
        "competition": "Cuộc thi",
        "recommended_goals": "Mục tiêu đề xuất",
        "team_competition": "Cuộc thi nhóm",
        "team": "Nhóm"
    },
    "MyMedibank": "My Medibank",
    "Google": "Google",
    "Facebook": "Facebook",
    "errorEntityTimeMessage": "Thời gian kết thúc không được sớm hơn thời gian bắt đầu",
    "company": "Công ty",
    "lessThan1DayRemain": "dưới 1 ngày",
    "lessThan1HourRemain": "dưới 1 giờ",
    "remainingToday": "còn lại trong hôm nay",
    "periodEndsDateAndTime": "Khoảng thời gian kết thúc vào lúc %{time}, %{date}",
    "moreToGo": "Còn %{n} %{unit} nữa cần thực hiện",
    "reachedYourGoal": "Bạn đã đạt được mục tiêu của %{period}!",
    "reachedYourGoalToday": "Bạn đã đạt được mục tiêu của ngày hôm nay!",
    "editProfileItemCorrectRange": "Hãy cung cấp một giá trị %{itemName} hợp lệ trong khoảng từ %{min} đến %{max}",
    "invalidUrl": "URL không hợp lệ",
    "activityLogChanged": {
        "success": "Các thay đổi đối với hoạt động đã được lưu",
        "info": "Đã xảy ra lỗi... Vui lòng thử lại.",
        "danger": "Đã xảy ra lỗi... Vui lòng thử lại."
    },
    "discardAlert": {
        "createChallenge": "Bạn có chắc chắn muốn hủy %{challengeType} này không?",
        "inviteByEmail": "Bạn có chắc chắn muốn hủy các thay đổi không?",
        "createTeam": "Bạn có chắc chắn muốn hủy quá trình tạo nhóm này không?",
        "cancel": "Hủy",
        "confirm": "Có, hãy hủy"
    },
    "entityInvalidNameError": "Tên của %{entity} chỉ được chứa số hoặc giá trị chuỗi và không được để trống",
    "accept": "Chấp nhận",
    "sync_now": "Đồng bộ hóa ngay",
    "reconnect_device": "Kết nối lại",
    "supported_activities": "Các hoạt động được hỗ trợ",
    "recentlySynced_activity": "Hoạt động được đồng bộ hóa gần đây",
    "noSyncedActivity_sevenDays": "Không có hoạt động nào được đồng bộ hóa trong 7 ngày qua",
    "recentActivityLog": {
        "convertingActivityPoints": "Đang đồng bộ hóa các hoạt động...",
        "activityMinuteOrTwo": "Quá trình này có thể mất một vài phút...",
        "noNewActivities": "Không có hoạt động mới nào được thêm vào... Có thể mất đến một giờ để các hoạt động mới đồng bộ hóa."
    },
    "deleteCommunityCheckbox": "Tôi hiểu rằng thao tác này không hủy được",
    "createEvent": {
        "type": {
            "company": "Sự kiện của công ty",
            "user": "Sự kiện của người dùng",
            "title": "Loại sự kiện"
        },
        "privacy": "Quyền riêng tư (hiển thị\/không hiển thị người tham dự)",
        "cost": "Chi phí",
        "associated": {
            "location": "Vị trí liên kết",
            "department": "Phòng ban liên kết"
        },
        "maxParticipants": "Số người tham gia tối đa (không bắt buộc)",
        "errorMessage": {
            "limit": "Không được lớn hơn %{maxValue}",
            "negative": "Không được là giá trị âm",
            "selectedLocations": "Vui lòng chọn một hoặc nhiều vị trí"
        },
        "selectLocations": "Các vị trí đã chọn",
        "createNew": "Tạo sự kiện mới"
    },
    "selected": "Đã chọn",
    "deleteEventButton": "Xóa sự kiện này",
    "notification": {
        "priorityNotification": {
            "title": "Bạn có các thông tin cập nhật quan trọng chưa đọc",
            "subtitle": "Nhấn để đọc ngay",
            "subtitleWeb": "Nhấp để đọc ngay"
        },
        "sectionTitle": {
            "priorityUnread": "Thông tin cập nhật quan trọng chưa đọc",
            "all": "Tất cả thông báo"
        },
        "modalTitle": "Bạn có %{count} thông tin cập nhật quan trọng",
        "priorityModalTitle": {
            "defaultTitle": "Xem tất cả thông tin cập nhật"
        }
    },
    "createEntity": {
        "cancel": {
            "title": "Hủy %{entity} %{actionType}",
            "message": "Bạn có chắc chắn muốn hủy %{entity} %{actionType} không?"
        },
        "action": {
            "creating": "tạo",
            "editing": "chỉnh sửa"
        },
        "type": {
            "team": "nhóm",
            "community": "cộng đồng",
            "event": "sự kiện",
            "challenge": "thử thách",
            "goal": "mục tiêu"
        }
    },
    "publicVisibilitySwitch": {
        "modalTitle": {
            "public": "Đặt ở chế độ công khai?",
            "private": "Đặt ở chế độ riêng tư?"
        },
        "modalSubtitle": {
            "public": "Khi bạn đặt %{entityType} này ở chế độ công khai, bất kỳ ai cũng có thể khám phá và tham gia. Bạn có chắc chắn muốn đặt %{entityType} này ở chế độ công khai không?",
            "private": "Khi bạn đặt %{entityType} này ở chế độ riêng tư, không ai có thể khám phá và tham gia. Bạn có chắc chắn muốn đặt %{entityType} này ở chế độ công khai không?"
        },
        "footerButton": {
            "makePublic": "Có, hãy đặt ở chế độ công khai",
            "makePrivate": "Có, hãy đặt ở chế độ riêng tư",
            "keepPrivate": "Giữ ở chế độ riêng tư",
            "keepPublic": "Giữ ở chế độ công khai"
        },
        "label": {
            "title": "Đặt %{entityType} này ở chế độ công khai",
            "subtitle": "Ai cũng có thể xem và tham gia"
        }
    },
    "imageUploader": {
        "changeImageButton": "Thay đổi hình ảnh"
    },
    "copyright": "Bản quyền © Sprout 2019",
    "samsunghealth_not_available": "Không thể kết nối với Samsung Health. Trong ứng dụng Health, bên dưới mục Data Permissions, hãy đảm bảo bạn đã bật quyền tối thiểu đối với các bước và đã theo dõi ít nhất 1 bước.",
    "rewardsHowDoIEarn": "Làm cách nào để kiếm được %{currencyName}?",
    "unlockAchievements": "Mở khóa thành tích",
    "unlockAchievementsDescription": "Theo dõi hoạt động, giành được %{pointsName}, mở khóa các cấp độ và kiếm được nhiều %{currencyName} hơn. Nhấn vào từng thành tích để xem bạn cần làm gì.",
    "myDay": "Ngày của tôi",
    "myGoalsChallengesTasks": "Mục tiêu, thử thách và nhiệm vụ của tôi",
    "yourGoalsChallenges": "Mục tiêu và thử thách của bạn",
    "mySocialStream": "Bài viết trên cộng đồng",
    "viewAllAchievements": "Xem tất cả thành tích",
    "viewAllBonusChallenges": "Xem tất cả các thử thách thưởng",
    "newVersionOfAppAvailable": "Chưa có phiên bản mới! Vui lòng tải lại trang này",
    "noBonusChallengesToDisplay": "Hiện không có thử thách thưởng nào.",
    "bonusChallenges": "Thử thách thưởng",
    "reloadAppVersion": "Tải lại",
    "appname": "Sprout",
    "cancel_tracking_confirmation": "Bạn có chắc chắn muốn hủy theo dõi %{activity_name} không?",
    "activity_tracker_instruction_header": "Nhấn vào một ngày để theo dõi các hoạt động trong ngày đó hoặc xem những hoạt động nào đã được theo dõi.",
    "alertDashboardFunctionalityToBeAdded": "văn bản sẽ được thêm vào đây để định nghĩa về khoảng thời gian theo dõi, tương tự như cách thực hiện đối với các chương trình khách hàng thân thiết của hãng hàng không, trong đó người dùng cần tiếp tục tích lũy \"dặm bay\" trong một năm dương lịch để nhận trạng thái cho năm tới.",
    "noNumberEntered": "Nhập mức độ hoạt động",
    "feed": "Luồng",
    "home": "Trang chủ",
    "challenges": "Thử thách",
    "explore": "Khám phá",
    "rewards": "Phần thưởng",
    "reward": "phần thưởng",
    "balance": "Số dư phần thưởng trong %{programName}",
    "profile": "Hồ sơ",
    "loading": "Đang tải...",
    "me": "Tôi",
    "back": "Quay lại",
    "next": "Tiếp theo",
    "skip": "Bỏ qua",
    "signup": "Đăng ký",
    "signin": "Đăng nhập",
    "signin_maintitle": "Sprout",
    "signin_subtitle": "",
    "signinto": "Đăng nhập vào Live Better",
    "signup_with_medibank": "Đăng ký với tư cách là thành viên Medibank",
    "signup_with_facebook": "Đăng ký bằng Facebook",
    "signup_with_google": "Đăng ký bằng Google",
    "signup_with_email": "Đăng ký qua email",
    "signin_with_medibank": "Đăng nhập bằng My Medibank",
    "signin_with_facebook": "Đăng nhập bằng Facebook",
    "signin_with_google": "Đăng nhập bằng Google",
    "signin_with_email": "Đăng nhập bằng email",
    "signup_heading": "Tạo tài khoản",
    "not_a_medibank_member": "Bạn không phải là thành viên Medibank?",
    "keep_me_signed_in": "Duy trì trạng thái đăng nhập",
    "forgotpassword": "Quên mật khẩu?",
    "emailaddress": "Địa chỉ email",
    "password": "Mật khẩu",
    "enterEmailAddress": "Nhập địa chỉ email của bạn",
    "enterYourPassword": "Nhập mật khẩu của bạn",
    "password_for_error": "mật khẩu",
    "reset_password": "Đặt lại mật khẩu",
    "passwordResetSuccess": "Đã đặt lại mật khẩu",
    "passwordResetEmailSent": "Nếu tìm thấy email trùng khớp trong hệ thống thì chúng tôi sẽ gửi hướng dẫn đặt lại mật khẩu qua email cho bạn.",
    "loginerror": "Đã xảy ra lỗi khi đăng nhập:",
    "logincancelled": "Đã hủy quá trình đăng nhập",
    "part_of_corporate_program": "Bạn đang đăng ký chương trình của công ty?",
    "continue_here": "Tiếp tục tại đây",
    "program_name": "Tên chương trình",
    "error_provide_program_name": "Vui lòng cung cấp tên chương trình.",
    "program_not_found": "Không tìm thấy chương trình",
    "registration_field_email": "Email",
    "employeeId": "ID nhân viên",
    "registration_field_firstName": "Tên",
    "registration_field_lastName": "Họ",
    "no_first_name": "Không có tên",
    "no_last_name": "Không có họ",
    "registration_field_password": "Mật khẩu mới",
    "no_disclaimer_available": "Rất tiếc, đã xảy ra sự cố... Chúng tôi không thể truy xuất các điều khoản và điều kiện của tổ chức của bạn. Vui lòng thử đăng ký lại sau. ",
    "registration_account_not_registered": "Có vẻ như bạn chưa xác minh địa chỉ email của mình. Bạn có muốn chúng tôi gửi lại email không?",
    "resend_verification_email": "Xác minh email",
    "resend_verification_email_successful": "Chúng tôi đã gửi lại email xác minh cho bạn.",
    "resend_verification_email_unsuccessful": "Rất tiếc, đã xảy ra sự cố... chúng tôi không thể gửi lại email xác minh. Vui lòng thử lại.",
    "not_supported": "Hiện không thể hiển thị bài viết này. Vui lòng thử lại sau.",
    "policyAgreeError": "Để tiếp tục, vui lòng đồng ý với Điều khoản dịch vụ và Chính sách quyền riêng tư.",
    "challenge_completion_bonus": "Thưởng hoàn thành",
    "me_tabs": {
        "activity": "Hoạt động",
        "bookmarks": "Dấu trang"
    },
    "health_tab": {
        "my_health_score": "Điểm sức khỏe của bạn",
        "overall_health_score_description": "Điểm sức khỏe của bạn là",
        "health_score_explanation": "Điểm sức khỏe được tính toán dựa vào các câu trả lời của bạn về sức khỏe và mức độ vận động. \n\nĐiểm của bạn được cập nhật hàng tháng dựa trên mức độ hoạt động của bạn. Bạn có thể đặt và hoàn thành các mục tiêu cá nhân để cải thiện điểm sức khỏe của mình.",
        "health_score_calculation_failed_onboarding": "Đã xảy ra sự cố và chúng tôi không thể truy xuất điểm sức khỏe của bạn. Bạn có thể tiếp tục ngay bây giờ và ngay sau khi sự cố được khắc phục, chúng tôi sẽ cập nhật điểm của bạn."
    },
    "track_activity": "Theo dõi hoạt động",
    "track_an_activity": "Theo dõi một hoạt động",
    "track": "Theo dõi",
    "unable_to_track": "Không thể theo dõi",
    "enter_before_track": "Nhập mức độ hoạt động cần theo dõi",
    "what_to_share": "Bạn muốn chia sẻ loại thông tin cập nhật nào?",
    "remove": "Xóa",
    "activity_tracking_description": "Bạn muốn theo dõi bao nhiêu %{units}?",
    "excessive_submission": "Tuyệt! Bạn sắp theo dõi hơn 2.000 %{customPoints} đối với %{activity_name}. Bạn nên đảm bảo rằng mọi thứ đều chính xác trước khi gửi.",
    "on": "bật",
    "in": "trong",
    "from": "từ",
    "at": "tại",
    "no_activities": "Không có hoạt động nào phù hợp với nội dung bạn tìm kiếm.",
    "activity_tracking_desc": "Bạn cần thêm một số để tiếp tục. Nhấn vào X ở góc bên trái để hủy.",
    "activity_tracking_desc2": "Nhấn vào bất kỳ vị trí nào trên hoạt động để chỉnh sửa, nhấn vào + để theo dõi nhanh mục tiêu",
    "vital_stats_title": "Giới thiệu về bạn",
    "invalid_numeric_response": "Không hợp lệ",
    "invalid_numeric_response_range": "Số này phải nằm trong khoảng từ %{minimum} đến %{maximum}",
    "search_placeholder": "Tìm kiếm trong thư viện...",
    "search_activities": "Tìm kiếm hoạt động",
    "searching": "Đang tìm kiếm...",
    "searchEmpty": "Không tìm thấy kết quả phù hợp nào",
    "vital_stats_description": "Hãy giới thiệu đôi điều về bạn",
    "health_survey_questions": "Câu hỏi khảo sát về sức khỏe",
    "health_survey_title": "Hoàn thành bản khảo sát về sức khỏe",
    "health_survey_results": "Kết quả khảo sát về sức khỏe",
    "health_survey_card_desc": "Hãy tham gia khảo sát để có cái nhìn tổng thể về tình trạng sức khỏe của bạn và đặt ra các mục tiêu riêng cho mình.",
    "apps_devices_title": "Liên kết các ứng dụng và thiết bị",
    "apps_devices_card_desc": "Đồng bộ hóa các ứng dụng và thiết bị của bạn để nhận được %{customPoints} một cách dễ dàng.",
    "interests_title": "Sở thích",
    "interests_card_desc": "Hãy cho chúng tôi biết về sở thích của bạn. Điều này giúp chúng tôi đề xuất các mục tiêu và cộng đồng mà bạn có thể quan tâm.",
    "interests_screen_desc": "Bạn quan tâm đến điều gì?",
    "health_obj_title": "Mục tiêu sức khỏe",
    "health_obj_card_desc": "Chúng tôi nghĩ rằng đã đến lúc phải đặt ra một số mục tiêu. Khi nắm được mục tiêu của bạn, chúng tôi có thể đưa ra các đề xuất tốt hơn cho bạn. Đừng lo, nếu đổi ý, bạn có thể dễ dàng thay đổi trong hồ sơ của mình sau này. ",
    "health_obj_screen_desc": "Bạn muốn hướng tới khía cạnh nào?",
    "my_heatlh_obj": "Mục tiêu sức khỏe của tôi",
    "health_topic_title": "Chủ đề sức khỏe",
    "health_topic_card_desc": "Chỉ định các chủ đề sức khỏe để cá nhân hóa trải nghiệm của bạn.",
    "health_topic_screen_desc": "Bạn muốn tìm hiểu về điều gì?",
    "multi_select_check_error": "Vui lòng chọn ít nhất 1 tùy chọn để tiếp tục",
    "my_health_topics": "Chủ đề sức khỏe của tôi",
    "build_your_profile": "Xây dựng hồ sơ",
    "personalize_title": "Cá nhân hóa",
    "personalize_desc": "Trả lời một vài câu hỏi nhanh để cá nhân hóa trải nghiệm của bạn.",
    "set_goals_title": "Xem các mục tiêu đề xuất",
    "set_goals_desc": "Đặt mục tiêu được cá nhân hóa để bắt đầu hành trình cải thiện sức khỏe.",
    "set_this_goal": "Đặt mục tiêu này",
    "goal_set": "Đã đặt mục tiêu",
    "required": "Bắt buộc",
    "apps_devices_description": "Kết nối với nền tảng thể dục để tự động nhận thêm %{customPoints}.",
    "connected": "Đã kết nối",
    "num_connected": "(Đã kết nối %{numDevices})",
    "available": "Có sẵn",
    "inProgress": "Đang tiến hành...",
    "time_a_m": "sáng",
    "time_p_m": "chiều",
    "last_synced": "Lần đồng bộ hóa gần đây nhất",
    "last_synced_lc": "lần đồng bộ hóa gần đây nhất",
    "no_connected_devices": "Không có thiết bị nào được kết nối",
    "apps_devices_confirm_disconnect": "Bạn có chắc chắn muốn ngắt kết nối không?",
    "button_delete": "Xóa",
    "button_disconnect": "Ngắt kết nối",
    "button_cancel": "Hủy",
    "button_dismiss": "Hủy",
    "ok": "OK",
    "waist_helper_text": "Bạn nên đo vòng eo bên dưới vùng xương sườn, thường là ngang với rốn và đo khi đứng. Nếu không biết chắc, hãy sử dụng cỡ quần jean của bạn.",
    "apps_devices_manage": "Quản lý các ứng dụng và thiết bị của tôi",
    "my_apps_devices": "Ứng dụng và thiết bị của tôi",
    "completeRegistration": "Hoàn tất đăng ký",
    "havingTrouble": "Bạn gặp sự cố?",
    "contactUs": "Hãy liên hệ theo địa chỉ support@sproutatwork.com để được hỗ trợ",
    "done": "Xong",
    "brand": "Sprout",
    "cannotTrackTitle": "Không thể theo dõi hoạt động",
    "cannotTrackPrior": "Bình tĩnh nào. Các hoạt động chỉ theo dõi được sau ngày bắt đầu.",
    "cannotTrackFuture": "Chờ chút nhé. Các hoạt động chỉ theo dõi được cho đến ngày hiện tại.",
    "cannotTrack": "Không thể theo dõi các hoạt động trước ngày bắt đầu hoặc vào một ngày trong tương lai.",
    "disclaimer": "Tuyên bố miễn trừ trách nhiệm",
    "acceptTerms": "Tôi chấp nhận các điều khoản và điều kiện",
    "verificationEmailTitle": "Xác minh email của bạn",
    "email_not_yet_verified": "Có vẻ như bạn chưa xác minh địa chỉ email của mình. ",
    "email_successfully_verified_title": "Xin chào",
    "email_successfully_verified": "Bạn đã xác minh thành công email của mình",
    "pleaseVerifyEmailMessage1": "Bạn cần xác minh địa chỉ email của mình để tiếp tục.",
    "pleaseVerifyEmailMessage2": "Vui lòng làm theo hướng dẫn được gửi tới:",
    "supportEmail": "support@sproutatwork.com",
    "resendEmail": "Gửi lại email",
    "restart": "Quay lại phần đăng nhập",
    "firstName": "Tên",
    "firstNamePlaceholder": "Tên bạn",
    "lastName": "Họ",
    "lastNamePlaceholder": "Họ của bạn",
    "email": "Email",
    "emailPlaceholder": "Địa chỉ email của bạn",
    "employeId": "ID nhân viên",
    "employeIdPlaceholder": "ID nhân viên công ty",
    "passwordPlaceholder": "Mật khẩu mới",
    "datePickerTitle": "Chọn ngày sinh của bạn",
    "datePickerConfirm": "Xác nhận",
    "datePickerCancel": "Hủy",
    "termsOfUsePrivacyPreLinks": "Tôi đồng ý với",
    "sendMePromoCommunications": "Gửi cho tôi nội dung quảng cáo",
    "sendMePromoCommunicationsFromPartners": "Gửi cho tôi nội dung quảng cáo từ đối tác",
    "termsOfService": "điều khoản dịch vụ",
    "legal": "Pháp lý",
    "privacyPolicy": "chính sách quyền riêng tư",
    "and": "và",
    "programDomainLabel": "Tên chương trình",
    "programDomainPlaceholder": "Tên chương trình",
    "findProgramName": "Tìm tên chương trình của tôi",
    "findProgramNameButton": "Tìm tên chương trình",
    "findProgramNameTitle": "Tìm tên chương trình của tôi",
    "findProgramNameDescription": "Địa chỉ email của công ty",
    "findProgramNamePlaceholder": "Địa chỉ email",
    "findProgramSuccessMessage": "Kết quả tìm kiếm tên chương trình đã được gửi cho bạn qua email.",
    "findProgramSuccessTitle": "Tên chương trình",
    "findProgramErrorTitle": "Tên chương trình",
    "findProgramErrorMessage": "Rất tiếc, đã xảy ra sự cố... Chúng tôi đã gặp lỗi khi cố gắng truy xuất tên chương trình của bạn. Vui lòng thử lại.",
    "countryLabel": "Chọn quốc gia",
    "countryName": "Quốc gia",
    "regionLabel": "Chọn khu vực",
    "regionName": "Khu vực",
    "cityLabel": "Chọn tỉnh\/thành phố",
    "cityName": "Tỉnh\/thành phố",
    "locationWorkLabel": "Chọn vị trí",
    "locationWorkName": "Vị trí",
    "locationLabel": "Chọn vị trí",
    "locationName": "Vị trí",
    "departmentLabel": "Chọn phòng ban",
    "departmentName": "Phòng ban",
    "no_department": "Không có phòng ban",
    "enterPIN": "Vui lòng nhập mã PIN của công ty",
    "verifyEmailTitle": "Xác minh email",
    "verifyEmailMsg": "Có vẻ như bạn chưa xác minh địa chỉ email của mình",
    "resendEmailTitle": "Xác minh email",
    "resendEmailMsg": "Gửi lại đến %{userEmail}",
    "select_date": "Chọn ngày",
    "changePasswordTitle": "Đổi mật khẩu",
    "currentPassword": "Mật khẩu hiện tại",
    "newPassword": "Mật khẩu mới",
    "confirmNewPassword": "Xác nhận mật khẩu mới",
    "passwordChangeError": {
        "currentPasswordMissing": "Nhập mật khẩu hiện tại",
        "newPasswordMissing": "Nhập mật khẩu mới",
        "confirmPasswordMissing": "Xác nhận mật khẩu mới",
        "passwordsMatch": "Các mật khẩu không khớp",
        "passwordIncorrect": "Sai mật khẩu. Vui lòng thử lại."
    },
    "settings": "Cài đặt",
    "signOut": "Đăng xuất",
    "updateApp": "Cập nhật ứng dụng",
    "updateAppRight": "Phiên bản mới nhất: %{version}",
    "appleStoreUrlSprout": "https:\/\/itunes.apple.com\/us\/app\/sprout-at-work\/id904741273",
    "playStoreUrlSprout": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.sproutmobileapp",
    "appleStoreUrlLiveBetter": "https:\/\/itunes.apple.com\/us\/app\/live-better\/id1289314646",
    "playStoreUrlLiveBetter": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.livebetter",
    "appleStoreUrlTelus": "https:\/\/apps.apple.com\/app\/telus-health-wellbeing\/id1627569346",
    "playStoreUrlTelus": "https:\/\/play.google.com\/store\/apps\/details?id=com.telus.health.wellbeing",
    "appleStoreUrlUPnGO": "https:\/\/itunes.apple.com\/us\/app\/upngo-with-participaction\/id1079958142",
    "playStoreUrlUPnGO": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.upngo",
    "getHelp": "Yêu cầu trợ giúp",
    "feedback": "Phản hồi",
    "feedback_success_title": "Đã gửi ý kiến phản hồi",
    "feedback_success_msg": "Cảm ơn bạn đã gửi ý kiến phản hồi. Chúng tôi thực sự trân trọng điều đó!",
    "feedback_failure_title": "Lỗi",
    "feedback_failure_msg": "Rất tiếc... Đã xảy ra lỗi khi gửi ý kiến phản hồi của bạn. Vui lòng thử lại.",
    "submit": "Gửi",
    "feedback_char_limit": "Đã vượt quá giới hạn ký tự.",
    "feedback_char_limit_toast_title": "Tin nhắn quá dài",
    "feedback_char_limit_toast_msg": "Tin nhắn của bạn vượt quá giới hạn tối đa 2000 ký tự.",
    "feedback_char_length_msg_1": "Bạn đã nhập",
    "feedback_char_length_msg_2": "\/2000 ký tự.",
    "feedback_empty_toast_title": "Tin nhắn trống",
    "feedback_empty_toast_msg": "Có vẻ như bạn chưa nhập gì. Hãy nhập tin nhắn trước khi gửi.",
    "feedback_email_message": "Tin nhắn:",
    "feedback_email_user_id": ", ID người dùng:",
    "feedback_email_device": ", Thiết bị:",
    "feedback_email_os_version": ", Phiên bản hệ điều hành:",
    "feedback_email_app_version": ", Phiên bản ứng dụng:",
    "savingUserToast": {
        "success": {
            "title": "Lưu thay đổi",
            "message": "Đã lưu các thay đổi với hồ sơ"
        },
        "danger": {
            "title": "Đã gặp lỗi",
            "message": "Rất tiếc... Chúng tôi đã gặp lỗi khi lưu các thay đổi của bạn. Vui lòng thử lại."
        }
    },
    "edit_profile_user_error_msg": "Vui lòng xem lại các lỗi trước khi lưu các thay đổi của bạn",
    "edit_profile_location_error": "Bạn cần chỉ định vị trí của mình",
    "edit_profile_department_error": "Bạn cần chỉ định phòng ban của mình",
    "edit_profile_unspecified_value": "Bạn cần chỉ định một giá trị",
    "edit_profile_value_too_low": "Giá trị phải lớn hơn",
    "edit_profile_value_too_high": "Giá trị phải nhỏ hơn",
    "choose_gender": "Chọn giới tính",
    "activity_tracked_successfuly": "Hoạt động của bạn đang được theo dõi",
    "multi_activity_tracked_successfully": "Các hoạt động của bạn đang được theo dõi",
    "no_activities_tracked": "Không có hoạt động nào được theo dõi",
    "track_activity_to_submit": "Chọn một ngày trên lịch để theo dõi một hoạt động",
    "last_day": "Gần đây nhất",
    "days_remaining": "ngày còn lại",
    "day_remaining": "ngày còn lại",
    "days_remaining_this_week": "ngày còn lại trong tuần này",
    "day_remaining_this_week": "ngày còn lại trong tuần này",
    "days_remaining_this_month": "ngày còn lại trong tháng này",
    "day_remaining_this_month": "ngày còn lại trong tháng này",
    "earned_today": "Kết quả hôm nay",
    "earned_this_week": "Kết quả tuần này",
    "earned_this_month": "Kết quả tháng này",
    "earned_in_total": "Tổng kết quả",
    "goal_completed": "Đã hoàn thành mục tiêu,",
    "see_results": "xem kết quả",
    "pts": "%{customPoints}",
    "of": "\/",
    "daily_goal": "Mục tiêu hàng ngày",
    "weekly_goal": "Mục tiêu hàng tuần",
    "monthly_goal": "Mục tiêu hàng tháng",
    "total_goal": "Tổng mục tiêu",
    "weeks": "tuần",
    "today": "Hôm nay",
    "this_week": "Tuần này",
    "this_month": "Tháng này",
    "overall": "Tổng",
    "level": "Cấp độ",
    "days_remaining_in_period": "Còn %{remainingDays} ngày",
    "days_left_in_period": "Còn %{remainingDays} ngày để theo dõi",
    "pointsToLevel": "Tiến độ hoàn thành %{levelName}",
    "levelCompleted": "Đã hoàn thành %{levelName}",
    "keepTrackingUntil": "Tiếp tục theo dõi cho đến",
    "activityLevelTitle": "Mức độ hoạt động của tôi",
    "activityLevelDescription": "Bạn dành bao nhiêu thời gian để vận động vừa phải - tức là khi bạn hoạt động với cường độ đủ để tăng nhịp tim và đổ mồ hôi - trong một tuần thông thường? ",
    "activityLevelUnder60": "Dưới 60 phút",
    "activityLevelUnder150": "60 - 150 phút",
    "activityLevelOver150": "Hơn 150 phút",
    "gender_male": "Nam",
    "gender_female": "Nữ",
    "gender_rather_not_say": "Không muốn chia sẻ",
    "date_of_birth": "Ngày sinh",
    "height": "Chiều cao",
    "Height": "Chiều cao",
    "weight": "Cân nặng",
    "waistCircumference": "Vòng eo",
    "bloodPressureHg": "Huyết áp tối đa",
    "bloodPressureMm": "Huyết áp tối thiểu",
    "bloodCholesterol": "Tổng lượng cholesterol trong máu",
    "ldl": "Lipoprotein tỉ trọng thấp (LDL)",
    "hdl": "Lipoprotein tỉ trọng cao (HDL)",
    "restingHeartRate": "Nhịp tim khi nghỉ ngơi",
    "percentageBodyFat": "Tỷ lệ phần trăm chất béo trong cơ thể",
    "hipCircumference": "Vòng ba",
    "bloodGlucose": "Đường huyết",
    "triglycerides": "Chất béo trung tính",
    "error_401_signed_out_message": "Phiên của bạn đã hết hạn. Vui lòng đăng nhập lại.",
    "first_name": "Tên",
    "last_name": "Họ",
    "preferred_name": "Tên ưa thích",
    "notifications": "Thông báo",
    "notificationsMarkAllReadButton": "Đánh dấu tất cả thông báo là đã đọc",
    "notificationsSettingsButton": "Cài đặt",
    "notificationsSettingsTitle": "Thông báo và email",
    "notificationEmptyMessage": "Bạn đã đọc các thông báo",
    "priorityModalTitle": "Thông báo ưu tiên của tôi",
    "remindMeLater": "Nhắc tôi sau",
    "priorityAdminTitle": "Thông báo từ quản trị viên",
    "markAsRead": "Đánh dấu là đã đọc",
    "expand": "Nhấn để mở rộng",
    "collapse": "Nhấn để thu gọn",
    "takePhoto": "Chụp ảnh mới",
    "choosePhoto": "Chọn một ảnh",
    "deletePhoto": "Xóa ảnh",
    "profileImageChangeErrorTitle": "Đã gặp lỗi",
    "profileImageChangeErrorMessage": "Rất tiếc... Đã xảy ra lỗi khi chỉnh sửa ảnh. Vui lòng thử lại.",
    "editProfile": "Chỉnh sửa hồ sơ",
    "postButton": "Đăng",
    "shareYourDayName": "Bạn đang làm gì vậy?",
    "greeting": "Chào %{firstNameDisplay}!",
    "shareAnUpdate": "Bạn đang làm gì vậy?",
    "shareYourDaySubtitle": "Bạn đang làm gì vậy?",
    "shareAPost": "Chia sẻ bài viết",
    "postVisibleTo": "Hiển thị với",
    "link": "Liên kết",
    "photo": "Ảnh",
    "insertLink": "Thêm liên kết vào bài viết của bạn",
    "save": "Lưu",
    "sampleLink": "http:\/\/sample.com",
    "shareErrorText": "Bạn cần thêm nội dung vào bài viết trước khi gửi.",
    "generalErrorTitle": "Bài viết trống",
    "generalSuccessTitle": "Thành công",
    "simplePlaceholder": "Bạn đang làm gì vậy?",
    "likesCountLabel": "Thích",
    "likesReceivedLabel": "Đã nhận lượt thích",
    "commentsCountLabel": "Bình luận",
    "commentsCountLabelSingular": "Bình luận",
    "likeButton": "Thích",
    "commentButton": "Bình luận",
    "seePreviousComments": "Xem các bình luận trước",
    "addCommentPlaceholder": "Thêm bình luận",
    "postCommentButton": "Đăng",
    "seeMoreLongComment": "Xem thêm",
    "activityPoints": "%{customPoints}",
    "activityLog": "Nhật ký hoạt động",
    "discardPost": "Hủy",
    "discardPostMessage": "Bạn có chắc chắn muốn hủy bài viết không?",
    "stream_filter_title": "Luồng",
    "stream_filter_screen_desc": "Chọn các bài viết bạn muốn xem trong luồng",
    "stream_filter_selection": "Hiển thị:",
    "moderate": "Đánh dấu là không phù hợp",
    "moderateDescription": "Khi bạn đánh dấu mục này là không phù hợp, mục này sẽ bị xóa và quản trị viên sẽ nhận được thông báo.",
    "editPost": "Chỉnh sửa bài viết",
    "deletePost": "Xóa bài viết",
    "deleteComment": "Xóa bình luận",
    "editComment": "Chỉnh sửa bình luận",
    "visibleOnlyToMe": "Chỉ hiển thị với tôi",
    "joinEvent": "Phản hồi sự kiện",
    "joinEventDetail": "Tham gia sự kiện",
    "joinedEvent": "Tôi sẽ tham gia",
    "joiningEventToast": {
        "success": {
            "title": "%{eventName}",
            "messageName": "Bạn đã tham gia sự kiện",
            "message": "Bạn đã tham gia thành công sự kiện này"
        }
    },
    "joinChallenge": "Tham gia thử thách",
    "viewChallenge": "Xem thử thách",
    "joinedChallenge": "Đã tham gia thử thách",
    "joinCommunity": "Tham gia cộng đồng",
    "joinedCommunity": "Đã tham gia cộng đồng",
    "joinProgress": "Đang tham gia",
    "joinSuccess": "Đã tham gia",
    "invitePeopleToCommunity": "Mời mọi người tham gia cộng đồng",
    "numberOfMembers": "%{num} thành viên",
    "joinToView": "Tham gia cộng đồng này để xem và đăng bài cho các thành viên khác",
    "numberOfAttendees": "%{num} người tham dự",
    "numberOfParticipants": "%{num} người tham gia",
    "numberOfMembersWithUser": "Bạn và %{num} thành viên khác",
    "numberOfAttendeesWithUser": "Bạn và %{num} người tham dự khác",
    "numberOfParticipantsWithUser": "Bạn và %{num} người tham gia khác",
    "communityMembers": "%{numberOfMembers} thành viên",
    "communityEvents": "%{numberOfEvents} sự kiện sắp diễn ra",
    "myEvents": "Sự kiện của tôi",
    "seeAll": "Xem tất cả",
    "noUpcomingEvents": "Không có sự kiện sắp diễn ra. Hãy tham gia một sự kiện!",
    "myCommunities": "Cộng đồng của tôi",
    "invitedCommunities": "Đã mời",
    "invitationSendingMessage": "Đang gửi lời mời...",
    "invitationReceivedMessage": "đã mời bạn tham gia",
    "invitationMessage": "Chúng tôi rất mong bạn sẽ tham gia cộng đồng của chúng tôi!",
    "recommendedCommunities": "Đề xuất cho bạn",
    "leaveCommunity": "Rời khỏi cộng đồng này",
    "leaveTeam": "Bạn có chắc chắn muốn rời nhóm",
    "leaveTeamLastMember": "trong thử thách này? Vì là thành viên cuối cùng của nhóm, nếu bạn rời khỏi thử thách này, nhóm sẽ bị xóa.",
    "leaveTeamChallenge": "trong thử thách này?",
    "Oops": "Rất tiếc. Đã xảy ra lỗi",
    "editCommunity": "Chỉnh sửa cộng đồng",
    "deleteCommunity": "Xóa cộng đồng này",
    "leaveCommunityDescription": "Bạn có chắc chắn muốn rời khỏi cộng đồng này không?",
    "inviteToCommunity": "Mời tham gia cộng đồng",
    "inviteByMembers": "Mời bằng tên",
    "inviteByEmail": "Mời bằng email",
    "select_person": "Vui lòng chọn ít nhất một người để mời",
    "no_users_found": "Rất tiếc… dường như chúng tôi không tìm thấy bất kỳ ai có tên đó.",
    "promptJoinCommunities": "Có vẻ như bạn vẫn chưa tham gia bất kỳ cộng đồng nào. Hãy tham gia cộng đồng để tương tác với những người khác và chia sẻ hành trình của bạn.",
    "exploreCommunities": "Khám phá cộng đồng",
    "sendInviteByMembers": "Mời %{num} người",
    "sendInviteByEmail": "Gửi lời mời qua email",
    "createNewCommunity": "Tạo cộng đồng mới",
    "createCommunity": "Tạo cộng đồng",
    "uploadCover": "Thêm ảnh",
    "cover": "Ảnh bìa",
    "nameOfCommunity": "Tên cộng đồng",
    "whatCommunityAbout": "Cộng đồng này hướng tới điều gì?",
    "companyMembersOnly": "Chỉ thành viên công ty",
    "viewAllButton": "Xem tất cả",
    "communities": "Cộng đồng",
    "contentLibrary": "Thư viện",
    "events": "Sự kiện",
    "past_events": "Sự kiện trước đây",
    "invitationCommunity": "cộng đồng",
    "searchPeople": "Tìm kiếm mọi người",
    "enterEmail": "Nhập email",
    "personalMessageToNewInvitees": "Tin nhắn cá nhân gửi cho những khách mời mới",
    "dangerToastTitle": "Lỗi",
    "dangerToastMessage": "Rất tiếc... Đã xảy ra lỗi. Vui lòng thử lại.",
    "successToastTitle": "Thành công",
    "successToastMessage": "Đã hoàn tất hành động",
    "joiningToast": {
        "success": {
            "message": "Bạn đã tham gia"
        }
    },
    "deletingCommentToast": {
        "success": {
            "message": "Đã xóa bình luận"
        }
    },
    "moderatingCommentToast": {
        "success": {
            "message": "Đã đánh dấu bình luận là không phù hợp"
        }
    },
    "editingCommentToast": {
        "success": {
            "message": "Đã cập nhật bình luận"
        }
    },
    "gettingLikesToast": {
        "success": {
            "message": "Đã cập nhật bình luận"
        }
    },
    "updatingAvatarToast": {
        "success": {
            "message": "Đã cập nhật ảnh hồ sơ"
        }
    },
    "deletingAvatarAvatarToast": {
        "success": {
            "message": "Đã xóa ảnh"
        }
    },
    "creatingStreamToast": {
        "success": {
            "title": "Đăng lên luồng",
            "message": "Bài viết của bạn đã được tạo"
        }
    },
    "editingStreamToast": {
        "success": {
            "title": "Chỉnh sửa bài viết",
            "message": "Bài viết của bạn đã được chỉnh sửa"
        }
    },
    "deletingPostToast": {
        "success": {
            "title": "Xóa bài viết",
            "message": "Bài viết của bạn đã bị xóa"
        }
    },
    "moderatingPostToast": {
        "success": {
            "title": "Đánh dấu là không phù hợp",
            "message": "Bài viết được đánh dấu là không phù hợp"
        }
    },
    "markingAllNotificationsToast": {
        "success": {
            "title": "Đánh dấu là đã đọc",
            "message": "Tất cả các thông báo được đánh dấu là đã đọc"
        },
        "info": {
            "title": "Đánh dấu là đã đọc",
            "message": "Tất cả các thông báo đã được đánh dấu là đã đọc."
        },
        "danger": {
            "title": "Đánh dấu là đã đọc"
        }
    },
    "markingNotificationToast": {
        "danger": {
            "title": "Không thể đánh dấu thông báo là đã đọc"
        }
    },
    "changePasswordToast": {
        "success": {
            "title": "Đã cập nhật mật khẩu",
            "message": "Đăng nhập bằng mật khẩu mới"
        },
        "danger": {
            "title": "Cập nhật mật khẩu",
            "message": "Rất tiếc… Đã xảy ra lỗi khi chúng tôi cố gắng cập nhật mật khẩu của bạn. Vui lòng thử lại."
        }
    },
    "joining": {
        "success": {
            "message": "Bạn đã tham gia %{name}"
        }
    },
    "invitingUsersToast": {
        "success": {
            "title": "Lời mời",
            "message": "Đã gửi (các) lời mời"
        }
    },
    "creatingCommunityToast": {
        "success": {
            "title": "Tạo cộng đồng",
            "message": "Cộng đồng mới của bạn đã được tạo"
        }
    },
    "restartingCustomGoalToast": {
        "success": {
            "message": "Mục tiêu của bạn đã được bắt đầu lại"
        },
        "danger": {
            "message": "Không thể bắt đầu lại mục tiêu"
        }
    },
    "quit": "Thoát",
    "wellbeing_survey_completed": "Đã hoàn thành bản khảo sát về sức khỏe",
    "wellbeing_survey_completed_message": "Cảm ơn bạn đã hoàn thành bản khảo sát này. Chúng tôi hy vọng rằng bản khảo sát này đã giúp bạn hiểu rõ hơn về sức khỏe của mình.",
    "update_wellbeing_score": "Cập nhật câu trả lời khả sát của tôi",
    "get_wellbeing_score": "Nhận điểm sức khỏe của bạn",
    "stats": "Số liệu thống kê",
    "my_wellbeing_score": "Điểm sức khỏe của tôi",
    "see_details": "Xem thông tin",
    "how_score_calculated": "Cách tính điểm của tôi",
    "contentTitle": "Thư viện",
    "promoted": "Nổi bật",
    "recommended": "Đề xuất",
    "recommendedForMe": "Đề xuất cho tôi",
    "recent": "Đã thêm gần đây",
    "view": "Xem",
    "added": "Đã thêm",
    "more": "khác",
    "openLibrary": "Chuyển đến thư viện",
    "readToEarn": "Đọc để nhận điểm",
    "readArticle": "Mở liên kết",
    "see_more": "Xem thêm (%{num})",
    "see_more_activities": "%{num} khác",
    "my_achievements": "Thành tích của tôi",
    "achievements": "Thành tích",
    "achievement_earned_date": "Ngày nhận: %{date}",
    "achievement_start_date": "Ngày bắt đầu: %{date}",
    "achievement_end_date": "Ngày kết thúc: %{date}",
    "achievement_earned": "Ngày nhận",
    "achievement_start": "Ngày bắt đầu",
    "achievement_end": "Ngày kết thúc",
    "achievement_earned_times": "%{num} lần",
    "achievement_earned_time": "%{num} lần",
    "in_progress": "Đang tiến hành",
    "date_earned": "Ngày nhận",
    "earned": "Ngày nhận",
    "past_dates_earned_heading": "Ngày nhận trước đây",
    "all": "Tất cả",
    "eat": "Ăn uống",
    "move": "Vận động",
    "feel": "Tinh thần",
    "profile_completion": "Hoàn tất hồ sơ: %{percentage}%",
    "complete_my_profile": "Hãy hoàn tất hồ sơ của bạn",
    "do_following_tasks": "Hãy thực hiện %{num} nhiệm vụ sau đây để hoàn tất hồ sơ.",
    "improve_my_score": "Cải thiện điểm số",
    "see_which_goals": "Xem các mục tiêu bạn đã đặt ra về việc cải thiện thói quen ăn uống, vận động và tinh thần.",
    "havent_set_goal": "Bạn chưa đặt mục tiêu.",
    "set_a_goal": "Đặt mục tiêu",
    "set_another_goal": "Đặt mục tiêu khác",
    "set_another_goal_here": "Đặt mục tiêu khác tại đây.",
    "my_recently_tracked_activities": "Hoạt động gần đây của tôi",
    "a_few_seconds_ago": "vài giây trước",
    "a_day_ago": "một ngày trước",
    "yesterday": "Hôm qua",
    "earn": "Nhận",
    "delete_activity_confirmation": "Bạn có chắc chắn muốn xóa hoạt động này không?",
    "delete_activity_title": "Xóa %{measurement} của %{activity_name}?",
    "reached_daily_goal": "Bạn đã đạt được mục tiêu của ngày hôm nay. Tốt lắm!",
    "multiple_activity_non_daily_instruction": "Nhấn vào một hàng hoạt động để bắt đầu theo dõi và nhận %{customPoints}!",
    "multiple_activity_daily_instruction": "Nhấn vào dấu cộng để theo dõi mức độ hoạt động cần thiết để đạt được mục tiêu của bạn. Nhấn vào vị trí khác bất kỳ trên hàng hoạt động để theo dõi mức độ hoạt động.",
    "only_automatic_activities": "Các hoạt động đóng góp vào mục tiêu này chỉ có thể theo dõi tự động",
    "only_automatic_activity": "Hoạt động đóng góp vào mục tiêu này chỉ có thể theo dõi tự động",
    "earn_pts_and_reach_goal": "Theo dõi %{qty} để nhận %{pts} điểm và đạt mục tiêu của bạn",
    "earn_pts_for_every": "Hãy theo dõi để nhận %{pts}",
    "you_track": "điểm!",
    "you_have_tracked": "Bạn đã theo dõi %{qty}",
    "so_far": "cho đến hiện tại!",
    "start_goal": "Đặt mục tiêu này",
    "about_this_goal": "Giới thiệu về mục tiêu này",
    "start_date": "Ngày bắt đầu",
    "end_date": "Ngày kết thúc",
    "activities": "Hoạt động",
    "goal": "Mục tiêu",
    "instructions": "Hướng dẫn",
    "daily": "Hàng ngày",
    "weekly": "Hàng tuần",
    "monthly": "Hàng tháng",
    "total": "Tổng",
    "week": "Tuần",
    "day": "Ngày",
    "days": "Ngày",
    "month": "Tháng",
    "months": "Tháng",
    "progress": "Tiến độ",
    "about": "Giới thiệu",
    "days_remaining_to_track": "Bạn còn %{num} ngày nữa để theo dõi bất kỳ hoạt động nào đã bỏ lỡ",
    "number_days": "%{num} ngày",
    "one_day": "1 ngày",
    "points_earned_this_week": "Số điểm nhận được trong tuần này",
    "points_earned_year": "Số điểm nhận được từ đầu năm đến nay",
    "completed": "Đã hoàn thành",
    "what_you_need_to_do": "Việc bạn cần làm",
    "see_all_num": "Nhìn thấy toàn bộ %{num}",
    "my_week_progress": "Tiến độ hàng tuần của bạn",
    "my_day_progress": "Tiến độ hàng ngày của bạn",
    "my_month_progress": "Tiến độ hàng tháng của bạn",
    "my_total_progress": "Tiến độ chung của bạn",
    "my_overall_progress": "Tiến độ chung",
    "you_earned": "Bạn đã nhận được",
    "of_this_week": "%{num} trong tuần này",
    "of_this_day": "%{num} trong hôm nay",
    "of_this_month": "%{num} trong tháng này",
    "of_this_total": "tổng cộng %{num}",
    "of_this_overall": "tổng thể %{num}",
    "remaining_this_week": "còn lại trong tuần này",
    "remaining_this_month": "còn lại trong tháng này",
    "remaining_this_total": "còn lại",
    "remaining_this_overall": "còn lại về tổng thể",
    "view_history": "Xem lịch sử",
    "this_goal_is": "Mục tiêu này là",
    "will_run_for": "Sẽ chạy trong",
    "button_unset_goal": "Mục tiêu chưa đặt",
    "button_leave_challenge": "Rời khỏi thử thách",
    "leaveChallenge": {
        "menu": "Rời khỏi %{challengeName}"
    },
    "deleteChallenge": {
        "menu": "Xóa %{challengeName}"
    },
    "unsetGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Bạn chưa đặt mục tiêu cá nhân này."
        }
    },
    "leaveChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Bạn đã rời khỏi thử thách."
        }
    },
    "activities_tracked": "Hoạt động đã theo dõi",
    "recently_tracked_activities": "Hoạt động đã theo dõi gần đây",
    "add": "Thêm",
    "change_before_track": "Có vẻ như bạn chưa thực hiện bất kỳ thay đổi nào. Chỉnh sửa số lượng hoạt động cho ngày này hoặc thoát mà không thực hiện thay đổi.",
    "havent_tracked_today": "Có vẻ như bạn chưa theo dõi bất kỳ hoạt động nào cho ngày này. Bắt đầu bằng cách tìm kiếm một hoạt động.",
    "cancel_tracking_quantity": "Hủy theo dõi %{quantity} %{activity_name}",
    "points": "%{customPoints}",
    "discard_activity_edits_confirmation": "Việc thoát sẽ hủy các chỉnh sửa đối với lịch sử hoạt động của bạn. Bạn có chắc không?",
    "discard_activity_edits_confirmation_date": "Việc thoát sẽ hủy các chỉnh sửa đối với lịch sử hoạt động của %{date}. Bạn có chắc không?",
    "yes_discard_edits": "Có, hãy thoát và hủy các chỉnh sửa",
    "createGoal": {
        "navigatorTitle": "Tạo mục tiêu cá nhân",
        "navigatorSubtitle": "Bước %{step}\/4"
    },
    "allCommunities": "Mọi thứ",
    "deleteCommunityDescription": "Bạn có chắc chắn muốn xóa cộng đồng này không?",
    "remaining": "còn lại",
    "recommended_goal": "Mục tiêu đề xuất",
    "pinError": "Mã PIN %{pin} không hợp lệ. Vui lòng thử lại.",
    "previousPersonalGoals": "Các mục tiêu cá nhân đã hoàn thành của tôi",
    "previousGoalsTitle": "Mục tiêu trước đây của tôi",
    "endedOn": "đã kết thúc vào",
    "achievedOfGoal": "Bạn đã hoàn thành %{num}% mục tiêu",
    "previousGoalsEmptyMessage": "Bạn không có mục tiêu trước đây",
    "emptyListDefaultMessage": "Bạn không có mục nào ở đây",
    "myCommunitiesEmpty": "Có vẻ như bạn vẫn chưa tham gia bất kỳ cộng đồng nào. Hãy tham gia cộng đồng để tương tác với những người khác và chia sẻ hành trình của bạn.",
    "discoverMoreCommunities": "Khám phá các cộng đồng khác",
    "howLong": "Khoảng thời gian",
    "frequency": "Tần suất",
    "discard": "Hủy",
    "description": "Mô tả",
    "optional": "không bắt buộc",
    "instruction": "Hướng dẫn",
    "name": "Tên",
    "create": "Tạo",
    "categories": "Danh mục",
    "uploadPhoto": "Thêm ảnh",
    "delete_goal": "Xóa %{name} này",
    "delete_goal_confirmation": "Bạn có chắc chắn muốn xóa mục tiêu này không?",
    "leave_goal_confirmation": "Bạn có chắc chắn muốn rời khỏi thử thách này không?",
    "creatingCustomGoalToast": {
        "success": {
            "message": "Mục tiêu của bạn đã được tạo."
        }
    },
    "defaultSelectMessage": "Vui lòng chọn một tùy chọn",
    "search": "Tìm kiếm",
    "inTotal": "tổng cộng",
    "State": "Tiểu bang",
    "Business unit": "Đơn vị kinh doanh",
    "Work location": "Trụ sở làm việc",
    "whenStart": "Khi nào bạn muốn bắt đầu?",
    "every": "mỗi",
    "acceptChallenge": "Chấp nhận thử thách",
    "activity_history_challenge": "Lịch sử hoạt động của thử thách",
    "havent_tracked_challenge": "Bạn chưa theo dõi bất kỳ hoạt động nào của thử thách này",
    "earned_lowercase": "ngày nhận",
    "noone_tracked_yet": "Chưa ai theo dõi bất kỳ hoạt động nào. Hãy bắt đầu theo dõi để trở thành người dẫn đầu trong cuộc thi này!",
    "you": "Bạn",
    "your_team": "Nhóm của tôi",
    "congrats_first_place": "Chúc mừng bạn đã giành vị trí cao nhất! Hãy phát huy.",
    "leader": "Người dẫn đầu",
    "average": "Trung bình",
    "show_leader": "Hiển thị người dẫn đầu",
    "show_me": "Hiển thị cho tôi",
    "show_my_team": "Hiển thị nhóm của tôi",
    "leaderboard": "Bảng xếp hạng",
    "my_team": "Nhóm của tôi",
    "remaining_to_track": "hoạt động còn lại cần theo dõi",
    "avg": "trung bình",
    "invite": "Mời",
    "team_members": "Thành viên nhóm",
    "daysLeft": "Số ngày còn lại",
    "regionNameLiveBetter": "Tiểu bang",
    "locationNameLiveBetter": "Trụ sở làm việc",
    "departmentNameLiveBetter": "Đơn vị kinh doanh",
    "regionLabelLiveBetter": "Chọn tiểu bang",
    "locationLabelLiveBetter": "Chọn địa điểm làm việc",
    "departmentLabelLiveBetter": "Chọn đơn vị kinh doanh",
    "companyLocation": "Trụ sở làm việc",
    "no_location": "Không có địa điểm",
    "connect": "Kết nối",
    "syncing": "Đồng bộ hóa",
    "sync": "Đồng bộ hóa",
    "havent_tracked_in_a_while": "Không có hoạt động đã theo dõi gần đây",
    "contact": "Liên hệ",
    "manage": "Quản lý",
    "creator": "Người tạo",
    "allow_notifications": "Quản lý thông báo",
    "enable_notifications": "Bật thông báo",
    "appload": "Chờ một chút trong khi {app_name} đang cập nhật...",
    "sendResetEmail": "Gửi email đặt lại",
    "min": "Tối thiểu",
    "max": "Tối đa",
    "error_joining_team": "Không thể tham gia nhóm",
    "cannot_add_to_team": "Rất tiếc… Đã xảy ra lỗi khi chúng tôi cố gắng thêm bạn vào nhóm này. Có thể nhóm đã đạt đến số lượng thành viên tối đa hoặc không còn tồn tại. Trong trường hợp xảy ra lỗi khác, vui lòng thử lại.",
    "members_needed": "Cần có %{num} thành viên",
    "member_needed": "Cần có %{num} thành viên",
    "spots_left": "Còn lại %{num} suất",
    "join": "Tham gia",
    "no_teams_create": "Hiện tại không có bất kỳ nhóm nào để bạn tham gia. Hãy tạo một sự kiện nào.",
    "number_teams": "%{num} nhóm",
    "youLowercase": "bạn",
    "joined_challenge_on_team": "Bạn đã tham gia một thử thách trong nhóm %{team_name}.",
    "join_team": "Tham gia nhóm",
    "former_members": "Thành viên cũ",
    "letsGo": "Bắt đầu nào",
    "invite_to_team": "Mời vào nhóm",
    "connectingDeviceToast": {
        "success": {
            "title": "Kết nối một ứng dụng hoặc thiết bị",
            "message": "Thành công! Ứng dụng hoặc thiết bị của bạn đã được kết nối."
        },
        "danger": {
            "title": "Kết nối một ứng dụng hoặc thiết bị",
            "message": "Rất tiếc… Chúng tôi đã gặp sự cố khi kết nối dịch vụ này. Vui lòng thử lại."
        }
    },
    "disconnectingDeviceToast": {
        "success": {
            "title": "Ngắt kết nối một ứng dụng hoặc thiết bị",
            "message": "Bạn đã ngắt kết nối thành công %{name}."
        },
        "danger": {
            "title": "Ngắt kết nối một ứng dụng hoặc thiết bị",
            "message": "Rất tiếc… Chúng tôi đã gặp sự cố khi ngắt kết nối %{name}. Vui lòng thử lại."
        }
    },
    "leave_entity_question": "Rời khỏi %{name}?",
    "delete_entity_question": "Xóa %{name}?",
    "leave_team_challenge_confirmation": "Bạn có chắc chắn muốn rời khỏi %{name} trong thử thách này không?",
    "leave_last_team_member": "Vì là thành viên cuối cùng của nhóm, nếu bạn rời khỏi thử thách này, nhóm sẽ bị xóa.",
    "oops_msg": "Rất tiếc... Đã xảy ra lỗi khi cố gắng hoàn thành thao tác này. Vui lòng thử lại.",
    "has_been_created": "Bạn đã tham gia một thử thách trong nhóm %{name}.",
    "specify_team_name": "Vui lòng chỉ định tên nhóm",
    "invite_members": "Mời các thành viên",
    "upload_photo_no_question": "Thêm ảnh",
    "my_progress": "Tiến độ của tôi",
    "rewardsPointsAdditionalInfo": "Nhận được %{reward_currency} khi đạt cấp độ mỗi %{period}. %{customPoints} và cấp độ của bạn sẽ làm mới mỗi %{period} để bạn có cơ hội tiếp tục nhận được %{reward_currency} ngay cả khi đã đạt đến cấp độ cao nhất vào khoảng thời gian cuối cùng.",
    "rewardsPointsInfo": "%{customPoints} và tiến độ của bạn được đặt lại mỗi %{period}.",
    "departments": "Phòng ban",
    "regions": "Khu vực",
    "noItemsSelected": "Chưa chọn mục nào",
    "pleaseSelectOne": "Vui lòng chọn ít nhất một mục trong danh sách",
    "tracked": "Đã theo dõi",
    "starts": "Ngày bắt đầu",
    "duration": "Khoảng thời gian",
    "bonus": "Phần thưởng",
    "invited_by": "Người mời",
    "create_team": "Tạo nhóm",
    "discardConfirmation": "Bạn có chắc bạn muốn thoát không?",
    "discardYes": "Có",
    "discardStay": "Quay lại",
    "create_team_toast_title": "Tạo nhóm",
    "edit_team": "Chỉnh sửa nhóm",
    "team_edits_submitted": "Nhóm của bạn đã được cập nhật.",
    "challenge_ended_still_trackable": "%{type} đã kết thúc, thật may bạn còn %{num} ngày nữa để theo dõi!",
    "tracking_period_ended": "Thời gian theo dõi cho %{type} này đã kết thúc.",
    "unlimited": "Không giới hạn",
    "ends_in": "Thời gian kết thúc",
    "challenge_toast": {
        "success": {
            "join": "Thành công!",
            "message": "Bạn đã tham gia thử thách thành công."
        },
        "danger": {
            "error": "Lỗi",
            "message": "Đã xảy ra lỗi. Hãy thử tham gia lại thử thách sau một thời gian ngắn."
        }
    },
    "members_to_invite": "Thành viên cần mời",
    "members_to_remove": "Thành viên cần xóa",
    "myChallenges": "Cuộc thi",
    "upcoming": "Sắp diễn ra",
    "myPersonalGoals": "Mục tiêu",
    "companyCompetitions": "Cuộc thi của công ty",
    "communityCompetitions": "Cuộc thi cộng đồng",
    "edit_your_team": "Chỉnh sửa nhóm",
    "emails": "Email",
    "CompletedOverall": "Nhìn chung đã hoàn thành",
    "TotalEarned": "Tổng điểm nhận được",
    "notify_header": "Tôi muốn nhận thông báo:",
    "AdditionalBonus": "Phần thưởng khác",
    "goalEndedNotification": "Mục tiêu đã kết thúc, hãy tiếp tục phát huy nhé!",
    "compEndedNotification": "Cuộc thi đã kết thúc, hãy tiếp tục phát huy nhé!",
    "congrats_tracking_first": "Chúc mừng bạn đã theo dõi hoạt động đầu tiên của mình!",
    "keep_tracking": "Tiếp tục theo dõi hoạt động của bạn để đạt được mục tiêu và lên cấp.",
    "understanding_tracking": "Tìm hiểu về hoạt động theo dõi",
    "cannot_track_this_day": "Bạn không thể theo dõi vào ngày này.",
    "nothing_tracked_this_day": "Bạn chưa theo dõi ngày này.",
    "tracked_something_this_day": "Bạn đã theo dõi hoạt động nào đó vào ngày này.",
    "reached_goal_this_day": "Bạn đã đạt được mục tiêu cho ngày này (chỉ dành cho mục tiêu hàng ngày).",
    "got_it": "OK!",
    "notDismissedMultiTitle": "Tóm tắt thử thách",
    "notDismissedMultiSubtitle": "Một vài thử thách đã kết thúc. Hãy xem xét kỹ hơn từng thử thách để biết chi tiết về cách bạn đã thực hiện. ",
    "daySummary": "%{userName}, dưới đây là tóm tắt về ngày của bạn cho đến nay",
    "goals": "Mục tiêu",
    "competitions": "Cuộc thi",
    "totalAccumulated": "Tổng tích lũy",
    "tracking_for_date": "Theo dõi cho %{date}",
    "activity_tracker_instruction": "Nhấn để chỉnh sửa hoặc xóa hoạt động được theo dõi thủ công",
    "ended": "Đã kết thúc",
    "notYetAvailableBeta": "Chưa có bản beta",
    "suggestedGoal": "Mục tiêu đề xuất",
    "singleFor": "cho",
    "seeLessLongComment": "Ẩn bớt",
    "synced_data": "Dữ liệu đã đồng bộ hóa:",
    "doThisLater": "Tôi sẽ thực hiện sau",
    "inviteUsers": "Mời những người khác tham gia",
    "cannotTrackAfterDeadline": "Bạn đang cố gắng theo dõi hoạt động của một ngày sau thời hạn thử thách.",
    "potentialBonusPoints": {
        "section": {
            "title": "Hoàn thành mục tiêu này để được thưởng %{potentialBonusPoints} %{customPoints}!",
            "titleNotCompleted": "Bạn đã không được thưởng %{potentialBonusPoints} %{customPoints} khi đạt %{activitytCompletedPercentage}%.",
            "titleCompleted": "Xin chúc mừng! Bạn đã được",
            "titleCompletedBold": "thưởng %{potentialBonusPoints} %{customPoints}!",
            "subtitle": "Tìm hiểu thêm về phần thưởng %{customPoints}"
        },
        "modal": {
            "title": "Phần thưởng %{customPoints}",
            "desc1": "Chúng tôi biết rằng không ai là hoàn hảo và không thể lúc nào cũng hoàn thành mục tiêu của mình.",
            "desc2": "Đó là lý do chúng tôi thưởng %{customPoints} khi bạn đạt tiến độ chung từ 85% trở lên.",
            "desc3": "Bạn sẽ nhận được toàn bộ phần thưởng %{customPoints} sau khi hoàn thành mục tiêu. Ngoài ra, nếu theo dõi từ một ứng dụng hoặc thiết bị được kết nối, bạn sẽ nhận được thưởng gấp đôi %{customPoints}!",
            "desc4": "Bạn sẽ không được thưởng %{customPoints} nếu bỏ dở mục tiêu."
        },
        "msg": {
            "title": "Mục tiêu này đã kết thúc",
            "subtitle": "Mục tiêu đã kết thúc vào %{goalEndedDate}"
        },
        "msgEnded": {
            "title": "Hết giờ! Mục tiêu của bạn đã kết thúc",
            "subtitle": "Bạn còn %{daysNum} %{daysOrDay} để theo dõi hoạt động."
        }
    },
    "finish": "Kết thúc",
    "personalGoal": {
        "all_goals": {
            "selected": "Đã đặt xong tất cả %{maxGoals} thử thách!",
            "description": "Mục tiêu này có như ý bạn muốn không? Nếu đổi ý, bạn có thể thay thế bất kỳ mục tiêu nào. Đừng lo, bạn sẽ có thể hủy đặt mục tiêu vào lúc khác.",
            "set": "Đã đặt xong tất cả mục tiêu!",
            "action": "Đã xong, hãy bắt đầu nào!",
            "error": "Đừng dàn trải! Chỉ tập trung vào tối đa 3 mục tiêu có cấu trúc cùng một lúc để tăng khả năng thành công.",
            "errorHeading": "Đặt mục tiêu"
        },
        "set_more": "Bạn có thể đặt %{maxGoals} thử thách hoạt động nữa",
        "select_goal": {
            "heading": "Đặt mục tiêu đề xuất hoặc tạo mục tiêu của riêng bạn"
        },
        "set_more_1": "Bạn có thể đặt thêm 1 mục tiêu hoạt động"
    },
    "restartPersonalGoal": "Bắt đầu lại bằng các mục tiêu mới",
    "delete_challenge_confirmation": "Bạn có chắc chắn muốn xóa thử thách này không?",
    "personal_goal_unit": "mục tiêu",
    "personal_goal_units": "mục tiêu",
    "day_summary": {
        "steps_taken": "Các bước thực hiện",
        "calories_in": "Lượng calo nạp vào",
        "calories_out": "Lượng calo đốt cháy",
        "avg_daily": "trung bình hàng ngày",
        "most_earned_daily": "số điểm cao nhất một ngày"
    },
    "invitedBy": "Do %{person} mời",
    "resetPasswordMissingField": "Vui lòng nhập một email",
    "resetPasswordInvalidValue": "Vui lòng nhập một địa chỉ email hợp lệ",
    "resetPasswordNotFound": "Không tìm thấy email của bạn",
    "resetPasswordNotCompleted": "Không thể hoàn thành yêu cầu của bạn",
    "resetGoalInstructions": {
        "start": "Hãy %{activity} %{quantity} %{units}",
        "additional": ", %{activity} %{quantity} %{units}",
        "end": "%{frequency} để nhận được %{points} %{customPoints} %{frequency}"
    },
    "goalSet": {
        "one": "Đã đặt 1 mục tiêu. Xem",
        "two": "Đã đặt 2 mục tiêu. Xem",
        "three": "Đã đặt 3 mục tiêu. Xem",
        "none": "Chưa đặt mục tiêu. Đặt mục tiêu"
    },
    "searchCommunitiesEmpty": "Không tìm thấy cộng đồng nào",
    "searchCommunitiesPlaceholder": "Tìm kiếm cộng đồng",
    "updating": "Đang cập nhật...",
    "pts_tracked": "Đã theo dõi %{activityName} - %{num} %{customPoints}",
    "improving_wellbeing_score": "Hãy tiếp tục phát huy, bạn đang từng bước cải thiện điểm sức khỏe của mình.",
    "progressHistory": "Lịch sử tiến độ",
    "privateCommunity": "Đây là cộng đồng riêng tư",
    "do_combo_of_activities": "Hãy kết hợp các yếu tố sau đây.",
    "noActivitiesTracked": "Không có hoạt động nào được theo dõi",
    "trackingWithFollowingApps": "Theo dõi bằng các ứng dụng\/thiết bị sau đây",
    "recommendedApps": "Ứng dụng\/thiết bị được đề xuất cho %{challengeType} này",
    "collapseWord": "Thu gọn",
    "started": "Đã bắt đầu",
    "ends": "Ngày kết thúc ",
    "do_activities": "Thực hiện hoạt động",
    "rewards_placeholder": "Ví dụ về phần thưởng từ cửa hàng, phần giữ chỗ. Người dùng sẽ thấy các sản phẩm khác nhau mà họ có thể mua và chi phí bằng %{rewardName}.",
    "personalGoals": {
        "top": {
            "label": "Trên cùng"
        },
        "allGoals": "Tất cả các mục tiêu",
        "seeMoreCard": {
            "heading": "Bạn không tìm thấy mục tiêu mình muốn ư?",
            "description": "Hãy xem tất cả các mục tiêu đề xuất",
            "button": "Khám phá mục tiêu"
        }
    },
    "rewardsNotAvailable": "Bản beta này hiện không có phần thưởng. Khi có, bạn sẽ có thể xem danh mục và hoàn thành việc đổi thưởng.",
    "editProfileProvideRestingHeartRate": "Vui lòng cung cấp giá trị nhịp tim khi nghỉ ngơi hợp lệ, tối thiểu là 40",
    "liveBetterHealthInfo": "Chúng tôi tổ chức một số chương trình, thiết kế nhiều nội dung về sức khỏe để đáp ứng một loạt các nhu cầu về sức khỏe và giúp bạn cải thiện sức khỏe của mình. Dù chưa có chương trình đáp ứng mọi nhu cầu và tình trạng về sức khỏe, nhưng chúng tôi đang nỗ lực phát triển các chương trình này! - tuy nhiên, nếu bạn trả lời các câu hỏi sau đây, chúng tôi sẽ liên hệ với bạn nếu tìm được bất kỳ chương trình hoặc dịch vụ y tế nào mang lại lợi ích cho bạn khi tham gia và\/hoặc gửi cho bạn thông tin đã được chứng thực để bạn hiểu rõ hơn và quản lý các nhu cầu sức khỏe của mình. Xin lưu ý rằng chúng tôi không sử dụng thông tin này để đánh giá tính phù hợp của chính sách áp dụng cho bạn. Nếu muốn tìm hiểu về chương trình bảo hiểm hoặc thắc mắc về chính sách, bạn có thể gọi cho nhóm Kết nối khách hàng của chúng tôi theo số 132 331.",
    "deleteGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Bạn đã xóa mục tiêu"
        }
    },
    "deleteChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Bạn đã xóa thử thách"
        }
    },
    "invitations": "Lời mời",
    "learnMorePeriods": "Tìm hiểu thêm về các khoảng thời gian",
    "tracked_by_app_name": "Theo dõi bằng %{app_name}",
    "device_required": {
        "text": "%{challengeType} này cần có ứng dụng hoặc thiết bị",
        "button": "Kết nối một ứng dụng hoặc thiết bị"
    },
    "editingCommunityToast": {
        "success": {
            "title": "Chỉnh sửa cộng đồng",
            "message": "Cộng đồng đã được chỉnh sửa"
        }
    },
    "competition": "Cuộc thi",
    "close": "Đóng",
    "only_automatic_activities_with_device": "Các hoạt động của %{goal_or_competition} này được tự động theo dõi bằng ứng dụng\/thiết bị đã kết nối của bạn.",
    "only_automatic_activity_with_device": "Hoạt động của %{goal_or_competition} này được tự động theo dõi bằng ứng dụng\/thiết bị đã kết nối của bạn.",
    "deletingCommunityToast": {
        "success": {
            "title": "%{name}",
            "message": "Cộng đồng đã bị xóa"
        }
    },
    "teamSizeMessage": "Nhóm của bạn cần ít nhất %{min} người thì mới nhận được %{customPoints} khi thực hiện thử thách.",
    "captain": "Trưởng nhóm",
    "inviteOthersToTeam": "Mời những người khác vào nhóm của tôi",
    "loadingMetrics": "Đang kết nối với các nguồn để cập nhật ngày của bạn...",
    "aboutTeamSize": {
        "title": "Quy mô nhóm",
        "text": "%{min} - %{max}"
    },
    "pointsOverview": "Tổng quan về %{customPoints}",
    "deepLinks": {
        "requestCouldNotBeCompleted": "Không thể hoàn thành yêu cầu của bạn",
        "error": "Lỗi"
    },
    "required_lc": "bắt buộc",
    "personal": "Thông tin cá nhân",
    "biometrics": "Sinh trắc học",
    "makeSelection": "Lựa chọn",
    "ask_question_success_msg": "Cảm ơn bạn. Chúng tôi sẽ trả lời ngay khi có thể.",
    "report_issue_success_msg": "Cảm ơn bạn. Chúng tôi sẽ trả lời ngay khi có thể.",
    "ask_question_success_title": "Đã gửi câu hỏi",
    "report_issue_success_title": "Đã gửi thông tin về sự cố kỹ thuật",
    "ask_question_failure_msg": "Rất tiếc... Đã xảy ra lỗi khi gửi ý kiến câu hỏi của bạn. Vui lòng thử lại.",
    "report_issue_failure_msg": "Rất tiếc... Đã xảy ra lỗi khi báo cáo sự cố của bạn. Vui lòng thử lại.",
    "notTrackedActivities": "Bạn chưa theo dõi bất kỳ hoạt động nào của khoảng thời gian này",
    "learn": "Tìm hiểu",
    "Balance": "Số dư",
    "details": "Chi tiết",
    "Reward": "Phần thưởng",
    "levelsReset": "Đã đặt các cấp độ trong %{remainingDays} ngày",
    "redeem": "Đổi thưởng",
    "redeemAt": "Đổi thưởng khi đạt %{points}",
    "needPointsToRedeem": "Bạn cần %{points} %{rewardName} nữa.",
    "learnEarnMore": "Tìm hiểu cách nhận được nhiều điểm hơn",
    "currency": "SproutBucks",
    "joiningTeamChallengeToast": {
        "success": {
            "title": "Tham gia nhóm",
            "message": "Bạn đã tham gia thành công nhóm này!"
        },
        "danger": {
            "message": "Chúng tôi đã gặp lỗi và không tìm thấy nhóm. Nhóm này có thể không còn tồn tại."
        }
    },
    "NoMatchingDeepLinkToast": {
        "danger": {
            "title": "Không có hành động",
            "message": "Không thể hoàn thành yêu cầu của bạn."
        }
    },
    "transactionLog": "Giao dịch",
    "orderHistory": "Đơn hàng",
    "pointsAvailableToEarn": "Có %{points} để nhận",
    "missedYTD": "Đã bỏ lỡ %{missed} từ đầu năm đến nay",
    "rewardsDetails": "Phần thưởng",
    "successfullyRedeemedItem": "Bạn đã đổi thành công món hàng này",
    "orderNumber": "Số đơn hàng",
    "amountSpent": "Số tiền chi tiêu",
    "status": "Trạng thái",
    "dateRedeemed": "Ngày đổi thưởng",
    "additionalInformation": "Thông tin bổ sung",
    "shipToAddress": "Vận chuyển đến địa chỉ này",
    "pointMissedYearToDate": "Đã bỏ lỡ %{rewardCurrencyName} trong năm nay",
    "pointMissedYearToDateDescription": "Nếu bạn không lên cấp trước khi khoảng thời gian kết thúc, chúng tôi sẽ xem như bạn bỏ lỡ cơ hội nhận được %{rewardCurrencyName}.",
    "NoLibraryContentToast": {
        "info": {
            "title": "Không tìm thấy bài viết",
            "message": "Không tìm thấy bài viết. Bài viết này có thể đã bị xóa hoặc không còn tồn tại."
        }
    },
    "CommunityNotFoundToast": {
        "danger": {
            "title": "Không tìm thấy cộng đồng",
            "message": "Không tìm thấy cộng đồng. Bài viết này có thể đã bị xóa hoặc không còn tồn tại."
        }
    },
    "shippingAddress": "Địa chỉ giao hàng\/thanh toán",
    "enterShippingAddress": "Nhập địa chỉ giao hàng\/thanh toán của bạn",
    "streetLine": "Đường %{num}",
    "stateProvince": "Tiểu bang\/Tỉnh",
    "postcodePostalcodeZip": "Mã bưu điện\/Mã bưu chính\/Mã zip",
    "phoneNumber": "Số điện thoại",
    "order": "Đơn hàng",
    "redemptionConfirmation": "Xác nhận đổi thưởng",
    "edit": "Chỉnh sửa",
    "processing": "Đang xử lý",
    "checkIsYouFirst": "Trước tiên, chúng tôi cần kiểm tra xem đó có phải bạn không",
    "discardSomeGoals": "Bạn đã đặt một số mục tiêu. Những mục tiêu này sẽ bị loại bỏ nếu bạn tiếp tục.",
    "settingGoalsToast": {
        "success": {
            "message": "Mục tiêu mới của bạn đã được thiết lập!"
        }
    },
    "one_team": "1 nhóm",
    "noAchievementsToEarnMessage": "Có vẻ như không còn huy hiệu nào để nhận được %{rewardCurrencyName} trong khoảng thời gian này.",
    "shopRewards": "Mua sắm phần thưởng",
    "validateShippingAddressToast": {
        "danger": {
            "title": "Địa chỉ giao hàng\/thanh toán",
            "message": "Vui lòng hoàn thành tất cả các trường trước khi tiếp tục."
        }
    },
    "viewDetails": "Xem chi tiết",
    "potential": "Tiềm năng",
    "missed": "Đã bỏ lỡ",
    "rewardsStoreNotAvailable": "Hiện không có cửa hàng phần thưởng nào dành cho bạn.",
    "havent_tracked_in_a_while_date": "Chưa theo dõi hoạt động nào vào %{currentDate}",
    "challengeNotFoundToast": {
        "danger": {
            "title": "Không tìm thấy thử thách",
            "message": "Không tìm thấy thử thách. Bài viết này có thể đã bị xóa hoặc không còn tồn tại."
        }
    },
    "shareYourDaySubtitleActivity": "Thêm hình ảnh hoặc chia sẻ điều gì đó về hoạt động này!",
    "goal_ended": "Mục tiêu đã kết thúc",
    "challenge_ended": "Thử thách đã kết thúc",
    "day_remaining_to_track": "Bạn có 1 ngày để theo dõi bất kỳ hoạt động nào đã bỏ lỡ",
    "challengeGoalCardSubtitleEndDate": "%{challengeOrGoal} đã kết thúc vào %{endDate}",
    "goalEndedModal": {
        "title": "Theo dõi hoạt động bỏ quên",
        "message": "Sau khi mục tiêu hoặc thử thách cá nhân kết thúc, bạn có 3 ngày kể từ ngày kết thúc để theo dõi bất kỳ hoạt động nào mà mình có thể bỏ quên. Sau khoảng thời gian gia hạn này, bạn không thể theo dõi bất kỳ hoạt động nào khác đóng góp vào mục tiêu hoặc thách thức."
    },
    "summary": "Tóm tắt",
    "placedRank": "Bạn đạt thứ hạn %{rank}\/%{total}",
    "rank": {
        "first": "Thứ nhất",
        "second": "Thứ hai",
        "third": "Thứ ba",
        "n": "Thứ %{rank}"
    },
    "event_name": "Tên sự kiện",
    "this_is": "Đây là  ",
    "location_info": "Vị trí và thông tin",
    "what_event": "Nội dung của sự kiện này",
    "event_is": "Đây là sự kiện",
    "start_on": "Ngày bắt đầu:",
    "end_on": "Ngày kết thúc:",
    "location": "Vị trí",
    "chooseLeaderboard": "Chọn bảng xếp hạng",
    "filterOneOfFollowing": "Lọc ra một trong các lựa chọn sau đây",
    "showChallengeInstead": "Hiển thị thử thách",
    "showActivityInstead": "Hiển thị hoạt động",
    "showAll": "Hiển thị tất cả",
    "activitiesShowSame": "Hoạt động: %{activityName}",
    "challengeShowSame": "Thử thách: %{challengeName}",
    "chooseTimePeriod": "Chọn một khoảng thời gian",
    "youCanFilterOneAtTime": "Bạn có thể chọn một bộ lọc mỗi lần",
    "saveHealthTopicsToast": {
        "success": {
            "message": "Đã lưu chủ đề về sức khỏe",
            "title": "Thành công!"
        },
        "info": {
            "message": "Không thể lưu"
        },
        "danger": {
            "title": "Lỗi!"
        }
    },
    "saveHealthObjectivesToast": {
        "success": {
            "message": "Đã lưu mục tiêu sức khỏe",
            "title": "Thành công!"
        },
        "info": {
            "message": "Không thể lưu"
        },
        "danger": {
            "title": "Lỗi!"
        }
    },
    "saveInterestGroupsToast": {
        "success": {
            "message": "Đã lưu sở thích",
            "title": "Thành công!"
        },
        "info": {
            "message": "Không thể lưu"
        },
        "danger": {
            "title": "Lỗi!"
        }
    },
    "edit_event": "Chỉnh sửa sự kiện",
    "leave": "Rời khỏi",
    "delete_event": "Xóa sự kiện",
    "no_events": "Không có sự kiện",
    "no_events_placeholder": "Bạn hiện không có kế hoạch tham dự bất kỳ sự kiện nào trong tương lai. Hãy tham gia một sự kiện thôi nào.",
    "event": "sự kiện  ",
    "challenge": "Thử thách",
    "invited_you": "Đã mời bạn",
    "public": "Công khai",
    "private": "Riêng tư",
    "deleteEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Đã xóa thành công sự kiện."
        }
    },
    "leaveEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Bạn đã rời khỏi sự kiện"
        }
    },
    "editEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Đã cập nhật sự kiện thành công."
        }
    },
    "createEventToast": {
        "success": {
            "message": "Đã tạo thành công sự kiện.",
            "title": "%{eventName}"
        }
    },
    "contentIsDeletedOrInappropriate": "Nội dung bạn đang muốn xem hiện không có. Nội dung này có thể đã bị tác giả xóa hoặc bị đánh dấu là không phù hợp.",
    "start_time": "Thời gian bắt đầu",
    "end_time": "Thời gian kết thúc",
    "event_type": "Sự kiện %{eventType}",
    "leave_event_modal": {
        "title": "Nếu bạn rời khỏi sự kiện này",
        "message": "Sự kiện này sẽ bị xóa"
    },
    "leave_event ": "Bạn có chắc chắn muốn rời khỏi sự kiện này không?",
    "create_event": "Tạo sự kiện",
    "created_by": "Người tạo",
    "eventActionToast": {
        "danger": {
            "title": "Lỗi",
            "message": "Đã xảy ra lỗi. "
        }
    },
    "continue": "Tiếp tục",
    "wantExitTour": "Bạn có chắc chắn muốn thoát khỏi phần hướng dẫn không?",
    "exitTour": "Thoát khỏi phần hướng dẫn",
    "deleveEventPopup": "Bạn có chắc chắn muốn xóa sự kiện này không?",
    "attendeesTitle": "Người tham dự",
    "userEvents": "Sự kiện của %{name}",
    "createEventIndicator": "Tạo sự kiện",
    "inviteToEvent": "Mời tham gia sự kiện",
    "noDescription": "Không có nội dung mô tả.",
    "leaderboardIsEmpty": "Bảng xếp hạng này trống hoặc bạn có thể cần theo dõi hoạt động trong khoảng thời gian đã chọn để xem được bảng xếp hạng này",
    "notParticipantingInAnyChallenges": "Bạn không tham gia bất kỳ thử thách nào",
    "buttonLeaveEvent": "Rời khỏi sự kiện",
    "leaveEvent ": "Rời khỏi %{name}?",
    "canceledCreatingChallenge": "Đã hủy thành công quá trình tạo %{challengeType}",
    "swipeReadNotification": "Đọc",
    "productTour": {
        "initialScreen": {
            "title": "Chào mừng bạn đến với %{programName}!",
            "body": "Hãy xem hướng dẫn và bạn sẽ biết nắm được những thông tin cơ bản sau giây lát."
        },
        "dashboard": {
            "title": "Bảng xếp hạng",
            "body": "Hãy số %{pointsName} bạn có và tiến độ hoàn thành cấp độ của bạn. Sau đó, hãy xem bảng xếp hạng để biết thứ hạng của bạn."
        },
        "rewards": {
            "title": "Phần thưởng",
            "body": "Xem số %{rewardPointName} bạn có và đổi thưởng tại cửa hàng."
        },
        "goals": {
            "title": "Mục tiêu và thử thách",
            "body": "Bạn có thể tìm thấy các mục tiêu cá nhân hoạt động, thử thách với những người khác và các nhiệm vụ đặc biệt tại đây."
        },
        "explore": {
            "title": "Khám phá",
            "body": "Tìm thử thách với những người khác, tham gia cộng đồng để thảo luận về sở thích của bạn và khám phá một bài viết mới trong thư viện sức khỏe."
        },
        "me": {
            "title": "Tôi",
            "body": "Tìm điểm sức khỏe của bạn, xem số liệu thống kê, chỉnh sửa hồ sơ và chế độ cài đặt của bạn tại đây."
        },
        "finishScreen": {
            "title": "Đã xong",
            "body": "Cảm ơn bạn đã hoàn thành phần hướng dẫn này.",
            "button": "Hãy bắt đầu nào!"
        },
        "skip": {
            "title": "Bạn có chắc chắn muốn bỏ qua phần hướng dẫn không?",
            "body": "Thao tác này sẽ kết thúc phần hướng dẫn và bạn có thể bắt đầu ngay."
        }
    },
    "getTemporaryRewardRedemptionTokenToast": {
        "danger": {
            "title": "Lỗi xác thực",
            "message": "Không thể tiếp tục đổi phần thưởng. Đã xảy ra lỗi khi xác thực với nhà cung cấp phần thưởng."
        }
    },
    "rewardRedemptionFailureToast": {
        "danger": {
            "title": "Không đổi thưởng được",
            "message": "%{displayMessage}"
        }
    },
    "disclamerSectionTitle": "Trước khi bạn bắt đầu",
    "disclamerSectionMessage": "Liên hệ với chuyên gia chăm sóc sức khỏe của bạn trước khi bắt đầu bất kỳ chương trình thể dục mới nào hoặc thực hiện thay đổi lối sống để đảm bảo điều đó phù hợp với bạn.",
    "noEarchedAchievements": "Bạn chưa đạt được bất kỳ thành tích nào. Theo dõi một hoạt động để bắt đầu.",
    "noInProgressAchievements": "Bạn không có thành tích nào đang thực hiện.",
    "discardCreatingEventMessage": "Đảm bảo rằng bạn đã điền vào mọi trường bắt buộc",
    "discardCreatingEventTitle": "Không thể tạo sự kiện",
    "discardEditedEventTitle": "Không thể chỉnh sửa sự kiện",
    "errorEventNameMessage": "Cần nhập tên",
    "errorEventStartDateMessage": "Cần nhập ngày bắt đầu",
    "errorEventEndDateMessage": "Cần nhập ngày kết thúc",
    "errorEventDateMessage": "Ngày kết thúc không được sớm hơn ngày bắt đầu",
    "noAccountsToLink": "Không có tài khoản nào để liên kết với %{program_name}.",
    "accountLinkEmailChanged": "Địa chỉ email của bạn đã được cập nhật. Về sau, hãy đăng nhập bằng tài khoản bạn đã liên kết.",
    "accountLinkSuccessful": "Tài khoản của bạn đã được liên kết thành công.",
    "edit_profile_nan_value": "Giá trị phải là một số",
    "advancedLogIn": "Đăng nhập nâng cao",
    "redemptionSessionExpiredToast": {
        "danger": {
            "title": "Không đổi thưởng được",
            "message": "Phiên đặt hàng đã hết hạn. Vui lòng thử đặt hàng lại."
        }
    },
    "left": "đã rời khỏi",
    "eventsCarousel": {
        "emptyEvent": {
            "prompt": "Có vẻ như hiện không có sự kiện nào để tham gia. Hãy tạo một sự kiện nào."
        }
    },
    "reachedHighestLevel": "Bạn đã đạt đến cấp độ cao nhất!",
    "error": "Lỗi",
    "redeemRewardSuccessfulToast": {
        "success": {
            "title": "Đổi phần thưởng",
            "message": "Đơn hàng của bạn đã được đặt"
        }
    },
    "redeemRewardComplete": "Hoàn tất đổi thưởng",
    "trackActivityTitle": {
        "oneUnit": "Theo dõi: 1 %{unit} %{activity} vào %{date}",
        "nUnit": "Theo dõi: %{activity} vào %{date}"
    },
    "ssoAuthenticationFailure": "Lỗi xác thực",
    "earnEvery": "Nhận mỗi %{frequency}",
    "earnOnce": "Chỉ nhận một lần",
    "goalSettings": {
        "maximumSet": "Bạn hiện đã đặt tối đa 3 mục tiêu.",
        "learnMore": "Tìm hiểu thêm về cách đặt mục tiêu"
    },
    "allowMarketingComms": "Gửi cho tôi nội dung quảng cáo",
    "allowPartnerMarketingComms": "Gửi cho tôi nội dung quảng cáo từ đối tác",
    "noUpcomingAchievements": "Bạn không có thành tích nào sắp tới.",
    "settingGoalToast": {
        "success": {
            "message": "Mục tiêu mới của bạn đã được đặt!"
        }
    },
    "authentication": {
        "saml": {
            "error": "Dịch vụ hiện không dùng được",
            "signin": "Quy trình đăng nhập tích hợp",
            "signup": "Quy trình đăng ký tích hợp"
        }
    },
    "monthName": {
        "january": "Tháng 1",
        "february": "Tháng 2",
        "march": "Tháng 3",
        "april": "Tháng 4",
        "may": "Tháng 5",
        "june": "Tháng 6",
        "july": "Tháng 7",
        "august": "Tháng 8",
        "september": "Tháng 9",
        "october": "Tháng 10",
        "november": "Tháng 11",
        "december": "Tháng 12"
    },
    "promotedForMe": "Nổi bật",
    "appRating": {
        "enjoying": "Bạn có thích ứng dụng của chúng tôi không?",
        "feedback": "Bạn có muốn đóng góp ý kiến không?",
        "appStore": "Xếp hạng chúng tôi trên App Store?",
        "googlePlay": "Xếp hạng chúng tôi trên Google Play?",
        "notReally": "Không hẳn vậy",
        "yes": "Đúng vậy!",
        "sure": "Chắc chắn rồi",
        "noThanks": "Không, xin cảm ơn",
        "notNow": "Lúc khác"
    },
    "getMobileApp": "Để dùng %{programName} trên điện thoại thông minh, hãy tải %{appStoreName} xuống từ App Store hoặc Google Play.",
    "newAppsDevicesDesign": {
        "getMobileApp": "Tải ứng dụng %{programName} xuống",
        "searchInAppStore": "Tìm kiếm %{programName} trong cửa hàng ứng dụng trên thiết bị của bạn",
        "getMobileAppNoName": "Tải ứng dụng di động"
    },
    "editorAlert": {
        "discardChanges": "Hủy thay đổi",
        "saveAndContinue": "Lưu lại và tiếp tục",
        "title": "Các thay đổi chưa lưu",
        "text": "Một số thay đổi bạn thực hiện chưa được lưu. Bạn muốn làm gì?"
    },
    "resources": "Tài nguyên",
    "noResources": "Không có tài nguyên nào",
    "viewAllResources": "Xem tất cả tài nguyên",
    "language": "Ngôn ngữ",
    "eventStarted": "Đã bắt đầu sự kiện. Đã hết thời gian đăng ký.",
    "Gender": "Giới tính",
    "show": "Hiển thị",
    "hide": "Ẩn",
    "timeoutError": "Rất tiếc! Mất quá nhiều thời gian chờ. Vui lòng thử lại sau.",
    "SOT": {
        "sample_task": "Nhiệm vụ mẫu"
    },
    "cache": {
        "new_version": "Hiện đã có phiên bản mới!",
        "refresh_browser": "Bấm vào đây để làm mới trình duyệt."
    },
    "welcomeUser": "Chào mừng bạn %{userFirstName}!",
    "quarter": "quý",
    "completionReward": "Phần thưởng hoàn thành",
    "bronzeLevel": "Cấp độ đồng",
    "deviceAppSyncingOk": "Đồng bộ hóa thiết bị\/ứng dụng thành công",
    "deviceAppSyncingIssue": "Sự cố đồng bộ hóa thiết bị\/ứng dụng",
    "deviceAppSyncingError": "Lỗi đồng bộ hóa thiết bị\/ứng dụng",
    "lastSync": "Lần đồng bộ hóa gần đây nhất",
    "period": "khoảng thời gian",
    "yourDaySummary": "Ngày của bạn cho đến hiện tại",
    "steps": "Bước",
    "gender_non_binary": "Phi nhị giới hoặc không theo tiêu chuẩn giới",
    "take_survey": "Tham gia khảo sát",
    "social": "Xã hội",
    "finalDay": "Ngày cuối cùng",
    "leaderboard_position": "Vị trí trên bảng xếp hạng",
    "signUp": {
        "apple": {
            "disconnectSettings": "Ngắt kết nối %{appName} khỏi \"Bảo mật & Mật khẩu ID Apple\" trong phần Cài đặt điện thoại để tiếp tục đăng ký"
        }
    },
    "earnPoints": "Nhận %{customPoints}. Lên cấp.",
    "getReward": "Nhận %{rewardName}.",
    "buildHealthyHabits": "Xây dựng thói quen lành mạnh.",
    "highestLevelIndicator": "Bạn đã đạt đến cấp độ cao nhất!",
    "highestLevelIndicatorNew": "Bạn đã hoàn thành mọi cấp độ!",
    "trackYourActivity": "Để nhận được %{customPoints}, hãy theo dõi hoạt động tập thể dục và sức khỏe của bạn.",
    "levelUpToGetRewarded": "Khi lên cấp, bạn sẽ được thưởng %{bonusName}.",
    "levelUpAndEarn": "Tiến độ của bạn sẽ được đặt lại sau mỗi %{period}, vì vậy bạn có thể lên cấp và đạt được nhiều điểm hơn.",
    "levelUp": "Tiến độ của bạn sẽ được đặt lại sau mỗi %{period}, vì vậy bạn có thể lên nhiều cấp hơn.",
    "goToLibrary": "Chuyển đến thư viện",
    "updateEventIndicator": "Cập nhật sự kiện",
    "meTour": {
        "healthSurveyDisabled": "Xem số liệu thống kê, chỉnh sửa hồ sơ và chế độ cài đặt của bạn tại đây."
    },
    "createNewGoal": "Tạo mục tiêu mới",
    "later": "Lúc khác",
    "bonusChallenge": "Thử thách thưởng",
    "bonusChallengeInfo": {
        "withReward": "Bạn sẽ được thưởng %{amount} %{points} khi hoàn thành ít nhất 85% %{challengeType} này.",
        "noReward": "Bạn sẽ được thưởng khi hoàn thành ít nhất 85% thử thách này.",
        "boldText": "Phần thưởng %{amount} %{points}",
        "noRewardChallengeType": "Bạn sẽ được thưởng khi hoàn thành ít nhất 85% %{challengeType} này."
    },
    "defaultApp": "Ứng dụng sức khỏe mặc định",
    "bonusGoal": {
        "additionalInfo": "Nếu tất cả hoạt động của bạn được theo dõi bằng ứng dụng hoặc thiết bị đã kết nối, bạn sẽ được thưởng gấp đôi %{points}!",
        "additionalInfoNew": {
            "paragraph2": "Bạn sẽ được thưởng %{points} sau khi hoàn thành mục tiêu. Bạn sẽ không được thưởng %{points} nếu bỏ dở mục tiêu."
        },
        "boldText": "được thưởng gấp đôi %{points}!",
        "markTitle": "Mục tiêu thưởng"
    },
    "notify_me": "Thông báo cho tôi",
    "bonusChallengeReward": "Phần thưởng thử thách",
    "forCompletingChallenge": "Khi hoàn thành %{challengeName}",
    "notifications_text": "Thông báo giúp bạn bám sát mục tiêu của mình và cập nhật các cuộc trò chuyện.",
    "type_here": "Nhập vào đây",
    "bonusEarned": "Đã nhận phần thưởng",
    "youEarnedBonus": "Bạn đã nhận được phần thưởng này!",
    "inviteOthersToChallenge": "Mời những người khác tham gia thử thách",
    "inviteOthersToYourTeam": "Mời những người khác vào nhóm của bạn",
    "manageTeam": "Quản lý nhóm",
    "ft": "ft",
    "lbs": "lbs",
    "cm": "cm",
    "kg": "kg",
    "community": "cộng đồng",
    "chooseActivity": "Chọn hoạt động",
    "Recent": "Gần đây",
    "noActivities": "Không có hoạt động nào phù hợp",
    "photoChooseText": "Chọn",
    "photoCancelText": "Hủy",
    "signIn": {
        "missingEmail": "Thiếu địa chỉ email",
        "missingPassword": "Hãy nhớ cung cấp mật khẩu",
        "invalidLogin": "Lượt đăng nhập không hợp lệ",
        "accountLocked": "Tài khoản của bạn đã bị khóa. Vui lòng liên hệ với quản trị viên",
        "accountMayNotExist": "Chúng tôi không có tài khoản cho địa chỉ email này. Hãy đăng ký để tạo một tài khoản.",
        "wrongPassword": "Sai mật khẩu. Hãy thử lại hoặc nhấp vào Quên Mật Khẩu để cài đặt lại."
    },
    "deleteGoalBonusPoints": "Nếu chưa nhận được phần thưởng liên quan, bạn sẽ không thể làm điều này nữa.",
    "havent_tracked_goal": "Bạn chưa theo dõi bất kỳ hoạt động nào của mục tiêu này",
    "trackActivity": {
        "search": "Tìm kiếm hoạt động...",
        "text": "Theo dõi hoạt động",
        "done": "Xong",
        "discardChanges": "Hủy thay đổi?",
        "discardMessage": "Bạn có chắc chắn muốn thoát và hủy tiến độ của mình không?",
        "discard": "Bỏ đi",
        "limitMessage": "Bạn chỉ có thể theo dõi tối đa 7 ngày cùng một lúc.",
        "inputDescription": "Mức độ %{activity} vào %{date}",
        "gracePeriod": "Bạn có %{n} %{text} để theo dõi bất kỳ hoạt động nào đã bỏ lỡ"
    },
    "dates": "Ngày",
    "pickDates": "Chọn các ngày khác",
    "selectDates": "Chọn ngày",
    "limitReached": "Bạn đã đạt đến giới hạn",
    "activity": "Hoạt động",
    "keepUpTheGoodWork": "Hãy phát huy!",
    "activityTracked": "Hoạt động đã theo dõi",
    "new": "Mới",
    "newFeatureTitle": "Theo dõi hoạt động dễ dàng hơn, nhanh hơn",
    "newFeatureText": "Cho dù bạn đang theo dõi hoạt động của ngày hôm nay, trong quá khứ hay trong nhiều ngày, chúng tôi nghĩ rằng bạn sẽ thích trải nghiệm mới.",
    "gotIt": "OK!",
    "frequencyViewHistory": "Xem dữ liệu chia nhỏ %{frequency}",
    "challengeDetails": {
        "trackTheseActivities": "Hãy theo dõi bất kỳ hoạt động nào trong số này để hoàn thành %{challengeType}."
    },
    "member": "thành viên",
    "weeklyBreakdown": "Dữ liệu chia nhỏ hàng tuần",
    "setGoals": {
        "earnPointsText": {
            "start": "Nhận",
            "end": "khi đặt mục tiêu đầu tiên!"
        }
    },
    "weeklyGoalEnded": "Tuần kết thúc vào",
    "weekFinished": "Bạn đã hoàn thành một tuần",
    "restartGoal": {
        "daysLeftToTrack": "Bạn vẫn có %{quantity} %{days} để theo dõi bất kỳ tiến độ nào bạn bỏ quên từ tuần trước.",
        "weekEnded": "Tuần này đã kết thúc.",
        "timesUp": "Hết giờ!",
        "period": {
            "title": "Khoảng thời gian hoàn thành mục tiêu",
            "text": "Thứ Hai đến Chủ Nhật, hàng tuần"
        }
    },
    "membersPlural": "Thành viên",
    "startedADayAgo": "Đã bắt đầu 1 ngày trước",
    "goalRestarted": "Bạn đã bắt đầu lại mục tiêu này",
    "weeklyGoals": "Mục tiêu hàng tuần",
    "weeklyGoalsDescription": "Mục tiêu hàng tuần sẽ tự gia hạn vào thứ Hai hàng tuần. Vì vậy, bạn có thể duy trì thói quen lành mạnh trong một thời gian dài.",
    "challengeEnded": "%{challengeType} này đã kết thúc",
    "goalEndedModalTitle": "Hết giờ! %{challengeType} của bạn đã kết thúc!",
    "yourProgress": "Tiến độ của bạn",
    "earn_withRewards": "Theo dõi hoạt động lành mạnh của bạn để kiếm được (%{pts}) và vượt qua các cấp độ. Khi lên cấp, bạn sẽ nhận được %{currency}.",
    "earn_noRewards": "Suivez votre exercice et votre activité de bien-être pour gagner (%{pts}) et passer au niveau supérieur.",
    "currentPeriod": "Khoảng thời gian hiện tại",
    "currentScore": "Điểm hiện tại",
    "viewActivityLog": "Xem nhật ký hoạt động",
    "balanceHistory": "Lịch sử số dư của tôi",
    "mymedibank": {
        "underAge": {
            "error": "Ứng dụng Live Better chỉ dành cho người dùng từ 18 tuổi trở lên. Vui lòng tham khảo Điều khoản & Điều kiện của Live Better để biết thêm thông tin."
        }
    },
    "enhancedHomePageInfo": "Chúng tôi đã cải tiến Trang chủ! Giờ đây, việc xem các thử thách và mục tiêu của bạn trở nên dễ dàng hơn. Đã đến lúc phải theo dõi!",
    "levelUpTitle": "Lên cấp",
    "levelUpDescription": "Hãy theo dõi các hoạt động, cũng như hoàn thành các mục tiêu và thử thách để lên cấp. Khi lên cấp, bạn sẽ được thưởng %{currency}!",
    "achievementsDescription": "Mở khóa các huy hiệu đặc biệt này để nhận được %{currency}. Nhấp vào huy hiệu để biết bạn cần làm gì.",
    "bonusChallengesDescription": "Tham gia và hoàn thành các thử thách tặng thưởng %{currency}.",
    "earnWithPartners": {
        "title": "Thành công nhờ đối tác",
        "description": "Các thành viên Medibank có bảo hiểm bệnh viện hoặc bổ sung có thể nhận được điểm khi thực hiện giao dịch mua\/hoạt động đủ điều kiện với các đối tác."
    },
    "browseAllPartners": "Duyệt qua tất cả các đối tác",
    "resetsIn": "Đặt lại sau %{daysNumber} ngày",
    "thisIsALot": "Thực sự nhiều đó!",
    "areYouSure": "Bạn có chắc không?",
    "trackingALotMessage": {
        "days": "Bạn đang theo dõi hơn 2.000 %{customPoints} trong %{daysNum} ngày. Khá nhiều đó!",
        "day": "Bạn đang theo dõi hơn 2.000 %{customPoints} trong 1 ngày. Khá nhiều đó!"
    },
    "amSure": "Tôi chắc chắn",
    "activeMinutesAndSleep": {
        "title": "Theo dõi bằng thiết bị để biết số phút hoạt động và giấc ngủ",
        "description": "Thiết bị của bạn ghi lại số phút hoạt động khi bạn hoạt động thể chất với cường độ trung bình hoặc cao - đây là bài tập có chất lượng tốt! Sử dụng thiết bị để theo dõi giấc ngủ của bạn? Khi đó, bạn cũng sẽ nhận được %{points}!"
    },
    "hourShort": "giờ",
    "hoursShort": "giờ",
    "secondsShort": "giây",
    "watchToEarn": "Xem để nhận điểm",
    "oneParticipant": "1 người tham gia",
    "oneTeam": "1 nhóm",
    "numberOfTeams": "%{num} nhóm",
    "inviteToYourTeam": "Mời vào nhóm của bạn",
    "inviteToThisChallenge": "Mời tham gia thách thức này",
    "challengeInstructionText": "Theo dõi hoạt động này để dần hoàn thành %{challengeType}.",
    "showLess": "Ẩn bớt",
    "startsTomorrow": "Bắt đầu vào ngày mai",
    "deadlineDayLeft": "số ngày còn lại",
    "deadlineDaysLeft": "số ngày còn lại",
    "deviceBonus": "phần thưởng thiết bị",
    "appsAndDevices": {
        "header": "Ứng dụng và thiết bị",
        "linked": "Các ứng dụng và thiết bị được liên kết này đang theo dõi %{challengeType}:",
        "noLinked": "Hiện chưa có ứng dụng hoặc thiết bị thích hợp nào được liên kết",
        "link": "Hãy liên kết điện thoại, đồng hồ hoặc ứng dụng của bạn để theo dõi tự động."
    },
    "yourGoals": "Mục tiêu của bạn",
    "yourChallenges": "Thử thách của bạn",
    "position": "Vị trí",
    "team_success": "Thành công của nhóm",
    "starts_in": "Thời gian bắt đầu",
    "team_challenge": "Thử thách của nhóm",
    "your_progress_today": "Tiến độ của bạn hôm nay",
    "your_daily_avarage": "Mức trung bình hàng ngày của bạn là",
    "this_week_progress": "Tiến độ của tuần này",
    "this_month_progress": "Tiến độ của tháng này",
    "overall_progress": "Tiến độ chung",
    "complete": "hoàn thành",
    "overallSuccess": "Thành công chung",
    "teamSuccessAverage": "Tỷ lệ thành công trung bình của nhóm",
    "progressDetails": "Chi tiết tiến độ",
    "dayStreak": "Khoảng thời gian %{n} ngày!",
    "weekStreak": "Khoảng thời gian %{n} tuần!",
    "dailyProgress": "Tiến độ hàng ngày",
    "participantsSuccessCount": {
        "overall": "%{amount}\/%{total} người tham gia đã đạt được mục tiêu",
        "day": "%{amount}\/%{total} người tham gia đã đạt được mục tiêu hôm nay",
        "week": "%{amount}\/%{total} người tham gia đã đạt được mục tiêu trong tuần này",
        "month": "%{amount}\/%{total} người tham gia đã đạt được mục tiêu trong tháng này"
    },
    "doubleBonusShort": "Thưởng gấp đôi!",
    "doubleBonusLong": "Bạn đã được thưởng gấp đôi!",
    "recommendedGoalDescription": "Mục tiêu giúp bạn theo dõi tiến độ của mình và luôn có động lực!",
    "noParticipation": "Không có ai tham gia",
    "nothingToShow": "Có vẻ như hiện không có gì để hiển thị",
    "yourTeam": "Nhóm của bạn",
    "no_activity_title": "Không có hoạt động nào",
    "brandSupport": {
        "description": "Chúng tôi đã hỗ trợ thêm tính năng đồng bộ hóa hoạt động với đồng hồ thông minh Polar và Withings. Đã đến lúc vận động rồi!"
    },
    "no_tracked_activities": "Bạn chưa theo dõi bất kỳ hoạt động nào.",
    "button_leave_community": "Rời khỏi cộng đồng",
    "button_delete_challenge": "Xóa %{challengeType}",
    "button_delete_community": "Xóa cộng đồng",
    "button_delete_activity": "Xóa hoạt động",
    "library_header_description": "Nội dung gốc để hướng dẫn, thu hút và truyền cảm hứng cho bạn trong hành trình chăm sóc sức khỏe bản thân.",
    "library_searchbar": "Tìm kiếm trong thư viện…",
    "library_page_header": "Nội dung gốc để hướng dẫn, thu hút và truyền cảm hứng cho bạn trong hành trình chăm sóc sức khỏe bản thân.",
    "onboarding_button_title": "Đã xong",
    "refresh_bar": "Nhấp vào đây để cập nhật",
    "content": {
        "min_read": "%{readingTime} phút đọc"
    },
    "noMembers": "Không có thành viên nào",
    "saved": "Đã lưu",
    "forYou": "Dành cho bạn",
    "min read (Note: min as in minutes)": "",
    "send me program related email notifications": "",
    "send me weekly email updates": "",
    "you can earn this bade once every quarter": "",
    "badgeInstruction": "%{badgeInstruction} muộn nhất vào",
    "youCanEarnThisBadge": "Kiếm được huy hiệu này mỗi lần %{period}",
    "emailPreferences": "Tùy chọn email",
    "unsubscribeText": "Chọn không nhận tất cả các thông tin cập nhật qua email",
    "savingText": "Đang lưu...",
    "wrongTryLater": "Đã xảy ra lỗi. Vui lòng thử lại sau.",
    "preferencesSaved": "Đã lưu các tùy chọn",
    "recommendedForYou": "Đề xuất cho bạn",
    "formerMember": {
        "label": "Thành viên cũ"
    },
    "selectionsFromLibrary": "Các lựa chọn dành riêng cho bạn trong thư viện của chúng tôi để giúp bạn",
    "goalsInfo": {
        "desc1": "tập trung vào việc cải thiện sức khỏe của bạn.",
        "desc2": "Bạn đã đặt số mục tiêu tối đa."
    },
    "createMyOwn": "Tạo mục tiêu của riêng bạn",
    "isAllSet": "đã hoàn thành!",
    "undoLabel": "Hoàn tác",
    "terms": "Điều khoản",
    "placeOrder": "Đặt hàng",
    "item": "Mặt hàng",
    "redeemFor": "Đổi lấy",
    "confirmYourOrder": "Xác nhận đơn đặt hàng của bạn",
    "orderComplete": "Đã đặt hàng xong",
    "redeemedFor": "Đã đổi lấy",
    "orderDetails": "Chi tiết đơn đặt hàng",
    "bonusGoalReward": "Phần thưởng cho mục tiêu thưởng",
    "orderSummary": "Tóm tắt đơn đặt hàng",
    "logoutSSO": {
        "title": "Bạn đã đăng xuất khỏi %{programName}.",
        "description": "Hẹn gặp lại bạn sớm!",
        "signinAgain": "Nhấn vào đây để đăng nhập lại"
    },
    "nothing_to_show": "Hiện chưa có nội dung nào để hiển thị",
    "no_saved_content": "Bạn chưa lưu nội dung nào",
    "restarts_every_week": "Bắt đầu lại hàng tuần",
    "myGoals": "Mục tiêu của tôi",
    "goalGallery": "Thư viện mục tiêu",
    "share_smth": "Chia sẻ điều gì đó…",
    "newFeatureModal": {
        "smartGoal": {
            "title": "Mục tiêu số bước của chúng tôi ngày càng thông minh hơn!",
            "description": "Các tuần của bạn luôn khác nhau - và mục tiêu của bạn bây giờ cũng vậy! \n Với Chế độ thông minh, mục tiêu số bước của bạn sẽ tự điều chỉnh dựa trên hoạt động trong đời thực của bạn.\n Chế độ được thiết lập ưu tiên sự thành công và khỏe mạnh của bạn.",
            "action": "Hãy dùng thử chế độ này!"
        },
        "mePage": {
            "title": "Tôi mới",
            "description": "Chúng tôi đã thiết kế lại phần Tôi để giúp bạn tìm thấy những điều bạn quan tâm dễ dàng hơn – hãy khám phá!",
            "letsSeeBtn": "Hãy xem nào!",
            "llaterBtn": "Có lẽ sau này"
        },
        "bellEAP": {
            "title": "Chào mừng bạn đến với nền tảng trực tuyến của Chương Trình Hỗ Trợ Gia Đình và Nhân Viên của bạn!",
            "description": "Khám phá các công cụ và dịch vụ có thể hỗ trợ những thách thức về sức khỏe cũng như trong cuộc sống dành cho bạn và các thành viên gia đình đủ điều kiện của bạn",
            "button": "Kết nối ngay bây giờ hoặc truy cập trang Liên Kết Nhanh bất cứ khi nào"
        },
        "quickActivityLogView": {
            "title": " Một cách nhanh hơn để xem hoạt động gần đây của bạn",
            "description": "Bây giờ bạn có thể nhấp vào thanh tiến trình để xem nhật ký hoạt động của mình."
        }
    },
    "goalSmartMode": {
        "title": "Chế độ thông minh",
        "description": "Nhận các mục tiêu hàng tuần được cá nhân hóa dựa trên mức độ hoạt động gần đây của bạn.",
        "status": "Chế độ thông minh là %{status} cho mục tiêu này.",
        "infoModal": {
            "descriptionOne": "Khi Chế độ thông minh được bật, mục tiêu đặt ra cho mục tiêu này sẽ thay đổi hàng tuần dựa trên mức độ hoạt động gần đây của bạn.",
            "descriptionTwo": "Chúng tôi sẽ thử thách bạn với số lượng vừa phải để giúp bạn thành công.",
            "instructions": ""
        },
        "settings": {
            "switch": "Bật Chế Độ Thông Minh cho mục tiêu số bước của tôi",
            "description": "Khi Chế Độ Thông Minh được kích hoạt, bạn sẽ nhận được mục tiêu số bước mới vào đầu mỗi tuần."
        },
        "enableSmartMode": "Kích Hoạt Chế Độ Thông Minh",
        "settingsModal": {
            "descriptionTurnOn": "Mục tiêu số bước của bạn sẽ thay đổi hàng tuần dựa trên hoạt động của bạn",
            "descriptionTurnOff": "Mục tiêu số bước của bạn sẽ không còn được cá nhân hóa hàng tuần nữa"
        }
    },
    "On": "Bật",
    "Off": "Tắt",
    "top_posts": "Bài đăng nổi bật nhất",
    "most_recent": "Gần đây nhất",
    "browseByTopic": "Tham khảo theo chủ đề",
    "video": "Video",
    "enable": "Bật",
    "turnOff": "Tắt",
    "new_post": "Bài viết mới",
    "new_post_in": "Bài đăng mới trong",
    "dailyTarget": "Mục tiêu hàng ngày",
    "dailyTargetForWeek": "Mục tiêu hàng ngày trong tuần",
    "showMyActivityLog": "Hiển thị nhật ký hoạt động của tôi",
    "usersReacted": {
        "oneOther": "%{userName} và 1 người khác",
        "multipleOthers": "%{userName} và %{count} người khác"
    },
    "reactionsModal": {
        "title": "Nhiều cách khác để ăn mừng",
        "description": "Cổ vũ đồng nghiệp của bạn bằng những phản ứng mới trên bài đăng trên mạng xã hội!"
    },
    "account": "Tài khoản",
    "myWellbeingProfile": "Hồ sơ sức khỏe của tôi",
    "physicalDetailsDescription": "Thông tin này là cần thiết để tính điểm phúc lợi của bạn",
    "wellbeingInterests": "Sở thích phúc lợi",
    "myWellbeingInterests": "Sở thích sức khỏe của tôi",
    "preferredNameOptional": "Tên ưa thích (tùy chọn)",
    "basicPhysicalDetails": "Chi tiết vật lý cơ bản",
    "notRegistered": {
        "infoModal": {
            "title": "Chúng tôi không thể tìm thấy bạn",
            "notInSystem": "trong hệ thống của chúng tôi.",
            "correctEmail": "Hãy đảm bảo rằng bạn sử dụng đúng tài khoản (thường là địa chỉ email của công ty) và kiểm tra lỗi chính tả.",
            "emailHelp": "Để được nhận thêm trợ giúp, hãy gửi email cho nhóm hỗ trợ của chúng tôi tại"
        }
    },
    "dontHaveAccount": "Không có tài khoản?",
    "wasThisHelpful": "Có hữu ích không?",
    "healthScoreFeedbackModal": {
        "emojiSection": "Trang này và điểm số sức khỏe của bạn có hữu ích như thế nào?",
        "commentSectionText": "Làm thế nào để có thể được cải thiện?",
        "commentSectionPlaceholder": "Thêm bình luận...",
        "thankYouModal": "Cảm ơn phản hồi của bạn!"
    },
    "number_connected": "%{numDevices} đã kết nối",
    "searchPlaceHolder": "Tìm kiếm...",
    "noTeamsFound": "Không tìm thấy đội nào",
    "join_a_challenge": "Tham gia thử thách",
    "me_page_titles": {
        "goal": {
            "singular": "mục tiêu",
            "plural": "mục tiêu"
        },
        "challenge": {
            "singular": "thử thách",
            "plural": "các thử thách"
        }
    },
    "seeMoreText": "…xem thêm",
    "adjust_entry": "Xin vui lòng điều chỉnh dữ liệu nhập vào.",
    "overTracking": {
        "title": "Cảnh báo theo dõi quá mức",
        "desc1": {
            "singular": "Dữ liệu nhập vào này sẽ được kiểm tra.",
            "plural": "Các dữ liệu nhập vào này sẽ được kiểm tra."
        },
        "desc2": "Việc cố ý theo dõi quá mức có thể dẫn đến việc đình chỉ tài khoản.",
        "button_edit": "Chỉnh sửa dữ liệu nhập vào của tôi",
        "button_confirm": "Gửi nguyên trạng"
    },
    "oneEventAttendee": "1 người tham dự",
    "multipleEventAttendees": "%{num} những người tham dự",
    "to": "đến",
    "eventBonusFull": "Bạn sẽ kiếm được %{number} bonus %{points} điểm khi tham gia sự kiện này.",
    "eventBonusBold": "%{number} bonus %{points}",
    "didYouLikeArticle": "Bạn có thích bài viết này không?",
    "didYouLikeVideo": "Bạn có thích video này?",
    "tellUsMore": "Hãy cho chúng tôi biết thêm...",
    "thanksForFeedback": "Cảm ơn phản hồi của bạn!",
    "challengesSubtitle": "Đạt được mục tiêu cùng với những người tham gia khác—hoặc chơi để giành chiến thắng!",
    "appStoreNameSprout": "Sprout at Work",
    "appStoreNameLiveBetter": "Medibank Live Better",
    "appStoreNameTelus": "Sức Khỏe An Sinh TELUS",
    "huaweiStoreUrlSprout": "https:\/\/appgallery.huawei.com\/app\/C104993765",
    "telusHealthVirtualCare": "Chăm Sóc Sức Khỏe Trực Tuyến Telus",
    "virtualCare": "Chăm Sóc Sức Khỏe Trực Tuyến",
    "changePassword": {
        "telus": {
            "info": "Mật khẩu của bạn được quản lý thông qua tài khoản %{telusVC} của bạn.",
            "button": "Thay đổi mật khẩu %{virtualCare} của tôi"
        }
    },
    "actions": "hành động",
    "onAndUpcoming": "Đang và sắp tới",
    "termsAndPrivacyPolicyNew": "Bằng cách tiếp tục, bạn đồng ý với",
    "invitedToTeam": "Được mời vào đội của %{firstName} %{lastName}",
    "decline": "Từ chối",
    "invitedToChallenge": "Được mời bởi %{firstName} %{lastName}",
    "goalsCard": {
        "emptyStateTitle": "Bạn chưa đặt ra mục tiêu nào"
    },
    "huaweiStoreUrlTelus": "https:\/\/appgallery.huawei.com\/app\/C107357173",
    "challengesCard": {
        "emptyStateTitle": "Bạn không tham gia bất kỳ thử thách nào",
        "buttonLabel": "Khám phá các thử thách"
    },
    "menu": "Danh mục",
    "everyone": "Mọi người",
    "confirmEmployeeID": "Xác Nhận ID của Nhân Viên",
    "employeeIDNoMatch": "Những ID này chưa khớp",
    "hidePost": "Ẩn bài đăng bởi %{ownerName}",
    "hidingUserPostToast": {
        "success": {
            "title": "Người Sử Dụng Đã Được Giấu Đi",
            "message": "Bạn sẽ không nhìn thấy bài đăng của người sử dụng này nữa."
        }
    },
    "moderateHideUserDescription": "Ẩn bài đăng của người sử dụng này sẽ xóa các nội dung cụ thể của người sử dụng khỏi các bài đăng trực tuyến.",
    "startsInOneDay": "Bắt đầu sau 1 ngày",
    "endsInOneDay": "Kết thúc sau 1 ngày",
    "endsToday": "Kết thúc ngày hôm nay",
    "hrisEmployeeID": {
        "infoModal": {
            "notInSystem": "không có trong hệ thống của chúng tôi. Bạn đã nhập đúng chưa?",
            "administrator": "Nếu bạn là nhân viên mới, chúng tôi có thể chưa có ID nhân viên của bạn. Xin vui lòng hỏi quản trị viên của bạn về thời điểm có thể thử lại.",
            "emailNotInSystem": "Nếu bạn là nhân viên mới, email của bạn có thể chưa được cập nhật vào hệ thống của chúng tôi. Xin vui lòng hỏi quản trị viên của bạn về thời điểm có thể thử lại.",
            "eligibleEmail": "địa chỉ email không hợp lệ. Bạn đã nhập đúng chưa?"
        }
    },
    "oneMember": "1 thành viên",
    "programCode": {
        "infoModal": {
            "unique": "Công ty của bạn có một mã chương trình đặc biệt thường được gửi cho bạn qua email.",
            "support": "Nếu bạn không thể tìm thấy mã của mình, hãy liên hệ với quản trị viên chương trình chăm sóc sức khỏe của bạn hoặc gửi email tới support@sproutatwork.com kèm theo tên công ty của bạn."
        },
        "instructions": "Nhập mã chương trình do nhà tuyển dụng của bạn cung cấp để bắt đầu"
    },
    "whatsMyProgramCode": "Mã chương trình của tôi là gì?",
    "enjoyApp": "Tận hưởng ứng dụng di động của chúng tôi",
    "programCodeLabel": "Mã chương trình",
    "createdByMembersChallenges": "Được thiết lập bởi các thành viên",
    "invites": "Mời",
    "recommendedContentTitle": "Các lựa chọn thư viện cho bạn",
    "amountExchanged": "Số lượng trao đổi",
    "orderStatus": "Tình trạng đơn đặt hàng",
    "orderSuccessfulyyItemForConfirmation": "Đặt hàng thành công! Một xác nhận đã được gửi đến %{email}.",
    "orderedOnDateText": "Đặt hàng vào lúc %{orderCreatedTime}",
    "personalize": {
        "communities": {
            "title": "Tham gia cộng đồng",
            "description": "Cộng đồng kết nối những người có chung sở thích. Bạn có thể tham gia hoặc rời khỏi các cộng đồng bất cứ lúc nào."
        },
        "objectives": {
            "title": "Mục tiêu của tôi",
            "description": "Chúng tôi có thể giúp bạn bắt đầu hoặc duy trì những điều gì? Chúng tôi sẽ sử dụng điều này để cải thiện các đề xuất của mình."
        },
        "topics": {
            "title": "Chủ đề sức khỏe của tôi",
            "description": "Bạn sẽ tìm thấy nhiều lời khuyên và nội dung hướng dẫn hơn về những lựa chọn này."
        }
    },
    "recommendedCardDesc": "Có thể đặt tối đa 3 mục tiêu để tập trung vào việc cải thiện sức khỏe của bản thân",
    "accessibility": {
        "track_activity": "Theo dõi hoạt động",
        "cardbody": "Đầu Trang Thẻ",
        "cardcontainer": "Nội Dung Thẻ",
        "cardfooter": "Cuối Trang Thẻ",
        "unstartedChallengeHeader": "Thử Thách Chưa Bắt Đầu",
        "activeOrEndedChallengeWrapper": "Kết Thúc Thử Thách",
        "activeOrEndedChallengeHeader": "Tiêu Đề Thử Thách",
        "goalHeader": "Tiêu Đề Mục Tiêu",
        "openOptions": "Mở tùy chọn"
    },
    "teams": {
        "teamInvites": "Lời mời nhóm",
        "findTeam": "Tim một nhóm",
        "teamFull": "Nhóm đã đủ người"
    },
    "deleteAccountText": "Xóa vĩnh viễn tài khoản Sprout At Work của bạn và tất cả các dữ liệu trong đó",
    "deleteAccountButtonTitle": "Xóa tài khoản của tôi",
    "joinTeamActionSheetText": "Tham gia hoặc tạo một nhóm để tham gia thử thách này",
    "frequencyNone": "không có",
    "quickLinkTitle": "Các liên kết nhanh",
    "moreTab": "Khác",
    "addedBy": "%{companyName} đã thêm vào",
    "teamsTitle": "Các nhóm",
    "helpAndSupport": "Trợ giúp và hỗ trợ ứng dụng",
    "feedbackTitle": "Ý kiến phản hồi",
    "feedbackDescription": "Hãy cho chúng tôi biết những điều bạn thích về ứng dụng, và những gì chúng tôi có thể cải thiện.",
    "leaveTeamAction": "Rời khỏi nhóm",
    "teamActions": "Các hoạt động của nhóm",
    "leaveTeamLeaveChallenge": "Việc rời khỏi nhóm này đồng nghĩa với việc bạn rời khỏi thử thách. Bạn sẽ cần phải tham gia một nhóm để được tiếp tục tham gia.",
    "familyMembers": "Thành viên gia đình",
    "familyMembersDescription": "Các thành viên trong gia đình phải trên 16 tuổi. Họ sẽ có toàn quyền truy cập và khả năng hiển thị trên toàn bộ nền tảng.",
    "learnMoreButton": "Tìm Hiểu Thêm",
    "thvcSelection": {
        "signUpUsingTelus": "Đăng ký bằng tài khoản Chăm Sóc Sức Khỏe Trực Tuyến TELUS của bạn",
        "loginGetStarted": "Đăng nhập vào Chăm Sóc Sức Khỏe Trực Tuyến để bắt đầu",
        "haveAccount": "Bạn có tài khoản Chăm Sóc Sức Khỏe Trực Tuyến không?",
        "emailHelp": "Cần giúp đỡ? Hãy liên hệ với nhóm hỗ trợ của chúng tôi tại",
        "yes": "Có",
        "signMeUp": "Không, đăng ký cho tôi"
    },
    "inviteFamilyMember": {
        "label": "Mời thành viên gia đình",
        "btn": "Gửi Lời Mời",
        "email": "Địa chỉ email*",
        "firstName": "Tên*",
        "lastName": "Họ*",
        "approval": "Tôi xác nhận rằng tôi có quyền mời thành viên gia đình này vào %{company}",
        "multiSelect1": "Thành viên gia đình này có trên độ tuổi trưởng thành ở khu vực của bạn hay không?",
        "multiSelect2": "Thành viên gia đình này đã ít nhất tròn 16 tuổi hay chưa?",
        "confirmTermsPolicy": "Tôi xác nhận rằng tôi là người giám hộ hợp pháp của người này. Theo quan điểm của tôi, người được bảo hộ đã đủ tuổi trưởng thành để đồng ý sử dụng nền tảng và tôi đồng ý cho họ tham gia nền tảng đó. Tôi sẽ giải thích cho người được bảo hộ về yêu cầu ứng xử có trách nhiệm trên nền tảng cũng như cách nền tảng thu thập và sử dụng dữ liệu của họ.",
        "onTheirBehalf": "thay mặt họ.",
        "confirm": "Có, tôi xác nhận những điều trên",
        "warning": "Thành viên gia đình phải ít nhất tròn 16 tuổi để được phép đăng ký",
        "errorMsg": "Xin vui lòng xem lại lỗi trước khi cố gắng tiếp tục"
    },
    "deleteFamilyMember": {
        "desc": "Việc xóa tài khoản của thành viên gia đình có tác dụng vĩnh viễn.",
        "btn": "Xóa thành viên gia đình",
        "confirmation": {
            "title": "Thành viên gia đình đã bị xóa",
            "desc": "Tài khoản của %{fullName} đã bị xóa"
        },
        "areYouSure": "Bạn có chắc chắn muốn xóa tài khoản của %{fullName} không?"
    },
    "familyInvitationStatus": {
        "active": "Đang hoạt động",
        "sent": "Đã gửi lời mời"
    },
    "familyInvitationSent": {
        "title": "Đã gửi email mời",
        "desc": "Lời mời đã được gửi tới %{fullName}"
    },
    "programCodeSignup": "Xin vui lòng sử dụng %{programCodeLabel} %{programCode} sau khi nhấp vào '%{signUpLabel}'",
    "notJoinedCommunityLabel": "Tham gia cộng đồng này để xem những gì các thành viên đang chia sẻ",
    "moda": {
        "installApp": {
            "title": "Xin lưu ý: Thành viên Moda Health chỉ có thể truy cập Sprout at Work thông qua Bảng điều khiển thành viên của họ.",
            "subtitle": "Để sử dụng chương trình Sprout at Work trên điện thoại thông minh của bạn:",
            "stepOneA": "1. Cài đặt ứng dụng di động Sprout at Work.",
            "stepOneB": "Không đăng ký hoặc đăng nhập trên ứng dụng di động.",
            "stepTwo": "2. Đăng nhập vào Bảng điều khiển thành viên trên điện thoại di động của bạn",
            "stepThree": "3. Duyệt đến chương trình chăm sóc sức khỏe Sprout và nhấp vào liên kết đó - ứng dụng di động Sprout at Work sẽ mở ra."
        }
    },
    "HRISLocationSelection": {
        "title": "Bạn làm việc ở nước nào?"
    },
    "visibilitySettings": {
        "title": "Cài đặt hiển thị",
        "desc1": "Bạn có thể hiển thị cho các thành viên ứng dụng Wellbeing khác trong công ty của mình không?",
        "desc2": "Bạn luôn có thể thay đổi điều này sau.",
        "moreTextQ1": "Người khác có thể nhìn thấy gì?",
        "moreTextAnswer1": "Những người trong công ty của bạn có thể nhìn thấy tên, ảnh hồ sơ và các chi tiết cơ bản về hồ sơ (như bộ phận và địa điểm). Điều này làm cho ứng dụng trở nên xã hội và thú vị hơn.",
        "moreTextQ2": "Tôi xuất hiện ở đâu?",
        "moreTextAnswer2": "Bạn sẽ được hiển thị với tư cách là người tham gia các thử thách, cộng đồng và sự kiện mà bạn tham gia, trong bảng xếp hạng và trong kết quả tìm kiếm. Bạn có thể điều chỉnh điều này sau.",
        "moreTextAnswer3": "Chúng tôi không chia sẻ hoặc hiển thị thông tin sức khỏe cá nhân của bạn, như chiều cao, cân nặng hoặc hoạt động bạn theo dõi.",
        "btnAgree": "Có thể cho tôi xem",
        "btnDisagree": "Đừng để các thành viên khác nhìn thấy tôi"
    },
    "privacyPolicyReadMore": "Để tìm hiểu thêm, hãy đọc Chính sách quyền riêng tư của chúng tôi",
    "tellMeMore": "Nói cho tôi biết thêm",
    "helpUsImprove": {
        "title": "Hãy giúp chúng tôi cải thiện",
        "desc1": "Chúng tôi sử dụng các công cụ ghi lại dữ liệu sử dụng ẩn danh. Việc nắm bắt xu hướng về nội dung mọi người xem và nhấp chuột giúp chúng tôi cải thiện ứng dụng.",
        "desc2": "Bạn có thể tắt tính năng này bất cứ lúc nào.",
        "moreTextQ1": "Những gì chúng tôi nhìn vào",
        "moreTextAnswer1": "Chúng tôi quan tâm đến các xu hướng và số liệu thống kê tổng thể nên chúng tôi không xem xét dữ liệu ở cấp độ cá nhân.",
        "moreTextQ2": "Chúng tôi không chia sẻ dữ liệu của bạn",
        "moreTextAnswer2": "Dữ liệu này chỉ có sẵn cho những người xây dựng ứng dụng này để giúp cải thiện nó. Chúng tôi không chia sẻ thông tin này với các công ty khác, kể cả chủ lao động của bạn.",
        "moreTextQ3": "Dữ liệu của bạn là ẩn danh",
        "moreTextAnswer3": "Công cụ của chúng tôi không ghi lại tên, vị trí chính xác hoặc bất kỳ thông tin sức khỏe cá nhân nào của bạn.",
        "btnAgree": "Theo dõi việc sử dụng của tôi một cách ẩn danh",
        "btnDisagree": "Tôi không đồng ý theo dõi"
    },
    "deleteAccountTextAppName": "Xóa vĩnh viễn tài khoản %{appName} của bạn và tất cả dữ liệu trong đó",
    "anonymousMember": "Thành viên ẩn danh",
    "activitiesToTrack": {
        "title": "Hoạt động theo dõi"
    },
    "includedInMembership": "Bao gồm trong tư cách thành viên của bạn",
    "invalidDate": "Ngày không hợp lệ",
    "discardsStreamPost": {
        "discardTitle": "Hủy bài đăng?",
        "discardChangesTitle": "Hủy thay đổi?",
        "discardPostText": "Bạn có chắc chắn muốn hủy bài đăng của mình không?",
        "discardPostChangesText": "Bạn có chắc chắn muốn hủy các thay đổi của mình không?"
    },
    "trackActivityModalTitle": "Theo dõi %{date}",
    "noPosts": "Không có bài viết để xem",
    "goalIcon": "Biểu tượng mục tiêu",
    "resetsOn": "Đặt lại vào %{date}",
    "clickForHelp": "Bấm vào đây để được trợ giúp",
    "trackActivityInputLabel": "Nhập %{unit} %{activityName} %{dateFormat}",
    "itemsFound": "Các mục được tìm thấy",
    "tagState": {
        "active": "Tích cực",
        "notActive": "Không hoạt động"
    },
    "bonusCheckmarkLabel": "Đã nhận được %{bonusLabel} điểm thưởng khi hoàn thành",
    "searchBar": {
        "searching": "đang tìm kiếm %{term}",
        "result": "kết quả tìm kiếm"
    },
    "activityProgress": "Tiến trình hoạt động - %{levelName} %{percentFilled}% - Đặt lại sau %{daysLeft} ngày",
    "bookmark": {
        "remove": "Xóa khỏi các mục đã lưu",
        "save": "Lưu mục này"
    },
    "bonusMark": {
        "earn": "Kiếm được %{qty} %{points}",
        "earned": "Bạn đã kiếm được %{qty} %{points}"
    },
    "tabToTrackActivity": "Nhấn để theo dõi hoạt động",
    "videoElementLabel": "%{title}, thời lượng %{duration}, Nhấn đúp để phát video",
    "updatedPoliciesPopup": {
        "title": "Chúng tôi đã cập nhật các điều khoản của mình",
        "details": "Chúng tôi khuyến khích bạn đọc các chính sách cập nhật của chúng tôi bên dưới:",
        "disclaimer": "点击下面的按钮，即表示您同意并承认更新后的政策。",
        "agree": "tôi đồng ý"
    },
    "editActivityLog": {
        "canNotEditItem": "Bạn không thể chỉnh sửa mục này",
        "canNotEditItemDescription": "Chỉnh sửa không khả dụng cho các hoạt động được đồng bộ hóa từ thiết bị hoặc ứng dụng.",
        "updatedItem": "Đã cập nhật hoạt động",
        "updatedItemDescription": "Những thay đổi của bạn đã được lưu."
    },
    "login_with_email": "Đăng nhập bằng email",
    "healthconnect_not_available": "Không thể kết nối với Health Connect. Trong ứng dụng Health Connect, vui lòng đảm bảo quyền được bật.",
    "registrationField": {
        "required": {
            "firstName": "Vui lòng nhập tên của bạn",
            "lastName": "Vui lòng nhập họ của bạn",
            "email": "Vui lòng nhập địa chỉ email hợp lệ",
            "password": "Vui lòng nhập mật khẩu hợp lệ"
        }
    },
    "settingsErrorMessage": {
        "firstName": "Vui lòng nhập tên của bạn",
        "lastName": "Vui lòng nhập họ của bạn"
    },
    "requiredValidValue": "Vui lòng nhập giá trị hợp lệ cho %{value} của bạn",
    "passwordHidden": "Mật khẩu bị ẩn, nhấn để hiển thị mật khẩu",
    "passwordShown": "Mật khẩu được hiển thị, nhấn để ẩn mật khẩu",
    "libraryHeaderContent": {
        "category": "",
        "points": "Kiếm được %{points} điểm."
    },
    "scoreCurrentPeriod": "%{text} là từ %{startDate} đến %{endDate}",
    "scoreCurrent": "%{text} là %{points} điểm",
    "abbotResetPasswordModal": {
        "title": "Bạn đang cố truy cập vào tài khoản từ năm ngoái?",
        "text": " Nếu bạn đã đăng ký thử thách năm ngoái, tài khoản đó sẽ không hoạt động nữa. Bạn cần phải đăng ký trong năm nay.",
        "goToResetPasswordBtn": "Tôi đã đăng ký vào %{currentYear}",
        "goToSignupBtn": "Tôi chưa đăng ký vào %{currentYear}"
    },
    "challengeRegistrationClosed": "Đã đóng đăng ký - Thử thách đã bắt đầu"
};